<template>
  <v-container>
    <v-card>
      <v-list-item three-line>
        <v-list-item-content>
          <v-list-item-title class="headline mb-1"><span>แก้ไขข้อมูลจัดโครงการ</span></v-list-item-title>
          <v-list-item>
            <v-row
                justify="center">
              <v-col
                  cols="12"
                  md="8">
                <v-autocomplete
                    :items="ProjectData_U"
                    item-text="Project_name"
                    item-value="Project_code"
                    v-model="Project_Choose"
                    label="เลือกโครงการ"
                    :rules="[rules.required]"
                    required
                    @change="Choose_Project"
                >
                  <template v-slot:item="{item}">
                    {{item.Project_name}}
                    <v-chip
                        color="#B0BEC5"
                        style="transform: scale(0.8);color: white"
                        v-if="item.Status == '0'"
                    >
                      <span style="color: white">รอเสนอโครงการ</span>
                    </v-chip>
                    <v-chip
                        color="#6D4C41"
                        style="transform: scale(0.8);color: white"
                        v-else-if="item.Status == '1'"
                    >
                      <span style="color: white">รอพิจารณา</span>
                    </v-chip>
                    <v-chip
                        color="#00BFA5"
                        style="transform: scale(0.8);color: white"
                        v-else-if="item.Status == '2'"
                    >
                      <span v-if="item.Approve == '0'">อนุมัติ</span>
                      <span v-else>อนุมัติ(หน่วยงาน)</span>
                    </v-chip>
                    <v-chip
                        color="#F50057"
                        style="transform: scale(0.8);color: white"
                        v-else-if="item.Status == '3'"
                    >
                      ไม่อนุมัติ
                    </v-chip>
                    <v-chip
                        color="#C0CA33"
                        style="transform: scale(0.8);color: white"
                        v-else-if="item.Status == '4'"
                    >
                      แก้ไข
                    </v-chip>
                    <v-chip
                        color="#4CAF50"
                        style="transform: scale(0.8)"
                        v-else-if="item.Status == '5'"
                    >
                      <span style="color: white;font-weight: bold">อนุมัติ(สมบูรณ์)</span>
                    </v-chip>
                    <v-chip
                        color="#00B8D4"
                        style="transform: scale(0.8)"
                        v-else-if="item.Status == '5'"
                    >
                      <span style="color: white;font-weight: bold">เสนอพิจารณา</span>
                    </v-chip>
                    <v-chip
                        color="#76FF03"
                        style="transform: scale(0.8)"
                        v-else-if="item.Status == '6'"
                    >
                      <span style="color: white;font-weight: bold">อนุมัติ(ขั้นต้น)</span>
                    </v-chip>
                    <v-chip
                        color="#00C853"
                        style="transform: scale(0.8)"
                        v-else-if="item.Status == '7'"
                    >
                      <span style="color: white;font-weight: bold">อนุมัติ(คณะ)</span>
                    </v-chip>
                    <v-chip
                        color="primary"
                        style="transform: scale(0.8);color: white"
                        v-else
                    >
                      ยกเลิกโครงการ
                    </v-chip>
                  </template>
                </v-autocomplete>
              </v-col
              >
            </v-row>
          </v-list-item>
          <v-card>
            <template>
              <div>
                <v-stepper
                    v-model="e1"
                    vertical
                    :alt-labels="altLabels"
                >
                  <template>
                    <v-stepper-step v-show="CheckStep1" :complete="e1 > 1" editable
                                    step="1">
                      ข้อมูลโครงการ
                    </v-stepper-step>
                    <v-stepper-step v-show="!CheckStep1" :rules="[() => false]" editable
                                    step="1">
                      ข้อมูลโครงการ
                      <small>กรอกข้อมูลไม่ครบถ้วน</small>
                    </v-stepper-step>
                    <v-stepper-content step="1">
                      <v-list>
                        <v-list-item three-line>
                          <v-list-item-content>
                            <v-list-item-title class="headline mb-1">
                              <span>ข้อมูลโครงการ</span>
                            </v-list-item-title>
                            <v-list-item>
                              <v-row justify="space-around">
                                <p>วันที่เริ่มต้นโครงการ</p>
                                <p>วันที่สิ้นสุดโครงการ</p>
                              </v-row>
                            </v-list-item>
                            <v-list-item>
                              <v-row justify="space-around">

                                <v-date-picker
                                    v-model="DateStart"
                                    :landscape="landscape"
                                    :reactive="reactive"
                                    :full-width="fullWidth"
                                    :show-current="showCurrent"
                                    :type="month ? 'month' : 'date'"
                                    :multiple="multiple"
                                    :readonly="readonly"
                                    :disabled="disabled"
                                    locale="th"
                                    :events="enableEvents ? functionEvents : null"
                                    :color="DateStart == '' ? 'red' : 'primary'"
                                    style="border: 1px solid black;border-radius: 5px"
                                ></v-date-picker>

                                <v-date-picker
                                    v-model="DateEnd"
                                    :landscape="landscape"
                                    :reactive="reactive"
                                    :full-width="fullWidth"
                                    :show-current="showCurrent"
                                    :type="month ? 'month' : 'date'"
                                    :multiple="multiple"
                                    :readonly="readonly"
                                    :disabled="disabled"
                                    locale="th"
                                    :events="enableEvents ? functionEvents : null"
                                    :color="DateEnd == '' ? 'red' : 'primary'"
                                    style="border: 1px solid black;border-radius: 5px"
                                ></v-date-picker>
                              </v-row>
                            </v-list-item>
                            <v-list-item style="margin-top: 20px">
                              <v-row class="d-flex justify-center">
                                <v-col
                                    cols="12"
                                    md="6"
                                >
                                  <v-autocomplete
                                      v-model="DepSelect"
                                      label="หน่วยงาน"
                                      :items="depart"
                                      item-text="dep_name"
                                      item-value="dep_id"
                                      :error-messages="DepSelect == null ? 'หน่วยงาน (ห้ามว่าง)' : ''"
                                      persistent-hint
                                      :error="DepSelect == null"
                                      clearable
                                  >
                                  </v-autocomplete>
                                </v-col>
                                <v-col
                                    cols="12"
                                    md="4"
                                >
                                  <v-autocomplete
                                      v-model="FiscalYear"
                                      label="โครการของปี"
                                      :items="FiscalYearData"
                                      item-text="yearth"
                                      item-value="year"
                                      :error-messages="FiscalYear == '' ? 'โครการของปี (ห้ามว่าง)' : ''"
                                      persistent-hint
                                      :error="FiscalYear == ''"
                                  ></v-autocomplete>
                                </v-col>
                                <v-col
                                    cols="12"
                                    md="2"
                                >
                                  <v-text-field label="ITEM CODE" readonly v-model="itemCode"></v-text-field>
                                </v-col>
                              </v-row>
                            </v-list-item>
                            <v-list-item>
                              <v-row>
                                <v-col
                                    cols="12"
                                    md="4"
                                >
                                  <div class="d-inline">
                                    <v-text-field v-model="Project_code"
                                                  label="รหัสโครงการ"
                                                  readonly
                                                  required
                                                  hide-details="auto"
                                    ></v-text-field>
                                  </div>
                                </v-col>
                                <v-col
                                    cols="12"
                                    md="5"
                                >
                                  <div class="d-inline">
                                    <v-text-field v-model="Project_name"
                                                  label="ชื่อโครงการ"
                                                  :rules="[rules.required]"
                                                  required
                                                  hide-details="auto"
                                                  persistent-hint
                                                  :error-messages="Project_name == '' ? 'ชื่อโครงการ (ห้ามว่าง)' : ''"
                                                  :error="Project_name == ''"
                                    ></v-text-field>
                                  </div>
                                </v-col>
                                <v-col
                                    cols="12"
                                    md="3"
                                >
                                  <div class="d-inline">
                                    <v-select
                                        :error="Project_group == ''"
                                        v-model="Project_group"
                                        :items="projectGroup"
                                        item-value="Project_group"
                                        item-text="Project_group_des"
                                        label="ประเภทโครงการ"
                                        :error-messages="Project_group == '' ? 'ประเภทโครงการ (ห้ามว่าง)' : ''"
                                        persistent-hint
                                        :rules="[rules.required]"
                                        required
                                        @change="SelProjectGroup"
                                    ></v-select>
                                  </div>
                                </v-col>
                              </v-row>
                            </v-list-item>
                            <v-list-item>
                              <v-row>
                                <v-col
                                    cols="12"
                                    md="4"
                                >
                                  <div class="d-inline">
                                    <v-select
                                        :items="courseData"
                                        item-text="Course_name"
                                        item-value="Course_code"
                                        v-model="Course_code"
                                        label="หลักสูตร"
                                        :error-messages="((Project_group == '101' || Project_group == '102' || Project_group == '103' || Project_group == '104') && Course_code == '0000000') ? 'หลักสูตร (ห้ามว่าง)' : ''"
                                        :error="((Project_group == '101' || Project_group == '102' || Project_group == '103' || Project_group == '104') && Course_code == '0000000')"
                                        persistent-hint
                                        clearable
                                        @change="getCourseType"
                                    ></v-select>
                                  </div>
                                </v-col>
                                <v-col
                                    cols="12"
                                    md="2"
                                >
                                  <div class="d-inline">
                                    <v-text-field
                                        v-model="course_group"
                                        label="สาขาประเภทหลักสูตร"
                                        required
                                        readonly
                                    ></v-text-field>
                                  </div>
                                </v-col>
                                <v-col
                                    cols="12"
                                    md="2"
                                >
                                  <div class="d-inline">
                                    <v-autocomplete
                                        readonly
                                        :items="period"
                                        item-text="name"
                                        item-value="id"
                                        v-model="Period_code"
                                        label="ระยะเวลา"
                                    ></v-autocomplete>
                                  </div>
                                </v-col>
                                <v-col
                                    cols="12"
                                    md="4"
                                >
                                  <div class="d-flex flex-column justify-center align-center">
                                    <v-checkbox
                                        v-model="roundNeed"
                                        required
                                        @change="CheckJoinPerson"
                                    >
                                      <template v-slot:label>
                                        <span style="font-weight: bold;color: black">มีการกำหนดรุ่นโครงการ</span>
                                      </template>
                                    </v-checkbox>
                                  </div>
                                </v-col>
                              </v-row>
                            </v-list-item>
                            <!--                              <v-list-item class="d-flex flex-row justify-center align-center"
                                                                       v-if="projectNeed">
                                                            <v-list-item>
                                                              <v-row>
                                                                <v-col
                                                                    cols="12"
                                                                    md="6">
                                                                  <v-row
                                                                      justify="center">
                                                                    <v-col
                                                                        class="d-flex justify-center"
                                                                        cols="12"
                                                                        md="8">
                                                                      <v-data-table
                                                                          :headers="courseHeadersCondi"
                                                                          :items="courseCondi"
                                                                          :search="search"
                                                                          item-key="Course_code"
                                                                          class="elevation-1"
                                                                      >
                                                                        <template v-slot:header.Course_code>
                                                                          <v-label
                                                                              fontSize="16px"
                                                                              fontWeight="bold">
                                                                            รหัสหลักสูตร
                                                                          </v-label>
                                                                        </template>
                                                                        <template v-slot:header.Course_name>
                                                                          <v-label
                                                                              fontSize="16px"
                                                                              fontWeight="bold">
                                                                            หลักสูตรที่ต้องผ่าน
                                                                          </v-label>
                                                                        </template>
                                                                        <template
                                                                            v-slot:item.action="{ item }">
                                                                          <v-row class="d-flex">
                                                                            <v-col
                                                                                cols="6"
                                                                                md="6">
                                                                              <v-btn
                                                                                  outlined
                                                                                  color="#BF360C"
                                                                                  @click="DeleteCourse(item)">
                                                                                ลบ
                                                                              </v-btn>
                                                                            </v-col>
                                                                          </v-row>
                                                                        </template>
                                                                      </v-data-table>
                                                                    </v-col>
                                                                  </v-row>
                                                                </v-col>
                                                                <v-col
                                                                    cols="12"
                                                                    md="6">
                                                                  <v-row>
                                                                    <v-row
                                                                        justify="center"
                                                                        class="d-flex justify-center">
                                                                      <v-col
                                                                          cols="12"
                                                                          md="12">
                                                                        <v-data-table
                                                                            :headers="dataHeadersCondi"
                                                                            :items="DataCondi"
                                                                            :search="search"
                                                                            item-key="PosWork"
                                                                            class="elevation-1"
                                                                        >
                                                                          <template v-slot:header.PosName>
                                                                            <v-label
                                                                                fontSize="16px"
                                                                                fontWeight="bold">
                                                                              เงื่อนไขตำแหน่ง, อายุงาน
                                                                            </v-label>
                                                                          </template>
                                                                          <template v-slot:header.Level>
                                                                            <v-label
                                                                                fontSize="16px"
                                                                                fontWeight="bold">
                                                                              ระดับ
                                                                            </v-label>
                                                                          </template>
                                                                          <template
                                                                              v-slot:header.workAgeStart>
                                                                            <v-label
                                                                                fontSize="16px"
                                                                                fontWeight="bold">
                                                                              อายุงานเริ่มต้น
                                                                            </v-label>
                                                                          </template>
                                                                          <template
                                                                              v-slot:header.workAgeEnd>
                                                                            <v-label
                                                                                fontSize="16px"
                                                                                fontWeight="bold">
                                                                              อายุงานสิ้นสุด
                                                                            </v-label>
                                                                          </template>
                                                                          <template
                                                                              v-slot:item.PosName="{ item }">
                                                                            <v-label>
                                                                              {{ item.PosName }}
                                                                            </v-label>
                                                                          </template>
                                                                          <template
                                                                              v-slot:item.Level="{ item }">
                                                                            <v-label>
                                                                              {{ item.Level }}
                                                                            </v-label>
                                                                          </template>
                                                                          <template
                                                                              v-slot:item.workAgeStart="{ item }">
                                                                            <v-label>
                                                                              {{ item.workAgeStart }}
                                                                              (ปี)
                                                                            </v-label>
                                                                          </template>
                                                                          <template
                                                                              v-slot:item.workAgeEnd="{ item }">
                                                                            <v-label>
                                                                              {{ item.workAgeEnd }} (ปี)
                                                                            </v-label>
                                                                          </template>
                                                                          <template
                                                                              v-slot:item.action="{ item }">
                                                                            <v-row class="d-flex">
                                                                              <v-col
                                                                                  cols="6"
                                                                                  md="6">
                                                                                <v-btn
                                                                                    outlined
                                                                                    color="#BF360C"
                                                                                    @click="DeleteDataCondi(item)">
                                                                                  ลบ
                                                                                </v-btn>
                                                                              </v-col>
                                                                            </v-row>
                                                                          </template>
                                                                        </v-data-table>
                                                                      </v-col>
                                                                    </v-row>
                                                                  </v-row>
                                                                </v-col>
                                                              </v-row>
                                                            </v-list-item>
                                                          </v-list-item>-->
                            <v-list-item>
                              <v-row>
                                <v-col
                                    cols="12"
                                    md="3"
                                >
                                  <div class="d-inline">
                                    <v-text-field type="number"
                                                  :error="CalHourse == ''"
                                                  v-model="CalHourse"
                                                  label="จำนวน ช.ม"
                                                  hide-details="auto"
                                                  :rules="[rules.required]"
                                                  required
                                                  :error-messages="CalHourse == '' ? 'จำนวน ช.ม (ห้ามว่าง)' : ''"
                                                  persistent-hint
                                    ></v-text-field>
                                  </div>
                                </v-col>
                                <v-col
                                    cols="12"
                                    md="3"
                                >
                                  <div class="d-inline">
                                    <v-text-field type="number"
                                                  v-model="CalCredit"
                                                  :error="CalCredit == ''"
                                                  label="จำนวน เครดิต"
                                                  hide-details="auto"
                                                  :error-messages="CalCredit == '' ? 'จำนวน เครดิต (ห้ามว่าง) **ไม่มีใส่0' : ''"
                                                  persistent-hint
                                                  :rules="[rules.required]"
                                                  required
                                    ></v-text-field>
                                  </div>
                                </v-col>
                                <v-col
                                    cols="12"
                                    md="3"
                                >
                                  <div class="d-inline">
                                    <v-select
                                        :items="PLACESelete"
                                        :error="PLACE == ''"
                                        item-value="id"
                                        item-text="detail"
                                        v-model="PLACE"
                                        label="โครงการถูกจัดขึ้น"
                                        :error-messages="PLACE == '' ? 'โครงการถูกจัดขึ้น (ห้ามว่าง)' : ''"
                                        persistent-hint
                                        :rules="[rules.required]"
                                        required
                                        @change="CheckPlace"
                                    >
                                    </v-select>
                                  </div>
                                </v-col>
                                <v-col
                                    cols="12"
                                    md="3"
                                >
                                  <div class="d-inline" v-if="PLACE == '2'">
                                    <v-autocomplete
                                        :error="Province_id == ''"
                                        v-model="Province_id"
                                        :items="provinces_Data"
                                        item-text="name_th"
                                        item-value="code"
                                        label="จังหวัด"
                                        :error-messages="Province_id == '' ? 'จังหวัด (ห้ามว่าง)' : ''"
                                        persistent-hint
                                        :rules="[rules.required]"
                                        required
                                    ></v-autocomplete>
                                  </div>
                                  <div class="d-inline" v-if="PLACE == '3'">
                                    <v-autocomplete
                                        :error="Country_id == ''"
                                        v-model="Country_id"
                                        :items="countryData"
                                        item-text="ct_nameTHA"
                                        item-value="ct_code"
                                        label="ประเทศ"
                                        :error-messages="Country_id == '' ? 'ประเทศ (ห้ามว่าง)' : ''"
                                        persistent-hint
                                        :rules="[rules.required]"
                                        required></v-autocomplete>
                                  </div>
                                </v-col>
                              </v-row>
                            </v-list-item>
                            <v-list-item>
                              <v-row>
                                <v-col
                                    cols="12"
                                    md="3"
                                >
                                  <div class="d-inline">
                                    <v-text-field v-model="BudgetRequest"
                                                  :error="BudgetRequest == ''"
                                                  type="number"
                                                  label="งบประมาณที่ขอ"
                                                  hide-details="auto"
                                                  :rules="[rules.required]"
                                                  required
                                                  :error-messages="BudgetRequest == '' ? 'งบประมาณที่ขอ (ห้ามว่าง) **ไม่มีใส่0' : ''"
                                                  persistent-hint
                                    ></v-text-field>
                                  </div>
                                </v-col>
                                <v-col
                                    cols="12"
                                    md="3"
                                >
                                  <div class="d-inline">
                                    <v-select
                                        :error="WorkBy == ''"
                                        v-model="WorkBy"
                                        label="จัดโดย"
                                        :items="WorkByData"
                                        item-value="id"
                                        item-text="detail"
                                        :error-messages="WorkBy == '' ? 'จัดโดย (ห้ามว่าง)' : ''"
                                        persistent-hint
                                        :rules="[rules.required]"
                                        required
                                    ></v-select>
                                  </div>
                                </v-col>
                                <v-col
                                    cols="12"
                                    md="3"
                                >
                                  <div class="d-inline">
                                    <v-text-field
                                        :error="WorkByName == ''"
                                        v-model="WorkByName"
                                        label="ชื่อผู้จัด"
                                        hide-details="auto"
                                        :error-messages="WorkByName == '' ? 'ชื่อผู้จัด (ห้ามว่าง)' : ''"
                                        persistent-hint
                                        required
                                        :rules="[rules.required]"></v-text-field>
                                  </div>
                                </v-col>
                                <v-col
                                    cols="12"
                                    md="3"
                                >
                                  <div class="d-inline">
                                    <v-text-field
                                        :error="Location == ''"
                                        v-model="Location"
                                        label="สถานที่จัดโครงการ"
                                        hide-details="auto"
                                        :error-messages="Location == '' ? 'สถานที่จัดโครงการ (ห้ามว่าง)' : ''"
                                        persistent-hint
                                        :rules="[rules.required]"
                                        required
                                    ></v-text-field>
                                  </div>
                                </v-col>
                              </v-row>
                            </v-list-item>
                            <v-list-item>
                              <v-row>
                                <v-col
                                    cols="12"
                                >
                                  <div class="d-inline">
                                    <v-textarea
                                        v-model="Remarks"
                                        outlined
                                        name=""
                                        label="รายละเอียดประกอบโครงการ"
                                        value=""
                                        persistent-hint
                                    ></v-textarea>
                                  </div>
                                </v-col>
                              </v-row>
                            </v-list-item>
                            <v-list-item>
                              <v-file-input
                                  v-model="files"
                                  color="deep-purple accent-4"
                                  counter
                                  label="แนบไฟล์เอกสารประกอบโครงการ"
                                  multiple
                                  placeholder="เลือกไฟล์"
                                  prepend-icon="mdi-paperclip"
                                  outlined
                                  :show-size="1000"
                                  @change="FileSelect"
                              >
                                <template v-slot:selection="{ index, text }">
                                  <v-chip
                                      v-if="index < 5"
                                      color="deep-purple accent-4"
                                      dark
                                      label
                                      small
                                  >
                                    {{ text }}
                                  </v-chip>

                                  <span
                                      v-else-if="index === 5"
                                      class="overline grey--text text--darken-3 mx-2"
                                  >
                                +{{ files.length - 2 }} File(s)
                              </span>
                                </template>
                              </v-file-input>
                            </v-list-item>
                            <v-list-item>
                              <v-alert
                                  v-if="alert"
                                  prominent
                                  type="error"
                              >
                                <v-row align="center" v-for="item in txtAlert" :key="item.id">
                                  <v-col class="d-flex grow">- {{ item.Detail }}</v-col>
                                </v-row>
                              </v-alert>
                            </v-list-item>
                            <v-list-item v-if="FileProject.length > 0">
                              <template>
                                <v-row>
                                  <v-col cols="12" sm="6" offset-sm="3">
                                    <v-card>
                                      <v-card-title>
                                        ไฟล์เอกสารประกอบ
                                      </v-card-title>
                                      <v-container fluid>
                                        <v-row>
                                          <v-col
                                              v-for="(file_i, index) in FileProject"
                                              :key="index"
                                              class="d-flex child-flex"
                                              cols="12"
                                              md="4"
                                          >
                                            <v-card flat tile>
                                              <v-img
                                                  v-if="file_i.type == 'image'"
                                                  :src="file_i.src"
                                                  :lazy-src="`https://picsum.photos/10/6?image=${(index+1) * 5 + 10}`"
                                                  aspect-ratio="1"
                                                  class="grey lighten-2"
                                              >
                                                <template
                                                    v-slot:placeholder>
                                                  <v-row
                                                      class="fill-height ma-0"
                                                      align="center"
                                                      justify="center"
                                                  >
                                                    <v-progress-circular
                                                        indeterminate
                                                        color="grey lighten-5"></v-progress-circular>
                                                  </v-row>
                                                </template>
                                              </v-img>
                                              <v-img
                                                  v-if="file_i.type == 'pdf'"
                                                  src="../../assets/Image/pdf.png"
                                                  :lazy-src="`https://picsum.photos/10/6?image=${(index+1) * 5 + 10}`"
                                                  aspect-ratio="1"
                                                  class="grey lighten-2"
                                              >
                                                <template
                                                    v-slot:placeholder>
                                                  <v-row
                                                      class="fill-height ma-0"
                                                      align="center"
                                                      justify="center"
                                                  >
                                                    <v-progress-circular
                                                        indeterminate
                                                        color="grey lighten-5"></v-progress-circular>
                                                  </v-row>
                                                </template>
                                              </v-img>
                                              <v-card-text>
                                                                                                <span
                                                                                                    style="font-weight: bold;color: black">
                                                                                                    {{ file_i.name }}
                                                                                                </span>
                                              </v-card-text>
                                              <v-card-actions>
                                                <v-btn text
                                                       @click="ShowData(file_i.src)">
                                                                                                    <span
                                                                                                        style="color: indigo;font-weight: bold">
                                                                                                        เรียกดู
                                                                                                    </span>
                                                </v-btn>
                                                <v-btn text
                                                       @click="DeleteFile(file_i)">
                                                                                                     <span
                                                                                                         style="color: red;font-weight: bold">
                                                                                                        ลบ
                                                                                                    </span>
                                                </v-btn>
                                              </v-card-actions>
                                            </v-card>
                                          </v-col>
                                        </v-row>
                                      </v-container>
                                    </v-card>
                                  </v-col>
                                </v-row>
                              </template>
                            </v-list-item>
                          </v-list-item-content>
                        </v-list-item>

                        <v-list-item class="d-flex justify-end">
                          <v-btn
                              color="primary"
                              @click="nextStep(1)"
                          >
                            ถัดไป
                            <v-icon right>mdi-arrow-right</v-icon>
                          </v-btn>
                        </v-list-item>
                      </v-list>

                    </v-stepper-content>
                    <v-stepper-step :complete="e1 > 2" editable step="2">
                      สมรรถนะ/ค่านิยม/วัตถุประสงค์เชิงกลยุทธ์
                    </v-stepper-step>
                    <v-stepper-content step="2">
                      <v-list>
                        <v-list-item three-line>
                          <v-list-item-content>
                            <v-list-item-title class="headline mb-1"><span>Competency</span>
                            </v-list-item-title>
                            <v-list-item>
                              <v-row class="d-flex justify-center">
                                <v-col
                                    cols="12"
                                    md="12"
                                >
                                  <v-row class="d-flex justify-center">
                                    <v-col
                                        cols="12"
                                        md="12">
                                      <v-responsive>
                                        <v-spacer></v-spacer>
                                        <v-text-field label="ค้นหา Competency" v-model="searchCompe"></v-text-field>
                                      </v-responsive>
                                      <v-responsive>
                                        <v-treeview v-model="selection" selectable :activatable="true"
                                                    :items="CompetencyData" :search="searchCompe">
                                          <template v-slot:prepend="{ item, open }">
                                            <v-icon v-if="!item.file" color="blue lighten-2">
                                              {{ open ? 'mdi-folder-open' : 'mdi-folder' }}
                                            </v-icon>
                                            <v-icon v-else>
                                              {{ files[item.file] }}
                                            </v-icon>
                                          </template>
                                          <template v-slot:label="{ item, active }">
                                            <div v-if="isMobile" style="cursor: pointer" @click="ShowDetail(item)">
                                                <span style="font-size: 12px;color: black" v-if="!active">
                                                    {{ item.name }}
                                                </span>
                                              <span style="font-size: 12px;color: #364eff;font-weight: bold"
                                                    v-else>
                                                    {{ item.name }}
                                                </span>
                                            </div>
                                            <div v-else style="cursor: pointer" @click="ShowDetail(item)">
                                                <span style="color:black;" v-if="!active">
                                                    {{ item.name }}
                                                </span>
                                              <span style="color: #364eff;font-weight: bold" v-else>
                                                    {{ item.name }}
                                                </span>
                                            </div>
                                          </template>
                                        </v-treeview>
                                      </v-responsive>
                                      <!--<v-list-item>
                                                                                <v-row class="d-flex justify-center">
                                                                                    <v-col class="d-flex justify-center" cols="8"
                                                                                           sm="2">
                                                                                        <v-btn
                                                                                                outlined
                                                                                                color="primary"
                                                                                                @click="InsertCompetency"
                                                                                        >
                                                                                            เพิ่ม Competency
                                                                                        </v-btn>
                                                                                    </v-col>
                                                                                </v-row>
                                                                            </v-list-item>
                                                                            <v-list-item class="d-flex justify-center"
                                                                                         style="margin-top: 20px">
                                                                                <v-data-table
                                                                                        :headers="competencyHeader"
                                                                                        :items="competency_DataForSubmit"
                                                                                        item-key="Competency_code"
                                                                                        class="elevation-1">
                                                                                    <template v-slot:header.Competency_des>
                                                                                        <v-label
                                                                                                fontSize="16px"
                                                                                                fontWeight="bold">
                                                                                            Competency
                                                                                        </v-label>
                                                                                    </template>
                                                                                    <template v-slot:header.UPercent>
                                                                                        <v-label
                                                                                                fontSize="16px"
                                                                                                fontWeight="bold">
                                                                                            เปอเซ็นต์
                                                                                        </v-label>
                                                                                    </template>
                                                                                    <template v-slot:item.Competency_des="{item}">
                                                                                        <span style="font-weight: bold">
                                                                                            {{item.Competency_des}}
                                                                                        </span>
                                                                                    </template>
                                                                                    <template v-slot:item.UPercent="{item}">
                                                                                        <span style="font-weight: bold">
                                                                                            {{item.UPercent}} %
                                                                                        </span>
                                                                                    </template>
                                                                                    <template v-slot:item.action="{item}">
                                                                                        <v-row class="d-flex">
                                                                                            <v-col
                                                                                                    cols="6"
                                                                                                    md="6">
                                                                                                <v-btn
                                                                                                        outlined
                                                                                                        color="#BF360C"
                                                                                                        @click="DeleteCompetency(item)">
                                                                                                    ลบ
                                                                                                </v-btn>
                                                                                            </v-col>
                                                                                        </v-row>
                                                                                    </template>
                                                                                </v-data-table>
                                                                            </v-list-item>-->
                                    </v-col>
                                  </v-row>
                                </v-col>
                              </v-row>
                            </v-list-item>
                          </v-list-item-content>
                        </v-list-item>
                        <v-list-item class="d-flex justify-end">
                          <v-btn text color="red"
                                 @click="backStep(1)">
                            <v-icon left>mdi-arrow-left</v-icon>
                            ย้อนกลับ
                          </v-btn>
                          <v-btn
                              color="primary"
                              @click="nextStep(2)"
                          >
                            ถัดไป
                            <v-icon right>mdi-arrow-right</v-icon>
                          </v-btn>
                        </v-list-item>
                      </v-list>
                    </v-stepper-content>
                    <v-stepper-step :complete="e1 > 3" editable step="3">
                      คณะทำงาน
                    </v-stepper-step>
                    <v-stepper-content step="3">
                      <v-list>
                        <v-list-item-title class="headline mb-1"><span>คณะทำงาน</span>
                        </v-list-item-title>
                        <v-list-item>
                          <v-row class="d-flex justify-center">
                            <v-col
                                cols="12"
                                md="12"
                            >
                              <v-list-item>
                                <v-label class="d-flex justify-center">
                                  <!--                                            กรรมการผู้ร่วมโครงการ-->
                                </v-label>
                              </v-list-item>
                              <v-list-item>
                                <v-row class="d-flex justify-center">
                                  <v-col class="d-flex justify-center" cols="12"
                                         sm="12">
                                    <v-radio-group v-model="radioGroup" row>
                                      <v-radio
                                          label="บุคลากรคณะแพทย์"
                                          value="0"
                                      ></v-radio>
                                      <v-radio
                                          label="บุคลากรคณะอื่น"
                                          value="1"
                                      ></v-radio>
                                      <v-radio
                                          label="บุคคลภายนอก"
                                          value="3"
                                      ></v-radio>
                                      <v-radio
                                          label="จากการแต่งตั้งคณะกรรมการ"
                                          value="4"
                                      ></v-radio>
                                    </v-radio-group>
                                  </v-col>
                                </v-row>
                              </v-list-item>
                              <v-list-item>
                                <v-row class="d-flex justify-center">
                                  <v-col class="d-flex justify-center" cols="12"
                                         md="6"
                                         v-if="radioGroup == '0'">
                                    <v-autocomplete
                                        v-if="radioGroup == '0'"
                                        v-model="perid"
                                        :items="staffData"
                                        item-text="customDetail"
                                        item-value="perid"
                                        label="รายชื่อบุคลากรในคณะ"
                                        outlined
                                        @change="UpdateName(perid)"
                                    ></v-autocomplete>
                                  </v-col>
                                  <v-col
                                      v-if="radioGroup != '4'"
                                      cols="12"
                                      md="6">
                                    <v-autocomplete
                                        v-model="Committee_code"
                                        :items="committee_Posi.filter(item => item.committee_type != '1' && item.committee_type != '4' && item.committee_type != '5')"
                                        item-text="committee_des"
                                        item-value="Committee_code"
                                        label="ตำแหน่ง"
                                        outlined
                                        required
                                    ></v-autocomplete>
                                  </v-col>
                                  <v-col
                                      v-else
                                      cols="12"
                                      md="8">
                                    <v-autocomplete
                                        v-model="AppointmentSel"
                                        :items="Appointment"
                                        item-text="Topic"
                                        item-value="id"
                                        label="คณะกรรมการ"
                                        outlined
                                        required
                                        @change="GetAppointmentGroupFn"
                                    >
                                      <template v-slot:item="{item}">
                                        <span style="font-weight: bold;color: #364eff">{{ item.Topic }}</span><span
                                          style="color: rebeccapurple;margin-left: 15px">{{ item.dep_name }}</span>
                                      </template>
                                    </v-autocomplete>
                                  </v-col>
                                </v-row>
                              </v-list-item>
                              <v-list-item v-if="radioGroup != '4'">
                                <v-row class="d-flex justify-center">
                                  <v-col class="d-flex justify-center" cols="12"
                                         sm="5">
                                    <v-text-field v-if="radioGroup != '0'"
                                                  v-model="full_name"
                                                  label="ชื่อ - สกุล"
                                                  hide-details="auto"></v-text-field>
                                    <v-text-field v-if="radioGroup == '0'"
                                                  v-model="full_name"
                                                  label="ชื่อ - สกุล"
                                                  hide-details="auto"
                                                  :readonly="true"></v-text-field>
                                  </v-col>
                                  <v-col class="d-flex justify-center" cols="12"
                                         sm="5">
                                    <v-text-field v-model="phone"
                                                  label="เบอร์โทร"
                                                  hide-details="auto"></v-text-field>
                                  </v-col>
                                  <v-col class="d-flex justify-center" cols="8"
                                         sm="2">
                                    <v-btn
                                        outlined
                                        color="primary"
                                        @click="InsertCoordinator(false)"
                                    >
                                      เพิ่ม
                                    </v-btn>
                                  </v-col>
                                </v-row>
                              </v-list-item>
                              <v-list-item class="d-flex justify-center"
                                           style="margin-top: 20px">
                                <v-data-table
                                    :headers="CoordinatorHeader"
                                    :items="Coordinator"
                                    item-key="PosWork"
                                    class="elevation-1">
                                  <template v-slot:header.Name>
                                    <v-label
                                        fontSize="16px"
                                        fontWeight="bold">
                                      ชื่อ - สกุล
                                    </v-label>
                                  </template>
                                  <template v-slot:header.position_com>
                                    <v-label
                                        fontSize="16px"
                                        fontWeight="bold">
                                      ตำแหน่ง
                                    </v-label>
                                  </template>
                                  <template v-slot:header.Committee_type>
                                    <v-label
                                        fontSize="16px"
                                        fontWeight="bold">
                                      สถานะ
                                    </v-label>
                                  </template>
                                  <template v-slot:header.TEL>
                                    <v-label
                                        fontSize="16px"
                                        fontWeight="bold">
                                      เบอร์โทร
                                    </v-label>
                                  </template>
                                  <template v-slot:header.Lecturer>
                                    <v-label
                                        fontSize="16px"
                                        fontWeight="bold">
                                      ข้อมูลวิทยากร
                                    </v-label>
                                  </template>
                                  <!--                                  <template v-slot:item.position_com="{item}">
                                                                                      <span v-if="item.Committee_code == '1'" style="color: brown">
                                                                                          ประธาน
                                                                                      </span>
                                                                      <span v-if="item.Committee_code == '2'"
                                                                            style="color: coral">
                                                                                          รองประธาน
                                                                                      </span>
                                                                      <span v-if="item.Committee_code == '3'"
                                                                            style="color: darkgoldenrod">
                                                                                          เลขา
                                                                                      </span>
                                                                      <span v-if="item.Committee_code == '4'"
                                                                            style="color: darkseagreen">
                                                                                          เหรัญญิก
                                                                                      </span>
                                                                      <span v-if="item.Committee_code == '5'"
                                                                            style="color: darkslategrey">
                                                                                          กรรมการ
                                                                                      </span>
                                                                      <span v-if="item.Committee_code == '6'"
                                                                            style="color: hotpink">
                                                                                          วิทยากร
                                                                                      </span><span v-if="item.Committee_code == '7'" style="color: khaki">
                                                                                          ที่ปรึกษา
                                                                                      </span><span v-if="item.Committee_code == '8'" style="color: grey">
                                                                                          ผู้ทรงคุณวุฒิ
                                                                                      </span>
                                                                      <span v-if="item.Committee_code == '9'"
                                                                            style="color: lightskyblue">
                                                                                          ผู้ประสานงาน
                                                                                      </span>
                                                                    </template>-->
                                  <template v-slot:item.Committee_type="{item}">
                                                    <span v-if="item.Committee_type == '0'" style="color: darkblue">
                                                        บุคลากรคณะแพทย์
                                                    </span>
                                    <span v-if="item.Committee_type == '1'"
                                          style="color: darkblue">
                                                        บุคลากรคณะอื่น
                                                    </span><span v-if="item.Committee_type == '3'"
                                                                 style="color: darkblue">
                                                        บุคคลภายนอก
                                                    </span>

                                  </template>
                                  <template v-slot:item.Lecturer="{item}">
                                    <v-btn text v-if="(item.Committee_code == '6' || item.Committee_code == '23' || item.Committee_code == '24') && item.Committee_type == '0'"
                                           color="primary" @click="ShowDetailLecturer(item)">
                                      รายละเอียด
                                    </v-btn>
                                  </template>
                                  <template v-slot:item.action="{item}">
                                    <v-row class="d-flex">
                                      <v-col
                                          cols="6"
                                          md="6">
                                        <v-btn
                                            outlined
                                            color="#BF360C"
                                            @click="DeleteCoordinator(item)">
                                          ลบ
                                        </v-btn>
                                      </v-col>
                                    </v-row>
                                  </template>
                                </v-data-table>
                              </v-list-item>
                              <v-list-item>
                                <v-alert
                                    v-if="alert2"
                                    prominent
                                    type="error"
                                    style="width: 100%"
                                >
                                  <v-row align="center" v-for="item in txtAlert2" :key="item.id">
                                    <v-col class="d-flex grow">- {{ item.Detail }}</v-col>
                                  </v-row>
                                </v-alert>
                              </v-list-item>
                            </v-col>
                          </v-row>
                        </v-list-item>
                        <v-list-item class="d-flex justify-end">
                          <v-btn text color="red"
                                 @click="backStep(2)">
                            <v-icon left>mdi-arrow-left</v-icon>
                            ย้อนกลับ
                          </v-btn>
                          <v-btn
                              color="primary"
                              @click="nextStep(3)"
                          >
                            ถัดไป
                            <v-icon right>mdi-arrow-right</v-icon>
                          </v-btn>
                        </v-list-item>
                      </v-list>
                    </v-stepper-content>
                    <v-stepper-step :complete="e1 > 4" editable step="4">
                      ค่าใช้จ่ายโครงการ
                    </v-stepper-step>
                    <v-stepper-content step="4">
                      <v-list>
                        <v-list-item-title class="headline mb-1"><span>ค่าใช้จ่ายโครงการ</span>
                        </v-list-item-title>
                        <v-list-item class="text-center">
                          <v-row class="justify-center">
                            <v-col
                                cols="12"
                                md="5">
                              <v-autocomplete
                                  v-model="expenseCost"
                                  :items="expense_Data"
                                  item-text="cost_desc"
                                  item-value="cost_id"
                                  label="รายการค่าใช้จ่าย"
                                  :rules="[rules.required]"
                                  required
                                  clearable
                                  outlined
                              ></v-autocomplete>
                            </v-col>
                            <v-col
                                cols="12"
                                md="2">
                              <v-text-field
                                  v-model="ReqMoney"
                                  type="number"
                                  outlined
                                  label="จำนวนเงิน"
                              ></v-text-field>
                            </v-col>
                            <v-col
                                cols="12"
                                md="4">
                              <v-text-field
                                  v-model="Rm"
                                  outlined
                                  label="หมายเหตุ"
                              ></v-text-field>
                            </v-col>
                            <v-col
                                cols="12"
                                md="1">
                              <v-btn outlined color="primary" class="mt-2 d-flex" style="padding: 22px"
                                     @click="AddExpenseData">เพิ่ม
                              </v-btn>
                            </v-col>
                          </v-row>
                        </v-list-item>
                        <v-list-item>
                          <div class="d-flex flex-column justify-stretch" style="width: 100%">
                            <v-data-table
                                :headers="budgetHeader"
                                :items="budgetData"

                            >
                              <template v-slot:item.ReqMoney="props">
                                {{ props.item.ReqMoney | currency }}
<!--                                <v-edit-dialog-->
<!--                                    :return-value.sync="props.item.ReqMoney"-->
<!--                                    @save="save"-->
<!--                                    @cancel="cancel"-->
<!--                                    @open="open"-->
<!--                                    @close="close"-->
<!--                                >-->
<!--                                  {{ props.item.ReqMoney | currency }}-->
<!--                                  <template v-slot:input>-->
<!--                                    <v-text-field-->
<!--                                        v-model="props.item.ReqMoney"-->
<!--                                        label="จำนวนเงิน"-->
<!--                                        single-line-->
<!--                                        counter-->
<!--                                    ></v-text-field>-->
<!--                                  </template>-->
<!--                                </v-edit-dialog>-->
                              </template>
                              <template v-slot:item.Rm="props">
                                {{ props.item.Rm }}
<!--                                <v-edit-dialog-->
<!--                                    :return-value.sync="props.item.Rm"-->
<!--                                    @save="save"-->
<!--                                    @cancel="cancel"-->
<!--                                    @open="open"-->
<!--                                    @close="close"-->
<!--                                >-->
<!--                                  <div>{{ props.item.Rm }}</div>-->
<!--                                  <template v-slot:input>-->
<!--                                    <v-text-field-->
<!--                                        v-model="props.item.Rm"-->
<!--                                        label="หมายเหตุ"-->
<!--                                        single-line-->
<!--                                        counter-->
<!--                                        autofocus-->
<!--                                    ></v-text-field>-->
<!--                                  </template>-->
<!--                                </v-edit-dialog>-->
                              </template>
                              <template v-slot:item.action="{item}">
                                <div class="d-flex justify-center">
                                  <v-btn color="red" outlined @click="DelExpense(item)">
                                    ลบ
                                  </v-btn>
                                </div>
                              </template>
                              <template
                                  v-slot:footer
                              >
                                <template v-if="BudgetRequest > 0">
                                  <div align="center" style="margin-top: 15px">
                                    <span style="font-weight: bold;color: #364eff">งบประมาณที่ขอ : {{
                                        BudgetRequest | currency
                                      }}</span>
                                  </div>
                                  <div align="center">
                                    <span style="font-weight: bold;color: #ff6d81">ค่าใช้จ่าย : {{ Expense | currency }}</span>
                                  </div>
                                  <div align="center">
                              <span
                                  style="font-weight: bold;color: #42b983">คงเหลือ : {{
                                  BudgetRequest - Expense | currency
                                }}</span>
                                  </div>
                                </template>
                              </template>
                            </v-data-table>
                          </div>
                        </v-list-item>
                        <v-list-item class="d-flex justify-end">
                          <v-btn text color="red"
                                 @click="backStep(3)">
                            <v-icon left>mdi-arrow-left</v-icon>
                            ย้อนกลับ
                          </v-btn>
                          <v-btn
                              color="primary"
                              @click="nextStep(4)"
                          >
                            ถัดไป
                            <v-icon right>mdi-arrow-right</v-icon>
                          </v-btn>
                        </v-list-item>
                      </v-list>
                    </v-stepper-content>
                    <v-stepper-step :complete="e1 > 5" step="5" editable v-if="!roundNeed">
                      กลุ่มเป้าหมาย/เงื่อนไขการเข้าร่วมโครงการ
                    </v-stepper-step>
                    <v-stepper-content step="5" v-if="!roundNeed">
                      <v-list>
                        <v-list-item-title class="headline mb-1">
                          กลุ่มเป้าหมาย
                        </v-list-item-title>
                        <v-list-item>
                          <v-row>
                            <v-col
                                cols="12"
                                md="6"
                            >
                              <v-autocomplete outlined
                                              v-model="posiCondi"
                                              :items="positions"
                                              item-text="PosName"
                                              item-value="PosCode"
                                              label="ตำแหน่ง"
                              ></v-autocomplete>
                            </v-col>
                            <v-col
                                cols="6"
                                md="3"
                            >
                              <v-text-field
                                  outlined
                                  type="number"
                                  v-model="workAgeStart_Condi"
                                  label="อายุงานเริ่มต้น"
                                  required
                              ></v-text-field>
                            </v-col>
                            <v-col
                                cols="6"
                                md="3"
                            >
                              <v-text-field
                                  outlined
                                  type="number"
                                  v-model="workAgeEnd_Condi"
                                  label="อายุงานสิ้นสุด"
                                  required
                              ></v-text-field>
                            </v-col>
                          </v-row>
                        </v-list-item>
                        <v-list-item class="d-flex justify-center">
                          <v-btn
                              outlined
                              color="primary"
                              @click="DataCondiFunc"
                          >
                            เพิ่ม
                          </v-btn>
                        </v-list-item>
                        <v-list-item class="d-flex justify-center">
                          <v-data-table
                              :headers="dataHeadersCondi"
                              :items="DataCondi"
                              :search="search"
                              item-key="PosWork"
                              class="elevation-1 mt-4"
                          >
                            <template v-slot:header.PosName>
                              <v-label
                                  fontSize="16px"
                                  fontWeight="bold">
                                เงื่อนไขตำแหน่ง, อายุงาน
                              </v-label>
                            </template>
                            <template v-slot:header.Level>
                              <v-label
                                  fontSize="16px"
                                  fontWeight="bold">
                                ระดับ
                              </v-label>
                            </template>
                            <template v-slot:header.workAgeStart>
                              <v-label
                                  fontSize="16px"
                                  fontWeight="bold">
                                อายุงานเริ่มต้น
                              </v-label>
                            </template>
                            <template v-slot:header.workAgeEnd>
                              <v-label
                                  fontSize="16px"
                                  fontWeight="bold">
                                อายุงานสิ้นสุด
                              </v-label>
                            </template>
                            <template v-slot:item.PosName="{ item }">
                              <v-label>
                                {{ item.PosName }}
                              </v-label>
                            </template>
                            <template v-slot:item.Level="{ item }">
                              <v-label>
                                {{ item.Level }}
                              </v-label>
                            </template>
                            <template
                                v-slot:item.workAgeStart="{ item }">
                              <v-label>
                                {{ item.workAgeStart }} (ปี)
                              </v-label>
                            </template>
                            <template v-slot:item.workAgeEnd="{ item }">
                              <v-label>
                                {{ item.workAgeEnd }} (ปี)
                              </v-label>
                            </template>
                            <template v-slot:item.action="{ item }">
                              <v-row class="d-flex">
                                <v-col
                                    cols="6"
                                    md="6">
                                  <v-btn
                                      outlined
                                      color="#BF360C"
                                      @click="DeleteDataCondi(item)">
                                    ลบ
                                  </v-btn>
                                </v-col>
                              </v-row>
                            </template>
                          </v-data-table>
                        </v-list-item>
                        <v-divider class="mt-6"></v-divider>
                        <v-list-item-title class="headline mt-6">
                          เงื่อนไขการเข้าร่วมโครงการ
                        </v-list-item-title>
                        <v-list-item>
                          <v-list-item-subtitle>
                            สมัครเข้าร่วมโครงการ
                          </v-list-item-subtitle>
                        </v-list-item>
                        <v-list-item class="d-flex justify-center">
                          <v-radio-group row v-model="ChooseTypRegis">
                            <v-radio label="อนุญาตสมัครเข้าร่วมโครงการ" value="0"></v-radio>
                            <v-radio label="ไม่อนุญาตสมัครเข้าร่วมโครงการ" value="1"></v-radio>
                          </v-radio-group>
                        </v-list-item>
                        <v-list-item class="d-flex justify-center" v-if="ChooseTypRegis == '0'">
                          <v-radio-group row v-model="ChooseTypRegis2">
                            <v-radio label="หน่วยงานและบุคลากรทั่วไป" value="0" color="green"></v-radio>
                            <v-radio label="หน่วยงาน" value="1" color="indigo"></v-radio>
                            <v-radio label="บุคลากรทั่วไป" value="2" color="yellow"></v-radio>
                          </v-radio-group>
                        </v-list-item>
                        <v-list-item class="d-flex justify-center">
                          <v-row class="d-flex justify-center">
                            <v-col
                                md="4"
                                cols="12">
                              <v-text-field label="วันที่เปิดรับสมัคร" type="date" v-model="dateRegStart"
                                            v-if="ChooseTypRegis == '0'"></v-text-field>
                            </v-col>
                            <v-col
                                md="4"
                                cols="12">
                              <v-text-field label="วันที่ปิดรับสมัคร" type="date" v-model="dateRegEnd"
                                            v-if="ChooseTypRegis == '0'"></v-text-field>
                            </v-col>
                          </v-row>
                        </v-list-item>
                        <v-divider></v-divider>
                        <v-list-item>
                          <v-list-item-subtitle>
                            ผู้เข้าร่วมโครงการ
                          </v-list-item-subtitle>
                        </v-list-item>
                        <v-list-item>
                          <v-row class="d-flex justify-center">
                            <v-col
                                md="4"
                                cols="12">
                              <v-text-field :disabled="ChkJoinPerson"
                                            outlined
                                            label="จำนวนผู้เข้าร่วมโครงการ / คน"
                                            type="number"
                                            v-model="ProjectQuotaCount"
                                            :error="!ChkJoinPerson && (ProjectQuotaCount == '' || parseInt(ProjectQuotaCount) == 0)"
                                            :error-messages="!ChkJoinPerson && (ProjectQuotaCount == '' || parseInt(ProjectQuotaCount) == 0) ? 'จำนวนผู้เข้าร่วมโครงการ / คน (ห้ามว่าง) หรือมีค่ามากกว่า 0' : ''"
                              ></v-text-field>
                            </v-col>
                            <v-col
                                md="4"
                                cols="12">
                              <v-checkbox label="ไม่จำกัดผู้เข้าร่วม" color="primary"
                                          v-model="ChkJoinPerson"></v-checkbox>
                            </v-col>
                          </v-row>
                        </v-list-item>
                        <v-divider></v-divider>
                        <v-list-item>
                          <v-list-item-subtitle>
                            โควตาหน่วยงานที่เข้าร่วม
                          </v-list-item-subtitle>
                        </v-list-item>
                        <v-list-item class="d-flex justify-center">
                          <v-radio-group row v-model="ChooseTypeDep">
                            <v-radio label="หน่วยงาน/ภาควิชา" value="0"></v-radio>
                            <v-radio label="กลุ่มหน่วยงาน/กลุ่มภาควิชา" value="1"></v-radio>
                            <v-radio label="กลุ่มเทมเพลต (ที่สร้างขึ้น)" value="3"></v-radio>
                          </v-radio-group>
                        </v-list-item>
                        <v-list-item>
                          <v-row class="d-flex justify-center">
                            <v-col
                                cols="12"
                                md="6"
                            >
                              <v-autocomplete
                                  v-model="DepQuotaSelect"
                                  label="หน่วยงาน/ภาควิชา"
                                  :items="depart"
                                  item-text="dep_name"
                                  item-value="dep_id"
                                  persistent-hint
                                  outlined
                                  v-if="ChooseTypeDep == '0'"
                                  clearable
                              >
                              </v-autocomplete>
                              <v-autocomplete
                                  v-model="DepQuotaSelect"
                                  label="กลุ่มหน่วยงาน/กลุ่มภาควิชา"
                                  :items="groupDepart"
                                  item-text="dep_name"
                                  item-value="dep_group_id"
                                  persistent-hint
                                  outlined
                                  v-else-if="ChooseTypeDep == '1'"
                                  clearable
                              >
                              </v-autocomplete>
                              <v-autocomplete
                                  v-model="DepQuotaSelect"
                                  label="กลุ่มเทมเพลต"
                                  :items="GroupQuotaMS"
                                  item-text="group_name"
                                  item-value="id"
                                  persistent-hint
                                  outlined
                                  v-else
                                  clearable
                              >
                              </v-autocomplete>
                            </v-col>
                            <v-col
                                cols="6"
                                md="2"
                            >
                              <v-text-field
                                  outlined
                                  type="number"
                                  v-model="DepQuotaCount"
                                  label="จำนวน / คน"
                                  required
                                  v-if="ChooseTypeDep != '3'"
                              ></v-text-field>
                              <v-btn
                                  @click="ShowGroupDepDetail"
                                  outlined
                                  color="primary"
                                  v-else
                              >
                                รายละเอียด
                              </v-btn>
                            </v-col>
                          </v-row>
                        </v-list-item>
                        <v-list-item class="d-flex justify-center">
                          <v-btn
                              outlined
                              color="primary"
                              @click="AddDepQuotaData"
                          >
                            เพิ่ม
                          </v-btn>
                        </v-list-item>
                        <v-list-item class="d-flex justify-center">
                          <v-data-table
                              :headers="DepQuotaHeader"
                              :items="DepQuotaData"
                              :search="searchDepQuota"
                              class="elevation-1 mt-4"
                          >
                            <template v-slot:header.type>
                              <v-label
                                  fontSize="16px"
                                  fontWeight="bold">
                                ประเภท
                              </v-label>
                            </template>
                            <template v-slot:header.dep_name>
                              <v-label
                                  fontSize="16px"
                                  fontWeight="bold">
                                ภาควิชา/หน่วยงาน
                              </v-label>
                            </template>
                            <template v-slot:header.count>
                              <v-label
                                  fontSize="16px"
                                  fontWeight="bold">
                                จำนวน/คน
                              </v-label>
                            </template>
                            <template v-slot:item.action="{ item }">
                              <v-row class="d-flex">
                                <v-col
                                    cols="6"
                                    md="6">
                                  <v-btn
                                      outlined
                                      color="#BF360C"
                                      @click="DeleteDepQuotaCondi(item)">
                                    ลบ
                                  </v-btn>
                                </v-col>
                              </v-row>
                            </template>
                            <template
                                v-slot:footer
                            >
                              <template>
                                <div align="center" style="margin-top: 15px">
                            <span style="font-weight: bold;color: #364eff">จำกัดหน่วยงาน : {{
                                ProjectQuotaDepCount
                              }} คน</span>
                                </div>
                                <div align="center" v-if="!ChkJoinPerson && parseInt(ProjectQuotaCount) > 0">
                            <span style="font-weight: bold;color: #ff6d81">ทั่วไป : {{
                                parseInt(ProjectQuotaCount) - parseInt(ProjectQuotaDepCount)
                              }} คน</span>
                                </div>
                                <div align="center" v-else>
                                  <span style="font-weight: bold;color: #ff6d81">ทั่วไป : ไม่จำกัดคน</span>
                                </div>
                                <div align="center" v-if="!ChkJoinPerson && parseInt(ProjectQuotaCount) > 0">
                              <span
                                  style="font-weight: bold;color: #42b983">รวม : {{
                                  ProjectQuotaCount
                                }} คน</span>
                                </div>
                                <div align="center" v-else>
                                  <span style="font-weight: bold;color: #42b983">รวม : ไม่จำกัดคน</span>
                                </div>
                              </template>
                            </template>
                          </v-data-table>
                        </v-list-item>
                        <v-list-item class="d-flex justify-end">
                          <v-btn text color="red"
                                 @click="backStep(4)">
                            <v-icon left>mdi-arrow-left</v-icon>
                            ย้อนกลับ
                          </v-btn>
                          <v-btn
                              color="primary"
                              @click="nextStep(5)"
                          >
                            ถัดไป
                            <v-icon right>mdi-arrow-right</v-icon>
                          </v-btn>
                        </v-list-item>
                      </v-list>
                    </v-stepper-content>
                    <v-stepper-step :complete="e1 > 6" step="6" editable v-if="!roundNeed">
                      เพิ่มผู้เข้าร่วมโครงการ
                    </v-stepper-step>
                    <v-stepper-content step="6" v-if="!roundNeed">
                      <v-list>
                        <v-list-item>
                          <v-row class="d-flex justify-center">
                            <v-col
                                class="d-flex justify-center"
                                cols="12"
                                md="6">
                              <v-radio-group v-model="TypeInsert" row>
                                <v-radio label="ค้นหาโดยชื่อ / รหัสบุคลากร" value="1"></v-radio>
                                <v-radio label="ค้นหาโดยตัวเลือก"
                                         value="2"></v-radio>
                              </v-radio-group>
                            </v-col>
                          </v-row>
                        </v-list-item>
                        <v-list-item v-if="TypeInsert == '1'" style="margin-top: 25px">
                          <v-row class="d-flex justify-center">
                            <v-col
                                cols="12"
                                md="6">
                              <v-autocomplete
                                  v-model="staffSel"
                                  label="ค้นหาบุคลากร"
                                  :items="staffData"
                                  item-text="customDetail"
                                  item-value="perid"
                                  hint="กด Enter เพื่อเป็นการเพิ่มข้อมูล"
                                  persistent-hint
                                  clearable
                                  outlined
                                  @keyup="checkKeyEnter"
                              ></v-autocomplete>
                            </v-col>
                            <v-col
                                cols="12"
                                md="4"
                                class="d-flex justify-center">
                              <v-radio-group v-model="rdoRegisterProject" row disabled>
                                <v-radio label="รอลงทะเบียน" value="0"></v-radio>
                                <v-radio label="ลงทะเบียน" value="1"></v-radio>
                              </v-radio-group>
                            </v-col>
                            <v-col
                                cols="8"
                                md="2"
                                class="d-flex justify-center">
                              <v-btn
                                  outlined
                                  color="primary"
                                  @click="ChooseEmpolyee_s_owner">
                                เพิ่ม
                              </v-btn>
                            </v-col>
                          </v-row>

                        </v-list-item>
                        <v-list-item v-if="TypeInsert == '2'" style="margin-top: 25px">
                          <v-row class="d-flex justify-center">
                            <v-col
                                cols="12"
                                md="6">
                              <v-autocomplete
                                  v-model="departSel"
                                  label="เลือกหน่วยงาน"
                                  :items="depart"
                                  item-text="dep_name"
                                  item-value="dep_id"
                                  flat
                                  solo-inverted
                                  hide-details
                                  clearable
                                  clear-icon="mdi-close-circle-outline"
                                  @change="ChooseEmpolyee"
                              ></v-autocomplete>
                            </v-col>
                          </v-row>

                        </v-list-item>
                        <v-row v-if="TypeInsert == '2'">
                          <v-col
                              cols="12"
                              md="6">
                            <v-card-text>
                              <v-treeview
                                  :items="items"
                                  selected-color="indigo"
                                  expand-icon="mdi-chevron-down"
                                  off-icon="mdi-checkbox-blank-circle-outline"
                                  on-icon="mdi-checkbox-marked-circle-outline"
                                  indeterminate-icon="mdi-minus-circle-outline"
                              >
                                <template v-slot:label="{ item }">
                                  <div class="d-flex justify-space-between">
                                    <span
                                        style="font-size: 16px;font-weight: bold;color: black;width: fit-content;margin-top: 22px">{{
                                        item.name
                                      }}</span>
                                    <v-switch
                                        inset
                                        :input-value="item.switch"
                                        @change="ChooseEmp(item)"
                                    ></v-switch>
                                  </div>
                                </template>
                              </v-treeview>
                            </v-card-text>
                          </v-col>

                          <!--                                        <v-divider vertical></v-divider>-->

                          <v-col
                              cols="12"
                              md="6"
                          >
                            <v-card-text>
                              <div
                                  v-if="EmpData.length === 0"
                                  key="title"
                                  class="title font-weight-light grey--text pa-4 text-center"
                              >
                                <span style="font-weight: bold;font-size: 18px">กรุณาเลือกรายชื่อบุคลากรที่ต้องการจะเข้าร่วมโครงการ</span>
                              </div>

                              <v-scroll-x-transition
                                  group
                                  hide-on-leave
                              >
                                <v-chip
                                    v-for="(selection, i) in EmpData"
                                    :key="i"
                                    color="grey"
                                    dark
                                    small
                                    class="ma-1"
                                >
                                  <v-icon left small>mdi-account-circle</v-icon>
                                  {{ selection.name }}
                                </v-chip>
                              </v-scroll-x-transition>
                            </v-card-text>
                          </v-col>
                        </v-row>
                        <v-divider v-if="TypeInsert == '2'"></v-divider>
                        <v-card-actions v-if="TypeInsert == '2'">
                          <v-row class="d-flex justify-center">
                            <v-col
                                class="d-flex justify-center"
                                cols="12"
                                md="3">
                              <v-btn
                                  text
                                  @click="EmpData = []"
                              >
                                Reset
                              </v-btn>
                            </v-col>
                            <v-col
                                class="d-flex justify-center"
                                cols="12"
                                md="6">
                              <v-radio-group v-model="rdoRegisterProject" row disabled>
                                <v-radio label="รอลงทะเบียน" value="0"></v-radio>
                                <v-radio label="ลงทะเบียน" value="1"></v-radio>
                              </v-radio-group>
                            </v-col>
                            <v-col
                                class="d-flex justify-center"
                                cols="12"
                                md="3">
                              <v-btn
                                  class="white--text"
                                  color="green darken-1"
                                  depressed
                                  @click="SaveToTable_owner"
                              >
                                Save
                                <v-icon right>mdi-content-save</v-icon>
                              </v-btn>
                            </v-col>
                          </v-row>
                        </v-card-actions>
                        <div align="center" style="margin-top: 30px">
                          <v-alert
                              dense
                              outlined
                              type="success"
                              dismissible
                              v-if="ShowAlertSuc"
                          >
                            <div v-html="MessageSuc"></div>
                          </v-alert>
                        </div>
                        <div align="center" style="margin-top: 30px">
                          <v-alert
                              dense
                              outlined
                              type="error"
                              dismissible
                              v-if="ShowAlertErr"
                          >
                            <div v-html="MessageError"></div>
                          </v-alert>
                        </div>
                        <v-card class="mt-7">
                          <v-toolbar
                              color="primary"
                              dark
                              flat
                          >
                            <v-toolbar-title>รายชื่อผู้เข้าร่วมโครงการ {{ JoinPerson.length }} <span
                                v-if="!ChkJoinPerson"> / {{ ProjectQuotaCount }}</span> คน
                            </v-toolbar-title>
                          </v-toolbar>
                          <v-card-title>
                            <v-spacer></v-spacer>
                            <v-text-field
                                v-model="searchPerson"
                                append-icon="mdi-magnify"
                                label="Search"
                                single-line
                                hide-details
                            ></v-text-field>
                          </v-card-title>
                          <v-data-table
                              :headers="headersPerson"
                              :items="JoinPerson"
                              :search="searchPerson"
                          >
                            <template v-slot:item.type="{item}">
                                                            <span v-if="item.registerType_id == '0'"
                                                                  style="color: #ff6d81">
                                                                บุคลากรคณะแพทย์
                                                            </span>
                              <span v-if="item.registerType_id == '1'" style="color: #ff6d81">
                                                                นักศึกษาคณะแพทย์
                                                            </span>
                              <span v-if="item.registerType_id == '2'" style="color: blue">
                                                                บุคลากรคณะอื่น
                                                            </span>
                              <span v-if="item.registerType_id == '3'" style="color: blue">
                                                                นักศึกษาคณะอื่น
                                                            </span>
                              <span v-if="item.registerType_id == '4'" style="color: darkslateblue">
                                                                บุคคลภายนอก
                                                            </span>
                              <span v-if="item.registerType_id == '5'" style="color: darkslateblue">
                                                                นักศึกษาภายนอก
                                                            </span>
                            </template>
                            <template v-slot:item.status_reg="{item}">
                              <span style="font-weight: bold;color: #364eff"
                                    v-if="item.status_reg == '1'">ลงทะเบียน</span>
                              <span style="font-weight: bold;color: #ffd54f" v-else>รอลงทะเบียน</span>
                            </template>
                            <template v-slot:item.action="{item}">
                              <v-btn
                                  color="#F44336"
                                  outlined
                                  @click="Del_item(item)">
                                ลบ
                              </v-btn>
                            </template>
                          </v-data-table>
                        </v-card>
                        <v-list-item class="d-flex justify-center ma-8">
                          <download-excel
                              class="btn btn-default"
                              :data="json_data"
                              :fields="json_fields"
                              worksheet="รายชื่อผู้เข้าร่วมโครงการ"
                              :title="array_title"
                              :name="'รายชื่อผู้เข้าร่วมโครงการ ' + Project_name + '.xls'"
                          >
                            <v-btn outlined color="green" class="darken-3" @click="ExportData">
                              Export รายชื่อผู้เข้าร่วมโครงการ
                            </v-btn>
                          </download-excel>
                        </v-list-item>
                        <v-list-item class="d-flex justify-end">
                          <v-btn text color="red"
                                 @click="backStep(5)">
                            <v-icon left>mdi-arrow-left</v-icon>
                            ย้อนกลับ
                          </v-btn>
                          <v-btn
                              color="primary"
                              @click="nextStep(6)"
                          >
                            ถัดไป
                            <v-icon right>mdi-arrow-right</v-icon>
                          </v-btn>
                        </v-list-item>
                      </v-list>
                    </v-stepper-content>
                    <v-stepper-step :complete="e1 > 5" step="5" editable v-if="roundNeed">
                      บันทึกรุ่นในการจัดโครงการ
                    </v-stepper-step>
                    <v-stepper-content step="5" v-if="roundNeed">
                      <v-list>
                        <v-list-item class="d-flex justify-center">
                          <v-btn
                              color="primary"
                              dark
                              outlined
                              @click="showDialogRound"
                          >
                            บันทึกรุ่นในการจัดโครงการ
                          </v-btn>
                          <v-dialog
                              v-model="dialogRound"
                              fullscreen
                              hide-overlay
                              transition="dialog-bottom-transition"
                          >
                            <v-card>
                              <v-app-bar
                                  dark
                                  color="primary"
                                  dense fixed
                              >
                                <v-btn
                                    icon
                                    dark
                                    @click="dialogRound = false"
                                >
                                  <v-icon>mdi-close</v-icon>
                                </v-btn>
                                <v-toolbar-title>กำหนดรุ่นการจัดโครงการ</v-toolbar-title>
                                <v-spacer></v-spacer>
                                <v-toolbar-items>
                                  <v-btn
                                      dark
                                      text
                                      @click="SaveRoundData"
                                      v-if="save"
                                  >
                                    บันทึกข้อมูล
                                  </v-btn>
                                  <v-btn
                                      v-if="!save"
                                      color="yellow"
                                      text
                                      @click="updateRoundData"
                                  >
                                    แก้ไขข้อมูล
                                  </v-btn>
                                  <v-btn
                                      dark
                                      text
                                      @click="dialogRound = false"
                                  >
                                    ยกเลิก
                                  </v-btn>
                                </v-toolbar-items>
                              </v-app-bar>
                              <v-row class="d-flex justify-center mt-16">
                                <v-col
                                    cols="12"
                                    md="8">
                                  <v-tabs
                                      color="red darken-3"
                                      show-arrows
                                      v-model="tabs"
                                  >
                                    <v-tabs-slider color="teal lighten-3"></v-tabs-slider>
                                    <v-tab
                                        key="CoriTab"
                                    >
                                      รุ่น/กลุ่มเป้าหมาย/เงื่อนไขการเข้าร่วมโครงการ
                                    </v-tab>
                                    <v-tab
                                        key="JoinTab"
                                    >
                                      เพิ่มผู้เข้าร่วม
                                      <v-chip color="red" dark class="ml-3">
                                        {{ JoinPerson.length }}
                                      </v-chip>
                                    </v-tab>
                                  </v-tabs>
                                  <v-tabs-items v-model="tabs">
                                    <v-tab-item
                                        key="CoriTab"
                                    >
                                      <v-list>
                                        <v-list-item-title class="headline mb-1">
                                          กำหนดรุ่นโครงการ
                                        </v-list-item-title>
                                        <v-list-item>
                                          <v-row class="d-flex justify-center">
                                            <v-col
                                                cols="12"
                                                md="5">
                                              <v-text-field
                                                  v-model="round"
                                                  label="รุ่นที่"
                                                  counter
                                                  :rules="[rules.counter]"
                                                  maxlength="5"
                                              ></v-text-field>
                                            </v-col>
                                            <v-col
                                                cols="12"
                                                md="5">
                                              <v-text-field
                                                  v-model="round_name"
                                                  label="ชื่อรุ่น"
                                              ></v-text-field>
                                            </v-col>
                                          </v-row>
                                        </v-list-item>
                                        <v-list-item>
                                          <v-row class="d-flex justify-center">
                                            <v-col
                                                cols="12"
                                                md="5">
                                              <v-text-field
                                                  v-model="dateRegS"
                                                  label="วันที่เริ่มต้น"
                                                  type="date"
                                              ></v-text-field>
                                            </v-col>
                                            <v-col
                                                cols="12"
                                                md="5">
                                              <v-text-field
                                                  v-model="dateRegE"
                                                  label="วันที่สิ้นสุด"
                                                  type="date"
                                              ></v-text-field>
                                            </v-col>
                                          </v-row>
                                        </v-list-item>
                                        <v-list-item>
                                          <v-row class="d-flex justify-center">
                                            <v-col
                                                cols="12"
                                                md="5">
                                              <v-text-field
                                                  v-model="time_start"
                                                  label="เวลาเริ่มต้น"
                                                  type="time"
                                              ></v-text-field>
                                            </v-col>
                                            <v-col
                                                cols="12"
                                                md="5">
                                              <v-text-field
                                                  v-model="time_end"
                                                  label="เวลาสิ้นสุด"
                                                  type="time"
                                              ></v-text-field>
                                            </v-col>
                                          </v-row>
                                        </v-list-item>
                                        <v-divider></v-divider>
                                        <v-list-item-title class="headline mb-1 mt-8">
                                          กลุ่มเป้าหมาย
                                        </v-list-item-title>
                                        <v-list-item>
                                          <v-row>
                                            <v-col
                                                cols="12"
                                                md="6"
                                            >
                                              <v-autocomplete outlined
                                                              v-model="posiCondi"
                                                              :items="positions"
                                                              item-text="PosName"
                                                              item-value="PosCode"
                                                              label="ตำแหน่ง"
                                              ></v-autocomplete>
                                            </v-col>
                                            <v-col
                                                cols="6"
                                                md="3"
                                            >
                                              <v-text-field
                                                  outlined
                                                  type="number"
                                                  v-model="workAgeStart_Condi"
                                                  label="อายุงานเริ่มต้น"
                                                  required
                                              ></v-text-field>
                                            </v-col>
                                            <v-col
                                                cols="6"
                                                md="3"
                                            >
                                              <v-text-field
                                                  outlined
                                                  type="number"
                                                  v-model="workAgeEnd_Condi"
                                                  label="อายุงานสิ้นสุด"
                                                  required
                                              ></v-text-field>
                                            </v-col>
                                          </v-row>
                                        </v-list-item>
                                        <v-list-item class="d-flex justify-center">
                                          <v-btn
                                              outlined
                                              color="primary"
                                              @click="DataCondiFunc"
                                          >
                                            เพิ่ม
                                          </v-btn>
                                        </v-list-item>
                                        <v-list-item class="d-flex justify-center">
                                          <v-data-table
                                              :headers="dataHeadersCondi"
                                              :items="DataCondi"
                                              :search="search"
                                              item-key="PosWork"
                                              class="elevation-1 mt-4"
                                          >
                                            <template v-slot:header.PosName>
                                              <v-label
                                                  fontSize="16px"
                                                  fontWeight="bold">
                                                เงื่อนไขตำแหน่ง, อายุงาน
                                              </v-label>
                                            </template>
                                            <template v-slot:header.Level>
                                              <v-label
                                                  fontSize="16px"
                                                  fontWeight="bold">
                                                ระดับ
                                              </v-label>
                                            </template>
                                            <template v-slot:header.workAgeStart>
                                              <v-label
                                                  fontSize="16px"
                                                  fontWeight="bold">
                                                อายุงานเริ่มต้น
                                              </v-label>
                                            </template>
                                            <template v-slot:header.workAgeEnd>
                                              <v-label
                                                  fontSize="16px"
                                                  fontWeight="bold">
                                                อายุงานสิ้นสุด
                                              </v-label>
                                            </template>
                                            <template v-slot:item.PosName="{ item }">
                                              <v-label>
                                                {{ item.PosName }}
                                              </v-label>
                                            </template>
                                            <template v-slot:item.Level="{ item }">
                                              <v-label>
                                                {{ item.Level }}
                                              </v-label>
                                            </template>
                                            <template
                                                v-slot:item.workAgeStart="{ item }">
                                              <v-label>
                                                {{ item.workAgeStart }} (ปี)
                                              </v-label>
                                            </template>
                                            <template v-slot:item.workAgeEnd="{ item }">
                                              <v-label>
                                                {{ item.workAgeEnd }} (ปี)
                                              </v-label>
                                            </template>
                                            <template v-slot:item.action="{ item }">
                                              <v-row class="d-flex">
                                                <v-col
                                                    cols="6"
                                                    md="6">
                                                  <v-btn
                                                      outlined
                                                      color="#BF360C"
                                                      @click="DeleteDataCondi(item)">
                                                    ลบ
                                                  </v-btn>
                                                </v-col>
                                              </v-row>
                                            </template>
                                          </v-data-table>
                                        </v-list-item>
                                        <v-divider class="mt-6"></v-divider>
                                        <v-list-item-title class="headline mt-6">
                                          เงื่อนไขการเข้าร่วมโครงการ
                                        </v-list-item-title>
                                        <v-list-item>
                                          <v-list-item-subtitle>
                                            สมัครเข้าร่วมโครงการ
                                          </v-list-item-subtitle>
                                        </v-list-item>
                                        <v-list-item class="d-flex justify-center">
                                          <v-radio-group row v-model="ChooseTypRegis">
                                            <v-radio label="อนุญาตสมัครเข้าร่วมโครงการ" value="0"></v-radio>
                                            <v-radio label="ไม่อนุญาตสมัครเข้าร่วมโครงการ" value="1"></v-radio>
                                          </v-radio-group>
                                        </v-list-item>
                                        <v-list-item class="d-flex justify-center" v-if="ChooseTypRegis == '0'">
                                          <v-radio-group row v-model="ChooseTypRegis2">
                                            <v-radio label="หน่วยงานและบุคลากรทั่วไป" value="0" color="green"></v-radio>
                                            <v-radio label="หน่วยงาน" value="1" color="indigo"></v-radio>
                                            <v-radio label="บุคลากรทั่วไป" value="2" color="yellow"></v-radio>
                                          </v-radio-group>
                                        </v-list-item>
                                        <v-list-item class="d-flex justify-center">
                                          <v-row class="d-flex justify-center">
                                            <v-col
                                                md="4"
                                                cols="12">
                                              <v-text-field label="วันที่เปิดรับสมัคร" type="date"
                                                            v-model="dateRegStart"
                                                            v-if="ChooseTypRegis == '0'"></v-text-field>
                                            </v-col>
                                            <v-col
                                                md="4"
                                                cols="12">
                                              <v-text-field label="วันที่ปิดรับสมัคร" type="date" v-model="dateRegEnd"
                                                            v-if="ChooseTypRegis == '0'"></v-text-field>
                                            </v-col>
                                          </v-row>
                                        </v-list-item>
                                        <v-divider></v-divider>
                                        <v-list-item>
                                          <v-list-item-subtitle>
                                            ผู้เข้าร่วมโครงการ
                                          </v-list-item-subtitle>
                                        </v-list-item>
                                        <v-list-item>
                                          <v-row class="d-flex justify-center">
                                            <v-col
                                                md="4"
                                                cols="12">
                                              <v-text-field :disabled="ChkJoinPerson"
                                                            outlined
                                                            label="จำนวนผู้เข้าร่วมโครงการ / คน"
                                                            type="number"
                                                            v-model="ProjectQuotaCount"
                                                            :error="!ChkJoinPerson && (ProjectQuotaCount == '' || parseInt(ProjectQuotaCount) == 0)"
                                                            :error-messages="!ChkJoinPerson && (ProjectQuotaCount == '' || parseInt(ProjectQuotaCount) == 0) ? 'จำนวนผู้เข้าร่วมโครงการ / คน (ห้ามว่าง) หรือมีค่ามากกว่า 0' : ''"
                                              ></v-text-field>
                                            </v-col>
                                            <v-col
                                                md="4"
                                                cols="12">
                                              <v-checkbox label="ไม่จำกัดผู้เข้าร่วม" color="primary"
                                                          v-model="ChkJoinPerson"></v-checkbox>
                                            </v-col>
                                          </v-row>
                                        </v-list-item>
                                        <v-divider></v-divider>
                                        <v-list-item>
                                          <v-list-item-subtitle>
                                            โควตาหน่วยงานที่เข้าร่วม
                                          </v-list-item-subtitle>
                                        </v-list-item>
                                        <v-list-item class="d-flex justify-center">
                                          <v-radio-group row v-model="ChooseTypeDep">
                                            <v-radio label="หน่วยงาน/ภาควิชา" value="0"></v-radio>
                                            <v-radio label="กลุ่มหน่วยงาน/กลุ่มภาควิชา" value="1"></v-radio>
                                            <v-radio label="กลุ่มเทมเพลต (ที่สร้างขึ้น)" value="3"></v-radio>
                                          </v-radio-group>
                                        </v-list-item>
                                        <v-list-item>
                                          <v-row class="d-flex justify-center">
                                            <v-col
                                                cols="12"
                                                md="6"
                                            >
                                              <v-autocomplete
                                                  v-model="DepQuotaSelect"
                                                  label="หน่วยงาน/ภาควิชา"
                                                  :items="depart"
                                                  item-text="dep_name"
                                                  item-value="dep_id"
                                                  persistent-hint
                                                  outlined
                                                  v-if="ChooseTypeDep == '0'"
                                                  clearable
                                              >
                                              </v-autocomplete>
                                              <v-autocomplete
                                                  v-model="DepQuotaSelect"
                                                  label="กลุ่มหน่วยงาน/กลุ่มภาควิชา"
                                                  :items="groupDepart"
                                                  item-text="dep_name"
                                                  item-value="dep_group_id"
                                                  persistent-hint
                                                  outlined
                                                  v-else-if="ChooseTypeDep == '1'"
                                                  clearable
                                              >
                                              </v-autocomplete>
                                              <v-autocomplete
                                                  v-model="GroupSelect"
                                                  label="กลุ่มเทมเพลต"
                                                  :items="GroupQuotaMS"
                                                  item-text="group_name"
                                                  item-value="id"
                                                  persistent-hint
                                                  outlined
                                                  v-else
                                                  clearable
                                              >
                                              </v-autocomplete>
                                            </v-col>
                                            <v-col
                                                cols="6"
                                                md="2"
                                            >
                                              <v-text-field
                                                  outlined
                                                  type="number"
                                                  v-model="DepQuotaCount"
                                                  label="จำนวน / คน"
                                                  required
                                                  v-if="ChooseTypeDep != '3'"
                                              ></v-text-field>
                                              <v-btn
                                                  @click="ShowGroupDepDetail"
                                                  outlined
                                                  color="primary"
                                                  v-else
                                              >
                                                รายละเอียด
                                              </v-btn>
                                            </v-col>
                                          </v-row>
                                        </v-list-item>
                                        <v-list-item class="d-flex justify-center">
                                          <v-btn
                                              outlined
                                              color="primary"
                                              @click="AddDepQuotaData"
                                          >
                                            เพิ่ม
                                          </v-btn>
                                        </v-list-item>
                                        <v-list-item class="d-flex justify-center">
                                          <v-data-table
                                              :headers="DepQuotaHeader"
                                              :items="DepQuotaData"
                                              :search="searchDepQuota"
                                              class="elevation-1 mt-4"
                                          >
                                            <template v-slot:header.type>
                                              <v-label
                                                  fontSize="16px"
                                                  fontWeight="bold">
                                                ประเภท
                                              </v-label>
                                            </template>
                                            <template v-slot:header.dep_name>
                                              <v-label
                                                  fontSize="16px"
                                                  fontWeight="bold">
                                                ภาควิชา/หน่วยงาน
                                              </v-label>
                                            </template>
                                            <template v-slot:header.count>
                                              <v-label
                                                  fontSize="16px"
                                                  fontWeight="bold">
                                                จำนวน/คน
                                              </v-label>
                                            </template>
                                            <template v-slot:item.action="{ item }">
                                              <v-row class="d-flex">
                                                <v-col
                                                    cols="6"
                                                    md="6">
                                                  <v-btn
                                                      outlined
                                                      color="#BF360C"
                                                      @click="DeleteDepQuotaCondi(item)">
                                                    ลบ
                                                  </v-btn>
                                                </v-col>
                                              </v-row>
                                            </template>
                                            <template
                                                v-slot:footer
                                            >
                                              <template>
                                                <div align="center" style="margin-top: 15px">
                            <span style="font-weight: bold;color: #364eff">จำกัดหน่วยงาน : {{
                                ProjectQuotaDepCount
                              }} คน</span>
                                                </div>
                                                <div align="center"
                                                     v-if="!ChkJoinPerson && parseInt(ProjectQuotaCount) > 0">
                            <span style="font-weight: bold;color: #ff6d81">ทั่วไป : {{
                                parseInt(ProjectQuotaCount) - parseInt(ProjectQuotaDepCount)
                              }} คน</span>
                                                </div>
                                                <div align="center" v-else>
                                                  <span
                                                      style="font-weight: bold;color: #ff6d81">ทั่วไป : ไม่จำกัดคน</span>
                                                </div>
                                                <div align="center"
                                                     v-if="!ChkJoinPerson && parseInt(ProjectQuotaCount) > 0">
                              <span
                                  style="font-weight: bold;color: #42b983">รวม : {{
                                  ProjectQuotaCount
                                }} คน</span>
                                                </div>
                                                <div align="center" v-else>
                                                  <span style="font-weight: bold;color: #42b983">รวม : ไม่จำกัดคน</span>
                                                </div>
                                              </template>
                                            </template>
                                          </v-data-table>
                                        </v-list-item>
                                      </v-list>
                                    </v-tab-item>
                                    <v-tab-item
                                        key="JoinTab"
                                    >
                                      <v-list>
                                        <v-list-item>
                                          <v-row class="d-flex justify-center">
                                            <v-col
                                                class="d-flex justify-center"
                                                cols="12"
                                                md="6">
                                              <v-radio-group v-model="TypeInsert" row>
                                                <v-radio label="ค้นหาโดยชื่อ / รหัสบุคลากร" value="1"></v-radio>
                                                <v-radio label="ค้นหาโดยตัวเลือก"
                                                         value="2"></v-radio>
                                              </v-radio-group>
                                            </v-col>
                                          </v-row>
                                        </v-list-item>
                                        <v-list-item v-if="TypeInsert == '1'" style="margin-top: 25px">
                                          <v-row class="d-flex justify-center">
                                            <v-col
                                                cols="12"
                                                md="6">
                                              <v-autocomplete
                                                  v-model="staffSel"
                                                  label="ค้นหาบุคลากร"
                                                  :items="staffData"
                                                  item-text="customDetail"
                                                  item-value="perid"
                                                  hint="กด Enter เพื่อเป็นการเพิ่มข้อมูล"
                                                  persistent-hint
                                                  clearable
                                                  outlined
                                                  @keyup="checkKeyEnter"
                                              ></v-autocomplete>
                                            </v-col>
                                            <v-col
                                                cols="12"
                                                md="4"
                                                class="d-flex justify-center">
                                              <v-radio-group v-model="rdoRegisterProject" row disabled>
                                                <v-radio label="รอลงทะเบียน" value="0"></v-radio>
                                                <v-radio label="ลงทะเบียน" value="1"></v-radio>
                                              </v-radio-group>
                                            </v-col>
                                            <v-col
                                                cols="8"
                                                md="2"
                                                class="d-flex justify-center">
                                              <v-btn
                                                  outlined
                                                  color="primary"
                                                  @click="ChooseEmpolyee_s_owner">
                                                เพิ่ม
                                              </v-btn>
                                            </v-col>
                                          </v-row>

                                        </v-list-item>
                                        <v-list-item v-if="TypeInsert == '2'" style="margin-top: 25px">
                                          <v-row class="d-flex justify-center">
                                            <v-col
                                                cols="12"
                                                md="6">
                                              <v-autocomplete
                                                  v-model="departSel"
                                                  label="เลือกหน่วยงาน"
                                                  :items="depart"
                                                  item-text="dep_name"
                                                  item-value="dep_id"
                                                  flat
                                                  solo-inverted
                                                  hide-details
                                                  clearable
                                                  clear-icon="mdi-close-circle-outline"
                                                  @change="ChooseEmpolyee"
                                              ></v-autocomplete>
                                            </v-col>
                                          </v-row>

                                        </v-list-item>
                                        <v-row v-if="TypeInsert == '2'">
                                          <v-col
                                              cols="12"
                                              md="6">
                                            <v-card-text>
                                              <v-treeview
                                                  :items="items"
                                                  selected-color="indigo"
                                                  expand-icon="mdi-chevron-down"
                                                  off-icon="mdi-checkbox-blank-circle-outline"
                                                  on-icon="mdi-checkbox-marked-circle-outline"
                                                  indeterminate-icon="mdi-minus-circle-outline"
                                              >
                                                <template v-slot:label="{ item }">
                                                  <div class="d-flex justify-space-between">
                                    <span
                                        style="font-size: 16px;font-weight: bold;color: black;width: fit-content;margin-top: 22px">{{
                                        item.name
                                      }}</span>
                                                    <v-switch
                                                        inset
                                                        :input-value="item.switch"
                                                        @change="ChooseEmp(item)"
                                                    ></v-switch>
                                                  </div>
                                                </template>
                                              </v-treeview>
                                            </v-card-text>
                                          </v-col>

                                          <!--                                        <v-divider vertical></v-divider>-->

                                          <v-col
                                              cols="12"
                                              md="6"
                                          >
                                            <v-card-text>
                                              <div
                                                  v-if="EmpData.length === 0"
                                                  key="title"
                                                  class="title font-weight-light grey--text pa-4 text-center"
                                              >
                                                <span style="font-weight: bold;font-size: 18px">กรุณาเลือกรายชื่อบุคลากรที่ต้องการจะเข้าร่วมโครงการ</span>
                                              </div>

                                              <v-scroll-x-transition
                                                  group
                                                  hide-on-leave
                                              >
                                                <v-chip
                                                    v-for="(selection, i) in EmpData"
                                                    :key="i"
                                                    color="grey"
                                                    dark
                                                    small
                                                    class="ma-1"
                                                >
                                                  <v-icon left small>mdi-account-circle</v-icon>
                                                  {{ selection.name }}
                                                </v-chip>
                                              </v-scroll-x-transition>
                                            </v-card-text>
                                          </v-col>
                                        </v-row>
                                        <v-divider v-if="TypeInsert == '2'"></v-divider>
                                        <v-card-actions v-if="TypeInsert == '2'">
                                          <v-row class="d-flex justify-center">
                                            <v-col
                                                class="d-flex justify-center"
                                                cols="12"
                                                md="3">
                                              <v-btn
                                                  text
                                                  @click="EmpData = []"
                                              >
                                                Reset
                                              </v-btn>
                                            </v-col>
                                            <v-col
                                                class="d-flex justify-center"
                                                cols="12"
                                                md="6">
                                              <v-radio-group v-model="rdoRegisterProject" row disabled>
                                                <v-radio label="รอลงทะเบียน" value="0"></v-radio>
                                                <v-radio label="ลงทะเบียน" value="1"></v-radio>
                                              </v-radio-group>
                                            </v-col>
                                            <v-col
                                                class="d-flex justify-center"
                                                cols="12"
                                                md="3">
                                              <v-btn
                                                  class="white--text"
                                                  color="green darken-1"
                                                  depressed
                                                  @click="SaveToTable_owner"
                                              >
                                                Save
                                                <v-icon right>mdi-content-save</v-icon>
                                              </v-btn>
                                            </v-col>
                                          </v-row>
                                        </v-card-actions>
                                        <div align="center" style="margin-top: 30px">
                                          <v-alert
                                              dense
                                              outlined
                                              type="success"
                                              dismissible
                                              v-if="ShowAlertSuc"
                                          >
                                            <div v-html="MessageSuc"></div>
                                          </v-alert>
                                        </div>
                                        <div align="center" style="margin-top: 30px">
                                          <v-alert
                                              dense
                                              outlined
                                              type="error"
                                              dismissible
                                              v-if="ShowAlertErr"
                                          >
                                            <div v-html="MessageError"></div>
                                          </v-alert>
                                        </div>
                                        <v-card class="mt-7">
                                          <v-toolbar
                                              color="primary"
                                              dark
                                              flat
                                          >
                                            <v-toolbar-title>รายชื่อผู้เข้าร่วมโครงการ {{ JoinPerson.length }} <span
                                                v-if="!ChkJoinPerson"> / {{ ProjectQuotaCount }}</span> คน
                                            </v-toolbar-title>
                                          </v-toolbar>
                                          <v-card-title>
                                            <v-spacer></v-spacer>
                                            <v-text-field
                                                v-model="searchPerson"
                                                append-icon="mdi-magnify"
                                                label="Search"
                                                single-line
                                                hide-details
                                            ></v-text-field>
                                          </v-card-title>
                                          <v-data-table
                                              :headers="headersPerson"
                                              :items="JoinPerson"
                                              :search="searchPerson"
                                          >
                                            <template v-slot:item.type="{item}">
                                                            <span v-if="item.registerType_id == '0'"
                                                                  style="color: #ff6d81">
                                                                บุคลากรคณะแพทย์
                                                            </span>
                                              <span v-if="item.registerType_id == '1'" style="color: #ff6d81">
                                                                นักศึกษาคณะแพทย์
                                                            </span>
                                              <span v-if="item.registerType_id == '2'" style="color: blue">
                                                                บุคลากรคณะอื่น
                                                            </span>
                                              <span v-if="item.registerType_id == '3'" style="color: blue">
                                                                นักศึกษาคณะอื่น
                                                            </span>
                                              <span v-if="item.registerType_id == '4'" style="color: darkslateblue">
                                                                บุคคลภายนอก
                                                            </span>
                                              <span v-if="item.registerType_id == '5'" style="color: darkslateblue">
                                                                นักศึกษาภายนอก
                                                            </span>
                                            </template>
                                            <template v-slot:item.status_reg="{item}">
                                              <span style="font-weight: bold;color: #364eff"
                                                    v-if="item.status_reg == '1'">ลงทะเบียน</span>
                                              <span style="font-weight: bold;color: #ffd54f" v-else>รอลงทะเบียน</span>
                                            </template>
                                            <template v-slot:item.action="{item}">
                                              <v-btn
                                                  color="#F44336"
                                                  outlined
                                                  @click="Del_item(item)">
                                                ลบ
                                              </v-btn>
                                            </template>
                                          </v-data-table>
                                        </v-card>
                                        <v-list-item class="d-flex justify-center ma-8">
                                          <download-excel
                                              class="btn btn-default"
                                              :data="json_data"
                                              :fields="json_fields"
                                              worksheet="รายชื่อผู้เข้าร่วมโครงการ"
                                              :name="'รายชื่อผู้เข้าร่วมโครงการ ' + Project_name + '.xls'"
                                          >
                                            <v-btn outlined color="green" class="darken-3" @click="ExportData">
                                              Export รายชื่อผู้เข้าร่วมโครงการ
                                            </v-btn>
                                          </download-excel>
                                        </v-list-item>
                                      </v-list>
                                    </v-tab-item>
                                  </v-tabs-items>
                                </v-col>
                              </v-row>
                            </v-card>
                          </v-dialog>
                        </v-list-item>
                        <v-list-item class="d-flex justify-center mt-8" v-if="RoundData.length > 0">
                          <v-data-table
                              :headers="roundHeader"
                              :items="RoundData"
                          >
                            <template v-slot:item.action="{item}">
                              <div align="center">
                                <v-btn text color="primary" @click="GetRoundDetail(item)">
                                  รายละเอียด
                                </v-btn>
                                <v-btn text color="red" @click="DelRoundData(item)">
                                  ลบ
                                </v-btn>
                              </div>
                            </template>
                          </v-data-table>
                        </v-list-item>
                        <v-list-item class="d-flex justify-end">
                          <v-btn text color="red"
                                 @click="backStep(4)">
                            <v-icon left>mdi-arrow-left</v-icon>
                            ย้อนกลับ
                          </v-btn>
                          <v-btn
                              color="primary"
                              @click="nextStep(5)"
                          >
                            ถัดไป
                            <v-icon right>mdi-arrow-right</v-icon>
                          </v-btn>
                        </v-list-item>
                      </v-list>
                    </v-stepper-content>
                    <v-stepper-step :complete="e1 > 7" v-if="!roundNeed" step="7" editable @click="ExecForm">
                      ฟอร์มตัวอย่าง, ใบปะหน้าบันทึกข้อความ <div style="color: red" class="ml-4">(หากต้องการแก้ไขข้อมูลฟอร์มโครงการ ควรทำในขั้นตอนสุดท้าย เพื่อป้องกันข้อมูลที่คีย์ไปแล้วนั้นสูญหาย)</div>
                    </v-stepper-step>
                    <v-stepper-step :complete="e1 > 6" v-if="roundNeed" step="6" editable @click="ExecForm">
                      ฟอร์มตัวอย่าง, ใบปะหน้าบันทึกข้อความ <div style="color: red" class="ml-4">(หากต้องการแก้ไขข้อมูลฟอร์มโครงการ ควรทำในขั้นตอนสุดท้าย เพื่อป้องกันข้อมูลที่คีย์ไปแล้วนั้นสูญหาย)</div>
                    </v-stepper-step>
                    <v-stepper-content :step="!roundNeed ? '7' : '6'">
                      <v-list>
                        <v-list-item-title class="headline mb-1"><span>ฟอร์มตัวอย่าง, ใบปะหน้าบันทึกข้อความ</span>
                        </v-list-item-title>
                        <v-list-item>
                          <v-row class="d-flex justify-center">
                            <v-col
                                class="d-flex justify-center"
                                cols="12"
                                md="4">
                              <v-btn text color="#FF9800" @click="ChangeForm('1')">
                                ฟอร์มตัวอย่าง
                              </v-btn>
                              <v-btn text color="#FF9800" @click="ChangeForm('2')">
                                ใบปะหน้า
                              </v-btn>
                            </v-col>
                          </v-row>
                        </v-list-item>
                        <v-list-item class="d-flex justify-center">
                          <v-radio-group
                              v-model="ChooseForm"
                              row
                              @change="ExecForm">
                            <v-radio
                                label="ประมวลผลฟอร์มใหม่"
                                value="NewForm"
                            ></v-radio>
                            <v-radio
                                label="ฟอร์มจากการบันทึกข้อมูล"
                                value="OldForm"
                            ></v-radio>
                          </v-radio-group>
                        </v-list-item>
                        <v-row class="d-flex justify-center">
                          <v-col
                              cols="12">
                            <v-card class="elevation-2">
<!--                              <ckeditor :editor="editor" v-model="editorData" :config="editorConfig"-->
<!--                                        style="min-height: 800px" @input="DocumentExec" @ready="onReady"></ckeditor>-->
                              <ckeditor v-if="form1" v-model="editorData" :config="editorConfig" :editor-url="editorUrl"></ckeditor>
                              <ckeditor v-else-if="form2" v-model="editorData2" :config="editorConfig" :editor-url="editorUrl"></ckeditor>
                            </v-card>
                          </v-col>
                        </v-row>
                        <v-list-item>
                          <v-row class="d-flex justify-center">
                            <v-col
                                cols="12"
                                md="4"  class="d-flex justify-center">
                              <v-btn outlined color="primary" @click="ExportToDocx" v-if="form1">
                                ExportToDocx
                              </v-btn>
                            </v-col>
                            <v-col
                                cols="12"
                                md="4"  class="d-flex justify-center">
                              <v-btn outlined color="primary" @click="ShowTemplate">
                                พิมพ์โครงการ
                              </v-btn>
                            </v-col>
                          </v-row>
                        </v-list-item>

                        <v-list-item class="d-flex justify-end">
                          <v-btn text color="red" v-if="!roundNeed"
                                 @click="backStep(6)">
                            <v-icon left>mdi-arrow-left</v-icon>
                            ย้อนกลับ
                          </v-btn>
                          <v-btn text color="red" v-else
                                 @click="backStep(5)">
                            <v-icon left>mdi-arrow-left</v-icon>
                            ย้อนกลับ
                          </v-btn>
                          <v-btn
                              color="primary"
                              @click="nextStep(7)"
                              v-if="!roundNeed"
                          >
                            ถัดไป
                            <v-icon right>mdi-arrow-right</v-icon>
                          </v-btn>
                          <v-btn
                              color="primary"
                              @click="nextStep(6)"
                              v-else
                          >
                            ถัดไป
                            <v-icon right>mdi-arrow-right</v-icon>
                          </v-btn>
                        </v-list-item>
                      </v-list>
                    </v-stepper-content>
                    <v-stepper-step :complete="e1 > 8" :step="!roundNeed ? '8' : '7'" editable>
                      ยืนยันข้อมูล
                    </v-stepper-step>
                    <v-stepper-content :step="!roundNeed ? '8' : '7'">
                      <v-list>
                        <v-list-item class="justify-center" style="height: 200px">
                          <span style="font-weight: bold;font-size: 30px;color: #ff6d81">ยืนยันข้อมูล</span>
                        </v-list-item>
                        <v-list-item class="justify-center" style="height: 200px">
                          <v-radio-group v-model="ApproveRadio" row>
                            <v-radio
                                label="โครงการอนุมัติโดยหน่วยงาน"
                                value="0"
                            ></v-radio>
                            <v-radio
                                label="โครงการอนุมัติโดยคณะ"
                                value="1"
                            ></v-radio>
                          </v-radio-group>
                        </v-list-item>
                        <v-list-item class="justify-center" style="height: 200px">
                          <span style="font-weight: bold;font-size: 30px;color: #ff6d81">กรุณาตรวจสอบข้อมูลให้ครบถ้วนก่อนบันทึกข้อมูล</span>
                        </v-list-item>
                        <v-list-item class="justify-center" style="margin-top: 50px">
                          <v-btn
                              :disabled="btnDisable"
                              x-large
                              outlined
                              color="#F57F17"
                              @click="UpdateProject">
                            <v-icon left>mdi-content-save-all</v-icon>
                            แก้ไขข้อมูล
                          </v-btn>
                        </v-list-item>
                        <v-list-item class="d-flex justify-end">
                          <v-btn text color="red"
                                 @click="backStep(7)" v-if="!roundNeed">
                            <v-icon left>mdi-arrow-left</v-icon>
                            ย้อนกลับ
                          </v-btn>
                          <v-btn text color="red"
                                 @click="backStep(6)" v-else>
                            <v-icon left>mdi-arrow-left</v-icon>
                            ย้อนกลับ
                          </v-btn>
                        </v-list-item>
                      </v-list>
                    </v-stepper-content>
                  </template>
                </v-stepper>
              </div>
            </template>
          </v-card>
        </v-list-item-content>
      </v-list-item>
    </v-card>
    <template>
      <v-dialog
          v-model="dialogLecturer"
          fullscreen
          transition="dialog-bottom-transition"
      >
        <v-card style="padding-bottom: 20px">
          <v-card-title>
                                    <span style="font-weight: bold;color: black">
                                           แบบฟอร์มการเป็นวิทยากร
                                    </span>
          </v-card-title>
          <v-list-item>
            <v-row class="d-flex justify-center">
              <v-col class="d-flex justify-center" cols="12"
                     md="6">
                <v-text-field label="หัวข้อเรื่อง / หน้าที่" v-model="SubjectForLecturer"
                              :error="SubjectForLecturer == ''"
                              :error-messages="SubjectForLecturer == '' ? 'หัวข้อเรื่อง / หน้าที่ ห้ามว่าง' : ''"
                ></v-text-field>
              </v-col>
            </v-row>
          </v-list-item>
          <v-list-item v-if="Committee_code == '6' || Committee_code == '23' || Committee_code == '24'">
            <v-card style="width: 100%" color="#E0F2F1">
              <v-card-subtitle>
                <span style="color: #364eff" class="font-weight-bold">รายละเอียดเพิ่มเติมการเป็นวิทยากร</span>
              </v-card-subtitle>
              <v-card-text>
                <v-list-item>
                  <v-row>
                    <v-col
                        cols="12"
                        md="6">
                      <v-text-field
                          v-model="LecturerProjectName"
                          label="โครงการ"
                          :error="LecturerProjectName == ''"
                          :error-messages="LecturerProjectName == '' ? 'โครงการ' : ''"
                      ></v-text-field>
                    </v-col>
                    <v-col
                        cols="6"
                        md="3">
                      <v-text-field
                          v-model="LecturerHour"
                          label="จำนวน ช.ม."
                          type="number"
                          :error="LecturerHour == ''"
                          :error-messages="LecturerHour == '' ? 'จำนวน ช.ม.' : ''"
                      ></v-text-field>
                    </v-col>
                    <v-col
                        cols="6"
                        md="3">
                      <v-text-field
                          v-model="LecturerInvite"
                          label="ผู้เชิญ"
                          :error="LecturerInvite == ''"
                          :error-messages="LecturerInvite == '' ? 'ผู้เชิญ' : ''"
                      ></v-text-field>
                    </v-col>
                  </v-row>
                </v-list-item>
                <v-list-item>
                  <v-row>
                    <v-col
                        cols="12"
                        md="3">
                      <v-text-field
                          v-model="LecturerDateStart"
                          label="วันที่เริ่มเป็นวิทยากร/อาจารย์พิเศษ/นำเสนอผลงาน"
                          :error="LecturerDateStart == ''"
                          :error-messages="LecturerDateStart == '' ? 'วันที่เริ่มเป็นวิทยากร/อาจารย์พิเศษ/นำเสนอผลงาน' : ''"
                          type="date"
                      ></v-text-field>
                    </v-col>
                    <v-col
                        cols="6"
                        md="3">
                      <v-text-field
                          v-model="LecturerTimeStart"
                          label="เวลาเริ่มการบรรยาย"
                          :error="LecturerTimeStart == ''"
                          :error-messages="LecturerTimeStart == '' ? 'เวลาเริ่มการบรรยาย' : ''"
                          type="time"
                      ></v-text-field>
                    </v-col>
                    <v-col
                        cols="6"
                        md="3">
                      <v-text-field
                          v-model="LecturerDateEnd"
                          label="วันที่เป็นวิทยากร/อาจารย์พิเศษ/นำเสนอผลงาน"
                          type="date"
                          :error="LecturerDateEnd == ''"
                          :error-messages="LecturerDateEnd == '' ? 'วันที่เป็นวิทยากร/อาจารย์พิเศษ/นำเสนอผลงาน' : ''"
                      ></v-text-field>
                    </v-col>
                    <v-col
                        cols="6"
                        md="3">
                      <v-text-field
                          v-model="LecturerTimeEnd"
                          label="เวลาสิ้นสุดการบรรยาย"
                          type="time"
                          :error="LecturerTimeEnd == ''"
                          :error-messages="LecturerTimeEnd == '' ? 'เวลาสิ้นสุดการบรรยาย' : ''"
                      ></v-text-field>
                    </v-col>
                  </v-row>
                </v-list-item>
                <v-list-item>
                  <v-row>
                    <v-col
                        cols="12"
                        md="4">
                      <v-text-field
                          v-model="LecturerPlace"
                          label="สถานที่"
                          :error="LecturerPlace == ''"
                          :error-messages="LecturerPlace == '' ? 'สถานที่' : ''"
                      ></v-text-field>
                    </v-col>
                    <v-col
                        cols="6"
                        md="4">
                      <v-text-field
                          v-model="LecturerDocNo"
                          label="เลขที่หนังสือ"
                          :error="LecturerDocNo == ''"
                          :error-messages="LecturerDocNo == '' ? 'เลขที่หนังสือ' : ''"
                      ></v-text-field>
                    </v-col>
                    <v-col
                        cols="6"
                        md="4">
                      <v-text-field
                          v-model="LecturerDateDocOut"
                          label="วันที่ออกหนังสือ"
                          type="date"
                          :error="LecturerDateDocOut == ''"
                          :error-messages="LecturerDateDocOut == '' ? 'วันที่ออกหนังสือ' : ''"
                      ></v-text-field>
                    </v-col>
                  </v-row>
                </v-list-item>
              </v-card-text>
            </v-card>
          </v-list-item>
          <v-list-item>
            <v-row class="d-flex justify-center">
              <v-col class="d-flex justify-center" cols="12"
                     md="6">
                <v-text-field type="date" label="วันที่เริ่มต้นจัดงาน"
                              v-model="dateSForLecturer"
                              :error="dateSForLecturer == ''"
                              :error-messages="dateSForLecturer == '' ? 'วันที่เริ่มต้นจัดงาน ห้ามว่าง' : ''"
                ></v-text-field>
              </v-col>
              <v-col class="d-flex justify-center" cols="12"
                     md="6">
                <v-text-field type="date" label="วันที่สิ้นสุดจัดงาน"
                              v-model="dateEForLecturer"
                ></v-text-field>
              </v-col>
            </v-row>
          </v-list-item>
          <v-list-item>
            <v-row class="d-flex justify-center">
              <v-col class="d-flex justify-center" cols="12"
                     md="6">
                <v-text-field type="date" label="วันที่เดินทาง"
                              v-model="dateSTravelForLecturer"
                ></v-text-field>
              </v-col>
              <v-col class="d-flex justify-center" cols="12"
                     md="6">
                <v-text-field type="date" label="วันที่กลับ"
                              v-model="dateETravelForLecturer"
                ></v-text-field>
              </v-col>
            </v-row>
          </v-list-item>
          <v-list-item>
            <v-row class="d-flex justify-center">
              <v-col class="d-flex justify-center" cols="12"
                     md="6">
                <v-text-field type="time" label="เวลาเริ่มต้น"
                              v-model="timeSForLecturer"
                ></v-text-field>
              </v-col>
              <v-col class="d-flex justify-center" cols="12"
                     md="6">
                <v-text-field type="time" label="เวลาสิ้นสุด"
                              v-model="timeEForLecturer"
                ></v-text-field>
              </v-col>
            </v-row>
          </v-list-item>
          <v-list-item>
            <v-row class="d-flex justify-center">
              <v-col class="d-flex justify-center" cols="12"
                     md="10">
                <v-textarea label="รายละเอียดเพิ่มเติม (ถ้ามี)" outlined v-model="Rm2"></v-textarea>
              </v-col>
            </v-row>
          </v-list-item>
          <v-list-item>
            <v-file-input
                v-model="filesExpert"
                color="deep-purple accent-4"
                counter
                label="แนบไฟล์เอกสารประกอบ"
                multiple
                placeholder="เลือกไฟล์"
                prepend-icon="mdi-paperclip"
                outlined
                :show-size="1000"
                @change="FileSelectExpert"
            >
              <template v-slot:selection="{ index, text }">
                <v-chip
                    v-if="index < 5"
                    color="deep-purple accent-4"
                    dark
                    label
                    small
                >
                  {{ text }}
                </v-chip>

                <span
                    v-else-if="index === 5"
                    class="overline grey--text text--darken-3 mx-2"
                >
                                +{{ filesExpert.length - 2 }} File(s)
                              </span>
              </template>
            </v-file-input>
          </v-list-item>
          <v-list-item>
            <v-alert
                v-if="alertExpert"
                prominent
                type="error"
            >
              <v-row align="center" v-for="item in txtAlertExpert" :key="item.id">
                <v-col class="d-flex grow">- {{ item.Detail }}</v-col>
              </v-row>
            </v-alert>
          </v-list-item>
          <v-list-item v-if="FileProjectExpert.length > 0">
            <template>
              <v-row class="d-flex justify-center">
                <v-col cols="12" md="12">
                  <v-list>
                    <v-list-item-title>
                      ไฟล์เอกสารประกอบ
                    </v-list-item-title>
                    <v-list-item>
                      <v-data-table
                          :items="FileProjectExpert"
                          :headers="FileHeader"
                          style="width: 100%"
                      >
                        <template v-slot:item.action="{ item }">
                          <v-list-item class="justify-space-around">
                            <v-btn text @click="ShowData(item.src)" color="green">
                              เรียกดู
                            </v-btn>
                            <v-btn @click="DeleteFile2(item)" text color="red">
                              ลบ
                            </v-btn>
                          </v-list-item>
                        </template>
                      </v-data-table>
                    </v-list-item>
                  </v-list>
                </v-col>
              </v-row>
            </template>
          </v-list-item>
          <div align="center">
            <v-btn outlined color="primary" @click="AddWorkGuest">เพิ่มข้อมูล</v-btn>
          </div>
          <v-list-item class="d-flex justify-center" style="margin-top: 20px">
            <v-data-table :items="Lecturer" :headers="headerLecturer" class="elevation-2"
                          show-expand
                          style="width: 100%">
              <template v-slot:expanded-item="{ headers, item }">
                <td :colspan="headers.length">
                  <div v-if="item.Lecturer != null" style="margin-top: 25px">
                      <span style="font-weight: bold">
                        รายละเอียดเพิ่มเติมการเป็นวิทยากร (เพิ่มเติม)
                      </span>
                    <v-list>
                      <v-list-item>
                        โครงการ : {{ item.Lecturer.Project_name }}
                      </v-list-item>
                      <v-list-item>
                        จำนวน ช.ม. : {{ item.Lecturer.Hour }}
                      </v-list-item>
                      <v-list-item>
                        ผู้เชิญ : {{ item.Lecturer.Invite }}
                      </v-list-item>
                      <v-list-item>
                        วันที่เริ่มต้นเป็นวิทยากร/อาจารย์พิเศษ/นำเสนอผลงาน : {{ item.Lecturer.DateStart | dateToThai }}
                      </v-list-item>
                      <v-list-item>
                        เวลาเริ่มการบรรยาย : {{ item.Lecturer.TimeStart }} น.
                      </v-list-item>
                      <v-list-item>
                        วันที่สิ้นสุดเป็นวิทยากร/อาจารย์พิเศษ/นำเสนอผลงาน : {{ item.Lecturer.DateEnd | dateToThai }}
                      </v-list-item>
                      <v-list-item>
                        เวลาสิ้นสุดการบรรยาย : {{ item.Lecturer.TimeEnd }} น.
                      </v-list-item>
                      <v-list-item>
                        สถุานที่ : {{ item.Lecturer.Place }}
                      </v-list-item>
                      <v-list-item>
                        เลขที่หนังสือ : {{ item.Lecturer.DocNo }}
                      </v-list-item>
                      <v-list-item>
                        วันที่ออกหนังสือ : {{ item.Lecturer.DateDocNo }}
                      </v-list-item>
                      <v-divider></v-divider>
                    </v-list>
                  </div>
                  <div v-for="(file, idx) in item.files" v-bind:key="idx">
                    <v-btn color="primary" text @click="ShowData(Openfile + file.path)">ไฟล์ : {{ file.name }}
                    </v-btn>
                  </div>
                  <div style="margin-bottom: 25px">
                    รายละเอียด : {{ item.Rm }}
                  </div>
                </td>
              </template>
              <template v-slot:item.action="{item}">
                <div align="center">
                  <v-btn text @click="GetOldData(item)" color="primary">ใช้ข้อมูลเดิม</v-btn>
                </div>
              </template>
              <template v-slot:item.date_travel_start="{item}">
                <span v-if="item.date_travel_start != '' && item.date_travel_start != null">{{
                    item.date_travel_start | dateToThai
                  }}</span>
              </template>
              <template v-slot:item.date_travel_end="{item}">
                <span v-if="item.date_travel_end != '' && item.date_travel_end != null">{{
                    item.date_travel_end | dateToThai
                  }}</span>
              </template>
              <template v-slot:item.date_start="{item}">
                <span v-if="item.date_start != '' && item.date_start != null">{{ item.date_start | dateToThai }}</span>
              </template>
              <template v-slot:item.date_end="{item}">
                <span v-if="item.date_end != '' && item.date_end != null">{{ item.date_end | dateToThai }}</span>
              </template>
            </v-data-table>
          </v-list-item>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
                outlined
                color="green darken-2"
                @click="InsertCoordinator(true)"
            >
              บันทึก
            </v-btn>
            <v-btn
                color="red darken-1"
                text
                @click="dialogLecturer = false"
            >
              ปิด
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </template>
    <template>
      <v-dialog
          v-model="dialogDetail"
          max-width="800"
      >
        <v-card v-if="itemToShow != null">
          <v-card-title class="headline"><span style="color: #42b983;font-weight: bold">{{ itemToShow.DelvDes }}</span>
          </v-card-title>

          <v-card-text>
            <v-row>
              <v-col
                  cols="12"
                  md="12">
                <v-divider></v-divider>
                <p style="font-weight: bold;color: black">
                  <span style="color: #364eff">ชื่อย่อ:</span> {{ itemToShow.DelvShort }}
                </p>
                <v-divider></v-divider>
                <p style="font-weight: bold;color: black">
                  <span style="color: #364eff">ชื่อ Eng:</span> {{ itemToShow.DelvEng }}
                </p>
                <v-divider></v-divider>
                <p style="font-weight: bold;color: black">
                  <span style="color: #364eff">คำอธิบาย:</span> {{ itemToShow.DelvRm }}
                </p>
                <v-divider></v-divider>
                <p style="font-weight: bold;color: black">
                  <span style="color: #364eff">PSU:</span> {{ itemToShow.PSU }}
                </p>
                <v-divider></v-divider>
                <p style="font-weight: bold;color: black" v-if="itemToShow.DelvGroup == 'A'">
                  <span style="color: #364eff">กรุ๊ป:</span> สมรรถนะหลัก
                </p>
                <p style="font-weight: bold;color: black" v-else-if="itemToShow.DelvGroup == 'B'">
                  <span style="color: #364eff">กรุ๊ป:</span> สมรรถนะด้านบริหาร
                </p>
                <p style="font-weight: bold;color: black" v-else-if="itemToShow.DelvGroup == 'C'">
                  <span style="color: #364eff">กรุ๊ป:</span> จิตสํานึกด้านความเสียงและความปลอดภัย
                </p>
                <p style="font-weight: bold;color: black" v-else-if="itemToShow.DelvGroup == 'D'">
                  <span style="color: #364eff">กรุ๊ป:</span> กลยุทธ์
                </p>
                <v-divider></v-divider>
                <p style="font-weight: bold;color: black">
                  <span style="color: #364eff">คณะ/หน่วยงาน:</span> {{ itemToShow.dep_name }}
                </p>
                <v-divider></v-divider>
              </v-col>
            </v-row>
          </v-card-text>

          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
                color="green darken-1"
                text
                @click="dialogDetail = false"
            >
              Close
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </template>
    <template>
      <v-dialog
          v-model="dialogTemplate"
          max-width="800"
      >
        <v-card>
          <v-card-title>ฟอร์ฺมตัวอย่าง</v-card-title>
          <v-card-text>
            <div v-html="editorData"></div>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
                color="green darken-1"
                text
                @click="dialogTemplate = false"
            >
              Close
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </template>
    <template>
      <v-dialog
          v-model="dialogLecturerDetail"
          max-width="800"
      >
        <v-card>
          <v-card-title class="headline"><span style="color: #42b983;font-weight: bold">รายละเอียดการเป็นวิทยากร</span>
          </v-card-title>
          <v-card-text>
            <v-data-table :items="LecturerDetail" :headers="headerLecturer" class="elevation-2"
                          show-expand
                          style="width: 100%">
              <template v-slot:expanded-item="{ headers, item }">
                <td :colspan="headers.length">
                  <div v-if="item.Lecturer != null" style="margin-top: 25px">
                      <span style="font-weight: bold">
                        รายละเอียดเพิ่มเติมการเป็นวิทยากร (เพิ่มเติม)
                      </span>
                    <v-list>
                      <v-list-item>
                        โครงการ : {{ item.Lecturer.Project_name }}
                      </v-list-item>
                      <v-list-item>
                        จำนวน ช.ม. : {{ item.Lecturer.Hour }}
                      </v-list-item>
                      <v-list-item>
                        ผู้เชิญ : {{ item.Lecturer.Invite }}
                      </v-list-item>
                      <v-list-item>
                        วันที่เริ่มต้นเป็นวิทยากร/อาจารย์พิเศษ/นำเสนอผลงาน : {{ item.Lecturer.DateStart | dateToThai }}
                      </v-list-item>
                      <v-list-item>
                        เวลาเริ่มการบรรยาย : {{ item.Lecturer.TimeStart }} น.
                      </v-list-item>
                      <v-list-item>
                        วันที่สิ้นสุดเป็นวิทยากร/อาจารย์พิเศษ/นำเสนอผลงาน : {{ item.Lecturer.DateEnd | dateToThai }}
                      </v-list-item>
                      <v-list-item>
                        เวลาสิ้นสุดการบรรยาย : {{ item.Lecturer.TimeEnd }} น.
                      </v-list-item>
                      <v-list-item>
                        สถุานที่ : {{ item.Lecturer.Place }}
                      </v-list-item>
                      <v-list-item>
                        เลขที่หนังสือ : {{ item.Lecturer.DocNo }}
                      </v-list-item>
                      <v-list-item>
                        วันที่ออกหนังสือ : {{ item.Lecturer.DateDocNo }}
                      </v-list-item>
                      <v-divider></v-divider>
                    </v-list>
                  </div>
                  <div v-for="(file, idx) in item.files" v-bind:key="idx">
                    <v-btn color="primary" text @click="ShowData(Openfile + file.File_path)">ไฟล์ : {{ file.File_name }}
                    </v-btn>
                  </div>
                  <div style="margin-bottom: 25px">
                    รายละเอียด : {{ item.Rm }}
                  </div>
                </td>
              </template>
              <template v-slot:item.date_travel_start="{item}">
                <span
                    v-if="item.date_travel_start != '0000-00-00' && item.date_travel_start != null && item.date_travel_start != ''">{{
                    item.date_travel_start | dateToThai
                  }}</span>
              </template>
              <template v-slot:item.date_travel_end="{item}">
                <span
                    v-if="item.date_travel_end != '0000-00-00' && item.date_travel_end != null && item.date_travel_end != ''">{{
                    item.date_travel_end | dateToThai
                  }}</span>
              </template>
              <template v-slot:item.date_start="{item}">
                <span v-if="item.date_start != '0000-00-00' && item.date_start != null && item.date_start != ''">{{
                    item.date_start | dateToThai
                  }}</span>
              </template>
              <template v-slot:item.date_end="{item}">
                <span v-if="item.date_end != '0000-00-00' && item.date_end != null && item.date_end != ''">{{
                    item.date_end | dateToThai
                  }}</span>
              </template>
              <template v-slot:item.time_start="{item}">
                <span v-if="item.time_start != '00:00:00' && item.time_start != null && item.time_start != ''">{{
                    item.time_start
                  }}</span>
              </template>
              <template v-slot:item.time_end="{item}">
                <span v-if="item.time_end != '00:00:00' && item.time_end != null && item.time_end != ''">{{
                    item.time_end
                  }}</span>
              </template>
            </v-data-table>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
                color="red darken-1"
                text
                @click="dialogLecturerDetail = false"
            >
              ปิด
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </template>
    <v-snackbar
        v-model="snack"
        :timeout="3000"
        :color="snackColor"
    >
      {{ snackText }}
      <template v-slot:action="{ attrs }">
        <v-btn
            v-bind="attrs"
            text
            @click="snack = false"
        >
          Close
        </v-btn>
      </template>
    </v-snackbar>
  </v-container>
</template>

<script>
import axios from 'axios'
import ConstData from '../../const/Const'
import {mapActions, mapGetters} from "vuex";
import DecoupledEditor from '@ckeditor/ckeditor5-build-decoupled-document'
import Vue from "vue";
import Allfunc from "@/FuncGlobal/ALlFunc";

export default {
  name: "UpdateProject",
  data() {
    return {
      editorUrl: "https://cdn.ckeditor.com/4.17.1/full-all/ckeditor.js",
      editorConfig: {
        height: 700,
        width: '100%',
        allowedContent: true,
        bodyClass: 'document-editor',
        tabSpaces: 4,
        // font_defaultLabel: 'Sarabun',
        font_names: 'Sarabun;Angsana New;Tahoma;;' +
            'Arial/Arial, Helvetica, sans-serif;' +
            'Times New Roman/Times New Roman, Times, serif;' +
            'Verdana',
        skin: 'kama',
        removeButtons: 'ExportPdf,Print'
      },
      config: {
        events: {
          initialized: function () {
            console.log('initialized')
          }
        },
        height: 700,
        tabSpaces: 6,
        fontFamily: {
          "Sarabun,sans-serif": 'Sarabun',
        },
        fontSize: ['8', '10', '12', '14', '16', '18', '20', '22', '24', '28', '30', '32', '60', '96'],
        fontSizeDefaultSelection: '16',
        fontSizeUnit: 'px',
        lineHeights: {
          Default: '1',
          Single: '1',
          '1.15': '1.15',
          '1.5': '1.5',
          Double: '2',
          '3': '3',
          '3.5': '3.5',
          '4': '4',
          '5': '5',
        },
      },
      form1: true,
      form2: false,
      LecturerDateStart: '',
      LecturerDateEnd: '',
      LecturerTimeStart: '',
      LecturerTimeEnd: '',
      LecturerDateDocOut: '',
      LecturerDocNo: '',
      LecturerPlace: '',
      LecturerInvite: '',
      LecturerHour: '',
      LecturerProjectName: '',
      dialogAppointment: false,
      AppointmentSel: '',
      AppointmentObj: '',
      appointmentGroup: [],
      appointmendHeader: [
        {text: 'ชื่อ-สกุล', value: 'full_Detail'},
        {text: 'ตำแหน่ง', value: 'committee_des'},
        {text: 'เบอร์โทร', value: 'phone'},
        {text: '', value: 'status'},
      ],
      IsRoundStatus: '',
      DataCondiDel: [],
      RoundDataDel: [],
      JoinPersonDel: [],
      DepQuotaDataDel: [],
      Ref_id: '',
      RoundDataDump: [],
      groupDetail: null,
      groupQuataDump: [],
      dialogGroupDetail: false,
      roundHeader: [
        {text: 'รุ่น', value: 'round'},
        {text: 'ชื่อรุ่น', value: 'round_name'},
        {text: 'จำนวนผู้เข้าร่วม', value: 'count_person'},
        {text: '', value: 'action'},
      ],
      roundNeed: false,
      RoundData: [],
      round: '',
      round_name: '',
      dateRegS: '',
      dateRegE: '',
      time_start: '',
      time_end: '',
      tabs: null,
      dialogRound: false,
      array_title: [],
      json_fields: {
        'ลำดับ': 'index',
        "รหัสบุคลากร": 'perid',
        "คำนำหน้า": 'iname',
        "ชื่อ": 'name',
        "นามสกุล": 'surname',
        "หน่วยงาน": 'dep_name_old',
        "กลุ่มหน่วยงาน": 'dep_group_name',
        "ตำแหน่ง": 'pos_name',
        "ศาสนา": 'religion_name',
        "งบวิชาการตามสิทธิ์ที่ได้รับ": 'money_permiss',
        "หมายเหตุ": 'remark',
      },
      json_data: [],
      json_meta: [
        [
          {
            key: "charset",
            value: "utf-8",
          },
        ],
      ],
      IsPlan: '',
      PlanProject_code: '',
      Project_code_dump: '',
      itemCode: '',
      ProjectPlan: '',
      Project_plan: [],
      TypeCreateProject: '0',
      FiscalYearData: [],
      rdoRegisterProject: '0',
      ProjectQuotaDepCount: 0,
      dateRegStart: '',
      dateRegEnd: '',
      MessageSuc: '',
      MessageError: '',
      ShowAlertErr: false,
      ShowAlertSuc: false,
      DepQuotaData: [],
      searchDepQuota: '',
      ChooseTypRegis: '1',
      ChooseTypRegis2: '0',
      ChkJoinPerson: true,
      ProjectQuotaCount: '',
      DepQuotaCount: '',
      groupDepart: [],
      ChooseTypeDep: '0',
      DepQuotaSelect: '',
      GroupSelect: '',
      CheckSubAdmin: false,
      CheckAdmin: false,
      Rm2: '',
      WorkGroupData: [],
      Openfile: ConstData.ConnectionHost + '/rest/files',
      FileHeader: [
        {text: 'ชื่อไฟล์', value: 'name'},
        {text: 'ประเภทไฟล์', value: 'type'},
        {text: '', value: 'action'},
      ],
      DepQuotaHeader: [
        {text: 'ประเภท', value: 'type'},
        {text: 'ภาควิชา/หน่วยงาน', value: 'dep_name'},
        {text: 'จำนวน', value: 'count'},
        {text: '', value: 'action'},
      ],
      filesExpert: [],
      alertExpert: false,
      txtAlertExpert: [],
      FileProjectExpert: '',
      dateSTravelForLecturer: '',
      dateETravelForLecturer: '',
      ChooseForm: 'OldForm',
      dialogLecturerDetail: false,
      LecturerDetail: [],
      Country_id: '',
      dialogLecturer: false,
      percent: 0,
      dialogTemplate: false,
      CheckLecturer: false,
      Lecturer: [],
      TemplateProject: [],
      LecturerToShow: [],
      Committee_ToShow: [],
      projectGroupToShow: [],
      headerLecturer: [
        {text: 'หัวข้อเรื่อง', value: 'subject'},
        {text: 'วันที่จัดงานเริ่มต้น', value: 'date_start'},
        {text: 'วันที่จัดงานสิ้นสุด', value: 'date_end'},
        {text: 'วันที่เดินทาง', value: 'date_travel_start'},
        {text: 'วันที่กลับ', value: 'date_travel_end'},
        {text: 'เวลาเริ่มต้น', value: 'time_start'},
        {text: 'เวลาสิ้นสุด', value: 'time_end'},
        {text: '', value: 'action'},
      ],
      SubjectForLecturer: '',
      dateSForLecturer: '',
      dateEForLecturer: '',
      timeSForLecturer: '',
      timeEForLecturer: '',
      formprint1: '', // หลักการและเหตุผล
      formprint2: '', // วัตถุประสงค์
      formprint3: '', // กลุ่มเป้าหมาย
      formprint4: '', // วิธีการจัดอบรม
      formprint5: '', // ระยะเวลาการจัดอบรม
      formprint6: '', // สถานที่จัดอบรม
      formprint7: '', // ผลที่คาดว่าจะได้รับ
      formprint8: '', // ผู้รับผิดชอบโครงการ
      formprint9: '', // ผู้รับผิดชอบโครงการ
      formprint10: '', // วิทยากร
      formprint11: '', // งบประมาณ
      formprint12: '', // หมายเหตุ
      editor: DecoupledEditor,
      editorDataGenerate: '',
      editorDataGenerate2: '',
      editorDataFormDB: '',
      editorData: '',
      editorData2: '',
      Expense: 0,
      btnDisable: false,
      snack: false,
      snackColor: '',
      snackText: '',
      ReqMoney: '',
      Rm: '',
      selection: [],
      dialogDetail: false,
      itemToShow: null,
      searchCompe: '',
      isMobile: false,
      SelDelvNo: '',
      itemsSel: [],
      CompetencyData: [],
      ProjectData_U: [],
      Period_code: '',
      period: [
        {
          'name': 'ระยะสั้น (ไม่เกิน 1 เดือน)',
          'id': '2'
        },
        {
          'name': 'ระยะยาว (มากกว่า 1 เดือน)',
          'id': '3'
        }
      ],
      Approve: '',
      DepSelect: null,
      EmpData: [],
      departSel: null,
      IdPersonal: '',
      personalMedData: [],
      IdDepart: '',
      Idstudent: '',
      tabPersonal: null,
      TypeInsert: '0',
      ApproveRadio: '0',
      studentUniData: [],
      IdstudentUni: '',
      IdDepartStd: '',
      searchPerson: '',
      headersPerson: [
        {text: 'ลำดับ', value: 'idx'},
        {text: 'ชื่อ - สกุล', value: 'full_Name'},
        {text: 'สังกัด', value: 'affiliation'},
        {text: 'ลงทะเบียน', value: 'status_reg'},
        {text: '', value: 'action'}
      ],
      JoinPerson: [],
      cardSel: '',
      staffSel: '',
      NameP: '',
      items: [],
      SurNameP: '',
      affiliation: '',
      position: '',
      idCard: '',
      NameStd: '',
      SurNameStd: '',
      affiliationStd: '',
      idCardStd: '',
      AllDepartData: [],
      studentData: [],
      FileProject: [],
      alert: false,
      alert2: false,
      txtAlert: [],
      txtAlert2: [],
      tab: null,
      Competency_code: '',
      UPercent: '',
      competencyHeader: [
        {text: 'Competency', value: 'Competency_des'},
        {text: 'เปอเซ็นต์', value: 'UPercent'},
        {text: '', value: 'action'}
      ],
      competency_DataForSubmit: [],
      expenseCostSum: 0,
      DepCost: '',
      expenseCost: '',
      moneyCost: '',
      expense_DataForSubmit: [],
      expense_p_DataForSubmit: [],
      CheckStep1: true,
      e1: 1,
      steps: 8,
      vertical: false,
      altLabels: false,
      editable: true,
      CheckFiles: false,
      full_name: '',
      phone: '',
      perid: '',
      peridCost: '',
      peridCommittee: '',
      Committee_code: '',
      radioGroup: '0',
      radioGroup2: '0',
      files: [],
      Project_Choose: '',
      ChooseCourse: '',
      posiCondi: '',
      levelCondi: '',
      workAgeStart_Condi: '',
      workAgeEnd_Condi: '',
      WSYear_Condi: '',
      WEYear_Condi: '',
      Course_Choose: '',
      DataCondi: [],
      courseCondi: [],
      Project_code: '',
      Project_name: '',
      Course_code: '0000000',
      course_group: '',
      FiscalYear: '',
      Project_type: '',
      WorkBy: '',
      WorkByName: '',
      Location: '',
      DateStart: '',
      DateEnd: '',
      CalHourse: '',
      CalCredit: '',
      PLACE: '',
      Province_id: '',
      Status: '',
      Remarks: '',
      ProjectLevel: '',
      App_doc_no: '',
      BudgetRequest: '',
      BudgetArrove: '',
      Project_group: '',
      D_Project: {
        Project_code: '',
        Project_name: '',
        Course_code: '0000000',
        course_group: '',
        Project_type: '',
        WorkBy: '',
        WorkByName: '',
        Location: '',
        DateStart: '',
        DateEnd: '',
        CalHourse: '',
        CalCredit: '',
        PLACE: '',
        Province_id: '',
        Status: '0',
        Remarks: '',
        ProjectLevel: '',
        App_doc_no: '',
        BudgetRequest: '',
        BudgetArrove: '',
        Project_group: '',
        Approve: '',
        FiscalYear: '',
        IsPlan: '',
        Status_Reg: '',
        Status_Type_Reg: '',
        DateS_Reg: '',
        DateE_Reg: '',
        Status_Count_Reg: '',
        Count_Reg: '',
        Dep_Code: '',
        IsRoundStatus: '',
        Update_By: '',
      },
      expanded: [],
      singleExpand: false,
      search: '',
      CoordinatorHeader: [
        {text: 'ชื่อ - สกุล', value: 'Name'},
        {text: 'ตำแหน่ง', value: 'position_com'},
        {text: 'เบอรโ์โทร', value: 'TEL'},
        {text: 'สถานะ', value: 'Committee_type'},
        {text: 'วิทยากร/คณะกรรมการ/นำเสนอผลงาน', value: 'Lecturer'},
        {text: '', value: 'action'}
      ],
      Coordinator: [],
      courseHeadersCondi: [
        {text: 'หลักสูตร', value: 'Course_name'},
        {text: '', value: 'action'},
      ],
      courseDataCondi: [],
      dataHeadersCondi: [
        {text: 'ตำแหน่ง', value: 'PosName'},
        {text: 'อายุงานเริ่มต้น', value: 'workAgeStart'},
        {text: 'อายุงานสิ้นสุด', value: 'workAgeEnd'},
        {text: '', value: 'action'},
      ],
      dataDataCondi: [],
      projectNeed: false,
      picker: new Date().toISOString().substr(0, 10),
      landscape: false,
      reactive: false,
      fullWidth: false,
      showCurrent: true,
      month: false,
      multiple: false,
      readonly: false,
      disabled: false,
      enableEvents: false,
      PLACESelete: [
        {
          id: '0', detail: 'ภายในคณะ'
        },
        {
          id: '1', detail: 'ภายในมหาวิทยาลัย'
        },
        {
          id: '2', detail: 'ถายในประเทศ'
        },
        {
          id: '3', detail: 'ต่างประเทศ'
        },
        {
          id: '4', detail: 'online'
        }
      ],
      WorkByData: [
        {
          id: 'D', detail: 'หน่วยงาน'
        },
        {
          id: 'F', detail: 'คณะ'
        },
        {
          id: 'U', detail: 'หน่วยงาน/คณะ มหาวิทยาลัย'
        },
        {
          id: 'P', detail: 'ภายนอก'
        },
        {
          id: 'C', detail: 'ร่วมโครงการ'
        },
      ],
      Menu: [
        {
          'id': 1,
          'value': 'จัดโครงการ'
        },
        {
          'id': 2,
          'value': 'จัดการข้อมูลโครงการ'
        },
        {
          'id': 3,
          'value': 'ข้อมูลเบิกจ่ายเงินโครงการ'
        }],
      projectType: [
        {
          id: '0',
          details: 'อบรม'
        },
        {
          id: '1',
          details: 'ดูงาน'
        },
        {
          id: '2',
          details: 'ประชุม'
        },
        {
          id: '3',
          details: 'นำเสนองาน'
        }
      ],
      workBy: [
        'Depart',
        'Faculty',
        'University',
        'Public C',
        'Co-Project'
      ],
      CourseType: [
        'ทั่วไป',
        'เฉพาะตำแหน่ง'
      ],
      DataCourse: {
        Project_code: '',
        Course_code: '',
        Credit: ''
      },
      budgetHeader: [
        {text: 'รายการ', value: 'Expense_des'},
        {text: 'จำนวนเงิน', value: 'ReqMoney'},
        {text: 'หมายเหตุ', value: 'Rm'},
        {text: '', value: 'action'}
      ],
      budgetData: [],
      rules: {
        required: value => !!value || 'Required.',
        counterCourse: value => value.length <= 5 || 'Max 5 characters',
        email: value => {
          const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
          return pattern.test(value) || 'Invalid e-mail.'
        },
      }
    }
  },
  watch: {
    steps(val) {
      if (this.e1 > val) {
        this.e1 = val
      }
    },
    vertical() {
      this.e1 = 2
      requestAnimationFrame(() => this.e1 = 1) // Workarounds
    },
  },
  computed: {
    functionEvents() {
      return this.month ? this.monthFunctionEvents : this.dateFunctionEvents
    },
    ...mapGetters({
      MeData: 'Staff/getMeData',
      levelData: 'Level/getLevel',
      projectData: 'Project/getProject',
      committee_Posi: 'Project/getComitteeType',
      provinces_Data: 'Project/getProvince',
      expense_Data: 'Project/getExpense',
      Competency_Data: 'Project/getCompetency',
      projectGroup: 'Project/getProjectGroup',
      textForPrint: 'Project/getTextForPrint',
      countryData: 'Project/getCountry',
      GroupExamData: 'Project/getGroupExamProject',
      QuotaDepartData: 'Project/getQuotaDepart',
      JoinProjectData: 'Project/getJoinProject',
      GroupQuotaData: 'Project/getGroupQuota',
      GroupQuotaMS: 'Project/getGroupQuota_Ms',
      staffData: 'Staff/getStaff',
      positions: 'Staff/getPosition',
      CardData: 'Staff/getCard',
      depart: 'Depart/getDepart',
      courseData: 'Course/getCourse',
      Competency: 'Competency/getCompetency',
      ProjectCompetency: 'Project/getCompetency',
      ProjectExpense: 'Project/getProjectExpense',
      ProjectRound: 'Project/getProjectRound',
      AllDepPermission: 'Permission/getAllDepUserPermission',
      DepPermission: 'Permission/getDepUserPermission',
      AllPermission: 'Permission/getAllUserPermission',
      Permission: 'Permission/getPermissionUser',
      Permission_Ms: 'Permission/getPermissionMs',
      Permission_Dep_User: 'Permission/getPermissionDepUser',
      Permission_Dep: 'Permission/getPermissionDep',
      Approve_Ms: 'Permission/getApproveMs',
      ApproveData: 'Permission/getApprove',
      PermissionAdmin: 'Permission/getPermission',
      Appointment: 'Appointment/getAppointmentData',
      AppointmentGroup: 'Appointment/getAppointmentGroupData',
    })
  },

  methods: {
    ...mapActions({
      initMeData: 'Staff/initMeData',
      initlevelData: 'Level/initLevelData',
      initDepartData: 'Depart/initDepartData',
      initCourseData: 'Course/initCourseData',
      initProjectData: 'Project/initProjectData',
      initComitteeData: 'Project/initComitteeData',
      initComitteeType: 'Project/initComitteeType',
      initProvincesData: 'Project/initProvincesData',
      initExpenseData: 'Project/initExpenseData',
      MangeTextForPrint: 'Project/MangeTextForPrint',
      initCountryData: 'Project/initCountryData',
      initProjectExpenseData: 'Project/initProjectExpenseData',
      initCompetencyData: 'Competency/initCompetencyData',
      initProjectCompetencyData: 'Project/initCompetencyData',
      initProjectGroupData: 'Project/initProjectGroupData',
      initProjectPlanData: 'Project/initProjectPlanData',
      getProjectRoundData: 'Project/getProjectRoundData',
      getGroupExamProjectByCordi: 'Project/getGroupExamProjectByCordi',
      getQuotaDepartRegisterByCordi: 'Project/getQuotaDepartRegisterByCordi',
      getJoinProjectByCordi: 'Project/getJoinProjectByCordi',
      initGroup_Quota: 'Project/initGroup_Quota',
      initGroup_Quota_Ms: 'Project/initGroup_Quota_Ms',
      initStaffData: 'Staff/initStaffData',
      initPositionsData: 'Staff/initPositionsData',
      initCardData: 'Staff/initCardData',
      initPermissionDepUserAllData: 'Permission/initPermissionDepUserAllData',
      initPermissionDepUserData: 'Permission/initPermissionDepUserData',
      initPermissionUserData: 'Permission/initPermissionUserData',
      initPermissionMsData: 'Permission/initPermissionMsData',
      getPermissionUserData: 'Permission/getPermissionUserData',
      getPermissionDep: 'Permission/getPermissionDepData',
      initPermissionDepData: 'Permission/initPermissionDepData',
      getPermissionDepUserData: 'Permission/getPermissionDepUserData',
      initApproveMsData: 'Permission/initApproveMsData',
      initApproveData: 'Permission/initApproveData',
      getPermissionData: 'Permission/getPermissionData',
      initPermissionData: 'Permission/initPermissionData',
      initAppointment: 'Appointment/initAppointment',
      getAppointmentGroup: 'Appointment/getAppointmentGroup',
    }),
    insertAppointment() {
      if (this.Coordinator.length > 0) {
        var CheckCupe = false
        this.appointmentGroup.map(a_item => {
          if (a_item.status) {
            CheckCupe = false
            this.Coordinator.map((CoorItem) => {
              if (CoorItem.Name == a_item.full_Name && CoorItem.Committee_code == a_item.C_Committee_code) {
                CheckCupe = true
              }
            })

            if (CheckCupe) {
              this.alert2 = true
              this.txtAlert2.push({
                id: this.txtAlert.length + 1,
                Detail: 'พบข้อมูลรายชื่อ ' + this.full_name + ' และตำแหน่งที่เลือกในระบบอยู่แล้ว'
              })
            } else {
              this.staffData.map((item) => {
                if (item.perid == a_item.perid) {
                  this.Coordinator.push({
                    ...item,
                    Project_code: this.Project_code,
                    Committee_code: a_item.C_Committee_code,
                    Committee_type: '0',
                    Committee_des: a_item.committee_des,
                    Name: a_item.full_Name,
                    Perid: a_item.perid,
                    TEL: a_item.phone,
                  })
                }
              })
              this.Committee_ToShow = this.Coordinator.filter(itemLecturer => itemLecturer.Committee_code != '6' && itemLecturer.Committee_code != '23' && itemLecturer.Committee_code != '24')
              this.LecturerToShow = this.Coordinator.filter(itemLecturer => itemLecturer.Committee_code == '6' || itemLecturer.Committee_code == '23' || itemLecturer.Committee_code == '24')
              if (this.Committee_ToShow.length > 0) {
                this.Committee_ToShow.map((Committee_i, idx) => {
                  Committee_i.index = (idx + 1)
                })
              }
              if (this.LecturerToShow.length > 0) {
                this.LecturerToShow.map((lecture_i, idx) => {
                  lecture_i.index = (idx + 1)
                })
              }
            }
          }
        })
      } else {
        this.appointmentGroup.map(a_item => {
          if (a_item.status) {
            this.staffData.map((item) => {
              if (item.perid == a_item.perid) {
                this.Coordinator.push({
                  ...item,
                  Project_code: this.Project_code,
                  Committee_code: a_item.C_Committee_code,
                  Committee_type: '0',
                  Committee_des: a_item.committee_des,
                  Name: a_item.full_Name,
                  Perid: a_item.perid,
                  TEL: a_item.phone,
                })
              }
            })
            this.Committee_ToShow = this.Coordinator.filter(itemLecturer => itemLecturer.Committee_code != '6' && itemLecturer.Committee_code != '23' && itemLecturer.Committee_code != '24')
            this.LecturerToShow = this.Coordinator.filter(itemLecturer => itemLecturer.Committee_code == '6' || itemLecturer.Committee_code == '23' || itemLecturer.Committee_code == '24')
            if (this.Committee_ToShow.length > 0) {
              this.Committee_ToShow.map((Committee_i, idx) => {
                Committee_i.index = (idx + 1)
              })
            }
            if (this.LecturerToShow.length > 0) {
              this.LecturerToShow.map((lecture_i, idx) => {
                lecture_i.index = (idx + 1)
              })
            }
          }
        })
      }
      setTimeout(() => {
        this.alert2 = false
      }, 5000)
      this.dialogAppointment = false
      this.AppointmentSel = ''
    },
    GetAppointmentGroupFn() {
      this.appointmentGroup = []
      this.AppointmentObj = null
      var Result = this.Appointment.filter(item => item.id == this.AppointmentSel)
      if (Result.length > 0) {
        this.AppointmentObj = Result[0]
        this.getAppointmentGroup({
          Ref_id: Result[0].Ref_id
        }).then(res => {
          if (res) {
            if (this.AppointmentGroup.length > 0) {
              this.AppointmentGroup.map(item => {
                this.appointmentGroup.push({
                  ...item,
                  full_Detail: '<span style="color: darkmagenta">' + item.full_Name + ' (' + item.perid + ')' + '</span>' + '<div><span style="color: cadetblue">' + item.dep_name + '</span></div>',
                  phone: '',
                  status: false
                })
              })
              this.dialogAppointment = true
            }
          }
        }).catch(res => {
          if (res) {
            this.$swal.fire({
              icon: 'error',
              title: 'ไม่พบข้อมูลคณะกรรมการในการแต่งตั้งกรรมการ ' + this.AppointmentObj.Topic
            })
          }
        })
      }
    },
    closeDialogAppoint() {
      this.dialogAppointment = false
      this.AppointmentSel = ''
    },
    ShowGroupDepDetail() {
      if (this.GroupSelect != '') {
        this.groupDetail = null
        this.groupDetail = this.GroupQuotaMS.filter(item => item.id == this.GroupSelect)[0]
        this.groupQuataDump = []
        this.groupQuataDump = this.GroupQuotaData.filter(itemG => itemG.group_quota_ms_id == this.GroupSelect)
        if (this.groupQuataDump.length > 0) {
          this.groupQuataDump.map(qua_i => {
            this.depart.map(depart => {
              if (qua_i.dep_id == depart.dep_id) {
                qua_i.dep_name = depart.dep_name
              }
            })
          })
        }
        this.dialogGroupDetail = true
      } else {
        this.$swal.fire({
          icon: 'error',
          title: 'กรุณาเลือกกลุ่มเทมเพลต'
        })
      }
    },
    showDialogRound() {
      this.round = ''
      this.round_name = ''
      this.dateRegS = ''
      this.dateRegE = ''
      this.time_start = ''
      this.time_end = ''
      this.DataCondi = []
      this.ChooseTypRegis = '1'
      this.ChooseTypRegis2 = '1'
      this.dateRegStart = ''
      this.dateRegEnd = ''
      this.ChkJoinPerson = true
      this.ProjectQuotaCount = ''
      this.DepQuotaData = []
      this.JoinPerson = []
      this.MessageSuc = ''
      this.ShowAlertSuc = false
      this.MessageError = ''
      this.ShowAlertErr = false
      this.staffSel = ''
      this.departSel = ''
      this.dialogRound = true
      this.RoundDataDump = null
      this.save = true
    },
    updateRoundData() {
      this.RoundData.map(Round_i => {
        if (Round_i.id == this.RoundDataDump.id) {
          Round_i.round = this.round
          Round_i.round_name = this.round_name
          Round_i.dateRegS = this.dateRegS
          Round_i.dateRegE = this.dateRegE
          Round_i.time_start = this.time_start
          Round_i.time_end = this.time_end
          Round_i.WorkAgeData = this.DataCondi
          Round_i.ChooseTypRegis = this.ChooseTypRegis
          Round_i.ChooseTypRegis2 = this.ChooseTypRegis2
          Round_i.dateRegStart = this.dateRegStart
          Round_i.dateRegEnd = this.dateRegEnd
          Round_i.ChkJoinPerson = this.ChkJoinPerson
          Round_i.ProjectQuotaCount = this.ProjectQuotaCount
          Round_i.DepQuotaData = this.DepQuotaData
          Round_i.JoinPersonData = this.JoinPerson
          Round_i.count_person = this.JoinPerson.length
        }
      })
      this.dialogRound = false
    },
    GetRoundDetail(item) {
      this.save = false
      this.RoundDataDump = null
      this.RoundDataDump = item
      this.ProjectQuotaDepCount = 0
      var RoundDump = this.RoundData.filter(Round_i => Round_i.id == item.id)
      if (RoundDump.length > 0) {
        this.round = RoundDump[0].round
        this.round_name = RoundDump[0].round_name
        this.dateRegS = RoundDump[0].dateRegS
        this.dateRegE = RoundDump[0].dateRegE
        this.time_start = RoundDump[0].time_start
        this.time_end = RoundDump[0].time_end
        this.DataCondi = RoundDump[0].WorkAgeData
        if (this.DataCondi.length > 0) {
          this.DataCondi.map(dataI => {
            dataI.workAgeStart = dataI.WSYear
            dataI.workAgeEnd = dataI.WEYear
          })
        }
        this.ChooseTypRegis = RoundDump[0].ChooseTypRegis
        this.ChooseTypRegis2 = RoundDump[0].ChooseTypRegis2
        this.dateRegStart = RoundDump[0].dateRegStart
        this.dateRegEnd = RoundDump[0].dateRegEnd
        this.ChkJoinPerson = RoundDump[0].ChkJoinPerson
        if (RoundDump[0].ProjectQuotaCount == '0') {
          this.ProjectQuotaCount = ''
        } else {
          this.ProjectQuotaCount = RoundDump[0].ProjectQuotaCount
        }

        this.DepQuotaData = RoundDump[0].DepQuotaData
        if (this.DepQuotaData.length > 0) {
          this.DepQuotaData.map(Group_I => {
            this.ProjectQuotaDepCount += parseInt(Group_I.count)
          })
        }
        this.JoinPerson = RoundDump[0].JoinPersonData
        this.JoinPerson.map(item => {
          item.idx = this.JoinPerson.length + 1
        })
      }
      this.dialogRound = true
    },
    DelRoundData(item) {
      this.RoundData.map((Round_i, idx) => {
        if (Round_i.id == item.id) {
          this.RoundData.splice(idx, 1)
        }
      })
      this.RoundDataDel.push({
        ...item,
        Ref_id: item.Ref_id
      })
    },
    SaveRoundData() {
      this.RoundData.push({
        id: this.RoundData.length + 1,
        Ref_id: Allfunc.uniqueid(),
        round: this.round,
        round_name: this.round_name,
        dateRegS: this.dateRegS,
        dateRegE: this.dateRegE,
        time_start: this.time_start,
        time_end: this.time_end,
        WorkAgeData: this.DataCondi,
        ChooseTypRegis: this.ChooseTypRegis,
        ChooseTypRegis2: this.ChooseTypRegis2,
        dateRegStart: this.dateRegStart,
        dateRegEnd: this.dateRegEnd,
        ChkJoinPerson: this.ChkJoinPerson,
        ProjectQuotaCount: this.ProjectQuotaCount,
        DepQuotaData: this.DepQuotaData,
        JoinPersonData: this.JoinPerson,
        count_person: this.JoinPerson.length
      })
      this.dialogRound = false
    },
    ExportData() {
      this.json_data = []
      this.array_title = []
      this.array_title.push(this.Project_name)
      this.array_title.push('วันที่ ' + Vue.filter('DateToThai')(this.DateStart) + ' ถึง ' + Vue.filter('DateToThai')(this.DateEnd))
      this.array_title.push('สถานที่ ' + this.Location)
      if (this.JoinPerson.length > 0) {
        var JoinPersonDump = this.JoinPerson.sort((a, b) => a.dep_id.localeCompare(b.dep_id));
        JoinPersonDump.map((item, idx) => {
          if (parseInt(item.salary) > 20000) {
            this.json_data.push({
              ...item,
              index: idx + 1,
              money_permiss: '15500'
            })
          } else {
            this.json_data.push({
              ...item,
              index: idx + 1,
              money_permiss: '11000'
            })
          }
        })
      }
    },
    GetPlanToForm() {
      this.Project_code = ''
      this.Project_name = ''
      this.Project_code_dump = ''
      this.Course_code = ''
      this.course_group = ''
      this.Project_type = ''
      this.Remarks = ''
      this.CalCredit = '0'
      this.CalHourse = '0'
      this.PLACE = ''
      this.Province_id = ''
      this.Country_id = ''
      this.BudgetRequest = '0'
      this.Location = ''
      this.WorkBy = ''
      this.WorkByName = ''
      this.DateStart = ''
      this.DateEnd = ''
      this.DepSelect = null
      this.Project_group = ''
      this.FiscalYear = ''
      this.itemCode = ''
      this.IsPlan = ''
      if (this.ProjectPlan != '') {
        axios.get(ConstData.ConnectionHost + '/app-api/v2/?/apis/hrtrain/D_project_view/Project_code/' + this.ProjectPlan).then(res => {
          if (res.data) {
            this.Project_code = res.data.Project_code
            this.Project_code_dump = res.data.Project_code
            this.Project_name = res.data.Project_name
            if (res.data.Course_code == '' || res.data.Course_code == null) {
              this.Course_code = '0000000'
            } else {
              this.Course_code = res.data.Course_code
            }
            this.course_group = res.data.Course_group
            this.Project_type = res.data.Project_type
            this.Remarks = res.data.Remarks
            this.CalCredit = res.data.CalCredit
            this.CalHourse = res.data.CalHourse
            this.PLACE = res.data.PLACE
            this.Province_id = res.data.Province_id
            this.Country_id = res.data.Country_id
            this.BudgetRequest = res.data.BudgetRequest
            this.Location = res.data.Location
            this.WorkBy = res.data.WorkBy
            this.WorkByName = res.data.WorkByName
            this.DateStart = res.data.DateStart
            this.DateEnd = res.data.DateEnd
            this.DepSelect = res.data.Dep_Code
            this.Project_group = res.data.Project_group
            this.FiscalYear = parseInt(res.data.FiscalYear)
            this.IsPlan = res.data.IsPlan
            this.itemCode = res.data.Item_Code

            this.SelProjectGroup()
            this.getCourseType()

            axios.get(ConstData.ConnectionHost + '/app-api/v2/?/apis/hrtrain/D_project_files/Type/0/Project_code/' + this.ProjectPlan).then(res => {
              if (res.data) {
                if (res.data.length > 0) {
                  res.data.map((item) => {
                    switch (item.File_type) {
                      case 'image/jpg':
                      case 'image/jpeg':
                      case 'image/gif':
                      case 'image/bmp':
                      case 'image/png':
                        this.FileProject.push({
                          id: item.id,
                          name: item.File_name,
                          src: ConstData.ConnectionHost + '/rest/files' + item.File_path,
                          path: item.File_path,
                          type: 'image',
                          type_Img: item.File_type
                        })
                        break
                      case 'application/pdf':
                        this.FileProject.push({
                          id: item.id,
                          name: item.File_name,
                          src: ConstData.ConnectionHost + '/rest/files' + item.File_path,
                          path: item.File_path,
                          type: 'pdf',
                          type_Img: item.File_type
                        })
                        break
                      default:
                        break
                    }
                  })
                } else {
                  switch (res.data.File_type) {
                    case 'image/jpg':
                    case 'image/jpeg':
                    case 'image/gif':
                    case 'image/bmp':
                    case 'image/png':
                      this.FileProject.push({
                        id: res.data.id,
                        name: res.data.File_name,
                        src: ConstData.ConnectionHost + '/rest/files' + res.data.File_path,
                        path: res.data.File_path,
                        type: 'image',
                        type_Img: res.data.File_type
                      })
                      break
                    case 'application/pdf':
                      this.FileProject.push({
                        id: res.data.id,
                        name: res.data.File_name,
                        src: ConstData.ConnectionHost + '/rest/files' + res.data.File_path,
                        path: res.data.File_path,
                        type: 'pdf',
                        type_Img: res.data.File_type
                      })
                      break
                    default:
                      break
                  }
                }
              } else {
                this.FileProject = []
              }
            })

          }
        })
      }
    },
    CheckCourseClear() {
      this.course_group = ''
      this.Project_code = ''
      this.Period_code = 0
      this.CalHourse = 0
      this.CalCredit = 0
    },
    ClearData() {
      this.PlanProject_code = ''
      this.ProjectPlan = ''
      this.Project_code = ''
      this.Project_name = ''
      this.Course_code = '0000000'
      this.course_group = ''
      this.Project_type = ''
      this.Remarks = ''
      this.CalCredit = '0'
      this.CalHourse = '0'
      this.PLACE = ''
      this.Province_id = ''
      this.Country_id = ''
      this.BudgetRequest = '0'
      this.Location = ''
      this.WorkBy = ''
      this.WorkByName = ''
      this.DateStart = ''
      this.DateEnd = ''
      this.DepSelect = null
      this.Project_group = ''
      this.FiscalYear = ''
      this.itemCode = ''
      this.FileProject = []
      this.files = []
    },
    GetCurrentDate() {
      var today = new Date();
      var dd = today.getDate();
      var mm = today.getMonth() + 1; //January is 0!

      var yyyy = today.getFullYear();
      if (dd < 10) {
        dd = '0' + dd;
      }
      if (mm < 10) {
        mm = '0' + mm;
      }

      return today = yyyy + '-' + mm + '-' + dd;
    },
    DaysInMonth(anyDateInMonth) {
      return new Date(anyDateInMonth.getFullYear(),
          anyDateInMonth.getMonth() + 1,
          0).getDate()
    },
    getAge(date_1, date_2) {
      //convert to UTC
      var arrayWorkSummary = [];
      var date2_UTC = new Date(Date.UTC(date_2.getUTCFullYear(), date_2.getUTCMonth(), date_2.getUTCDate()));
      var date1_UTC = new Date(Date.UTC(date_1.getUTCFullYear(), date_1.getUTCMonth(), date_1.getUTCDate()));


      //--------------------------------------------------------------
      var days = date2_UTC.getDate() - date1_UTC.getDate();
      if (days < 0) {

        date2_UTC.setMonth(date2_UTC.getMonth() - 1);
        days += this.DaysInMonth(date2_UTC);
      }
      //--------------------------------------------------------------
      var months = date2_UTC.getMonth() - date1_UTC.getMonth();
      if (months < 0) {
        date2_UTC.setFullYear(date2_UTC.getFullYear() - 1);
        months += 12;
      }
      //--------------------------------------------------------------
      var years = date2_UTC.getFullYear() - date1_UTC.getFullYear();

      arrayWorkSummary.push(years);
      arrayWorkSummary.push(months);
      arrayWorkSummary.push(days);

      return arrayWorkSummary;
    },
    AddDepQuotaData() {
      var CheckMatch = false
      var Depart = []
      var type = ''
      if (this.ChooseTypeDep == '3') {

        var count = this.GroupQuotaData.reduce((prev, cur) => prev + parseInt(cur.count), 0)

        if (!this.ChkJoinPerson && ((parseInt(count) + parseInt(this.ProjectQuotaDepCount)) > parseInt(this.ProjectQuotaCount))) {
          this.$swal.fire({
            icon: 'error',
            title: 'ไม่สามารถบันทึกโควต้าข้อมูลหน่วยงานได้เนื่องจากเกินจำนวนผู้เข้าร่วมที่กำหนด'
          })
        } else {
          this.GroupQuotaData.map((Group_I, idx) => {
            CheckMatch = false
            if (this.DepQuotaData.length > 0) {
              this.DepQuotaData.map(itemDepQ => {
                if (itemDepQ.type_id == '0') {
                  if (Group_I.dep_id == itemDepQ.dep_id) {
                    CheckMatch = true
                  }
                } else {
                  Depart = this.depart.filter(item => item.dep_group_id == itemDepQ.dep_group_id)
                  if (Depart.filter(item => item.dep_id == Group_I.dep_id).length > 0) {
                    CheckMatch = true
                  }
                }
              })

              if (!CheckMatch) {
                this.DepQuotaData.push({
                  quotaType: '0',
                  type: 'หน่วยงาน/ภาควิชา',
                  type_id: '0',
                  dep_name: this.depart.filter(item => item.dep_id == Group_I.dep_id)[0].dep_name,
                  dep_id: this.depart.filter(item => item.dep_id == Group_I.dep_id)[0].dep_id,
                  dep_group_id: this.depart.filter(item => item.dep_id == Group_I.dep_id)[0].dep_group_id,
                  count: Group_I.count
                })

                this.ProjectQuotaDepCount += parseInt(Group_I.count)
              }
            } else {
              this.DepQuotaData.push({
                quotaType: '0',
                type: 'หน่วยงาน/ภาควิชา',
                type_id: '0',
                dep_name: this.depart.filter(item => item.dep_id == Group_I.dep_id)[0].dep_name,
                dep_id: this.depart.filter(item => item.dep_id == Group_I.dep_id)[0].dep_id,
                dep_group_id: this.depart.filter(item => item.dep_id == Group_I.dep_id)[0].dep_group_id,
                count: Group_I.count
              })

              this.ProjectQuotaDepCount += parseInt(Group_I.count)
            }

            if (idx == this.GroupQuotaData.length - 1) {
              this.GroupSelect = ''
            }
          })

        }

        ///////////////////////////////////////////////////////

      } else {
        if (this.DepQuotaSelect != '' && this.DepQuotaCount != '') {
          if (!this.ChkJoinPerson && ((parseInt(this.DepQuotaCount) + parseInt(this.ProjectQuotaDepCount)) > parseInt(this.ProjectQuotaCount))) {
            this.$swal.fire({
              icon: 'error',
              title: 'ไม่สามารถบันทึกโควต้าข้อมูลหน่วยงานได้เนื่องจากเกินจำนวนผู้เข้าร่วมที่กำหนด'
            })
          } else {
            if (parseInt(this.DepQuotaCount) > 0) {
              if (this.DepQuotaData.length > 0) {
                this.DepQuotaData.map(itemDepQ => {
                  if (itemDepQ.type_id == '0') {
                    if (this.ChooseTypeDep == '0') {
                      if (this.DepQuotaSelect == itemDepQ.dep_id) {
                        CheckMatch = true
                      }
                    } else {
                      Depart = this.depart.filter(item => item.dep_group_id == this.DepQuotaSelect)
                      if (Depart.filter(item => item.dep_id == itemDepQ.dep_id).length > 0) {
                        CheckMatch = true
                      }
                    }
                  } else {
                    Depart = this.depart.filter(item => item.dep_group_id == itemDepQ.dep_group_id)
                    if (Depart.filter(item => item.dep_id == this.DepQuotaSelect).length > 0) {
                      CheckMatch = true
                    }
                  }
                })

                if (CheckMatch) {
                  this.$swal.fire({
                    icon: 'error',
                    title: 'พบข้อมูลหน่วยงาน อยู่แล้วไม่สามารถบันทึกข้อมูลหน่วยงานเพิ่มได้อีก'
                  })
                } else {
                  if (this.ChooseTypeDep == '0') {
                    type = 'หน่วยงาน/ภาควิชา'
                  } else {
                    type = 'กลุ่มหน่วยงาน/กลุ่มภาควิชา'
                  }
                  this.DepQuotaData.push({
                    quotaType: this.ChooseTypeDep,
                    type: type,
                    type_id: this.ChooseTypeDep,
                    dep_name: this.depart.filter(item => item.dep_id == this.DepQuotaSelect)[0].dep_name,
                    dep_id: this.depart.filter(item => item.dep_id == this.DepQuotaSelect)[0].dep_id,
                    dep_group_id: this.depart.filter(item => item.dep_id == this.DepQuotaSelect)[0].dep_group_id,
                    count: this.DepQuotaCount
                  })

                  this.ProjectQuotaDepCount += parseInt(this.DepQuotaCount)
                  this.DepQuotaSelect = ''
                  this.DepQuotaCount = ''
                }
              } else {
                if (this.ChooseTypeDep == '0') {
                  type = 'หน่วยงาน/ภาควิชา'
                } else {
                  type = 'กลุ่มหน่วยงาน/กลุ่มภาควิชา'
                }
                this.DepQuotaData.push({
                  quotaType: this.ChooseTypeDep,
                  type: type,
                  type_id: this.ChooseTypeDep,
                  dep_name: this.depart.filter(item => item.dep_id == this.DepQuotaSelect)[0].dep_name,
                  dep_id: this.depart.filter(item => item.dep_id == this.DepQuotaSelect)[0].dep_id,
                  dep_group_id: this.depart.filter(item => item.dep_id == this.DepQuotaSelect)[0].dep_group_id,
                  count: this.DepQuotaCount
                })

                this.ProjectQuotaDepCount += parseInt(this.DepQuotaCount)
                this.DepQuotaSelect = ''
                this.DepQuotaCount = ''
              }
            } else {
              this.$swal.fire({
                icon: 'error',
                title: 'กรุณาระบุจำนวนผู้เข้าร่วมอย่างน้อย 1 คน'
              })
            }
          }
        } else {
          this.$swal.fire({
            icon: 'error',
            title: 'กรุณาระบุข้อมูลหน่วยงาน และจำนวนผู้เข้าร่วมให้ครบถ้วน'
          })
        }
      }
    },
    RemoveQuotaDep() {
      if (this.DepQuotaData.length > 0) {
        this.DepQuotaData = []
      }
      this.ProjectQuotaDepCount = 0
    },
    RemoveJoinProject() {
      if (this.JoinPerson.length > 0) {
        this.JoinPerson = []
      }
    },
    UniqueArraybyId(collection, keyname) {
      var output = [],
          keys = [];

      collection.map((item) => {
        var key = item[keyname];
        if (keys.indexOf(key) === -1) {
          keys.push(key);
          output.push(item);
        }
      });
      return output;
    },
    CheckPlace() {
      if (this.PLACE == '2') {
        this.Country_id = ''
      } else if (this.PLACE == '3') {
        this.Province_id = ''
      }
    },
    CheckKeyPress(event) {
      if (event.key == "Enter") {
        console.log('here')
      }
    },
    ExecForm() {
      if (this.ChooseForm == 'OldForm') {
        this.editorData = this.editorDataFormDB.replaceAll('&quot;', '"')
      } else {
        this.getFormGenerate()
      }
    },
    ShowDetailLecturer(item) {
      this.LecturerDetail = []
      this.LecturerDetail = this.WorkGroupData.filter(L_item => L_item.perid == item.Perid && L_item.type == item.Committee_code)
      this.dialogLecturerDetail = true
    },
    onProgress(evt) {
      console.log(evt)
      this.percent = 0
      this.percent = evt
    },
    hasGenerated(evt) {
      console.log(evt)
    },
    hasStartedGeneration(evt) {
      console.log(evt)
    },
    generateReport() {
      this.$refs.html2Pdf.generatePdf()
    },
    async ExportToDocx() {
      var preHtml = "<html xmlns:o='urn:schemas-microsoft-com:office:office' xmlns:w='urn:schemas-microsoft-com:office:word' xmlns='http://www.w3.org/TR/REC-html40'><head><meta charset='utf-8'><title>Export HTML To Doc</title></head><body>";
      var postHtml = "</body></html>";
      var html = preHtml+ (this.form1 ? this.editorData : this.editorData2) +postHtml;

      var blob = new Blob(['\ufeff', html], {
        type: 'application/msword'
      });

      // Specify link url
      var url = 'data:application/vnd.ms-word;charset=utf-8,' + encodeURIComponent(html);

      // Specify file name
      var filename = (this.form1 ? 'ฟอร์มตัวอย่างโครงการ' : 'ใบปะหน้าบันทึกข้อความ') + '.doc';

      // Create download link element
      var downloadLink = document.createElement("a");

      document.body.appendChild(downloadLink);

      if(navigator.msSaveOrOpenBlob ){
        navigator.msSaveOrOpenBlob(blob, filename);
      }else{
        // Create a link to the file
        downloadLink.href = url;

        // Setting the file name
        downloadLink.download = filename;

        //triggering the function
        downloadLink.click();
      }

      document.body.removeChild(downloadLink);
    },
    ShowTemplate() {
      // this.dialogTemplate = true
      // this.generateReport()
      let routeData = this.$router.resolve({name: 'PrintData', query: {data: (this.form1 ? this.editorData : this.editorData2)}});
      window.open(routeData.href, '_blank', 'location=yes,height=800,width=800,scrollbars=yes,status=yes');
    },
    SelProjectGroup() {
      if (this.Project_group == '108' || this.Project_group == '109') {
        this.rdoRegisterProject = '1'
        if (this.JoinPerson.length > 0) {
          this.JoinPerson.map(item => {
            item.status_reg = '1'
          })
        }
      } else {
        this.rdoRegisterProject = '0'
        if (this.JoinPerson.length > 0) {
          this.JoinPerson.map(item => {
            item.status_reg = '0'
          })
        }
      }
      if (this.projectGroup.filter(item => item.Project_group == this.Project_group).length > 0) {
        this.projectGroupToShow = this.projectGroup.filter(item => item.Project_group == this.Project_group)[0].Project_group_des
      } else {
        this.projectGroupToShow = ''
      }
    },
    AddWorkGuest() {
      // if (this.SubjectForLecturer != '' && this.dateSForLecturer != ''
      //     && this.dateSTravelForLecturer != '' && this.dateETravelForLecturer != ''
      //     && this.dateEForLecturer != '' && this.timeSForLecturer != ''
      //     && this.timeEForLecturer != '') {
      if (this.SubjectForLecturer != '' && this.dateSForLecturer != '' && this.LecturerProjectName != '' && this.LecturerHour != '' && this.LecturerInvite != ''
          && this.LecturerPlace != '' && this.LecturerDocNo != '' && this.LecturerDateDocOut != ''
          && this.LecturerDateStart != '' && this.LecturerTimeStart != '' && this.LecturerDateEnd != '' && this.LecturerTimeEnd != '') {
        this.Lecturer.push({
          id: this.Lecturer.length,
          perid: this.perid,
          subject: this.SubjectForLecturer,
          date_start: this.dateSForLecturer,
          date_end: this.dateEForLecturer,
          time_start: this.timeSForLecturer,
          time_end: this.timeEForLecturer,
          full_Name: this.staffData.filter(item => item.perid == this.perid)[0].full_Name,
          date_travel_start: this.dateSTravelForLecturer,
          date_travel_end: this.dateETravelForLecturer,
          type: this.Committee_code,
          type_name: this.committee_Posi.filter(item => item.Committee_code == this.Committee_code)[0].committee_des,
          files: this.FileProjectExpert,
          Rm: this.Rm2,
          Lecturer: (this.Committee_code == '6' || this.Committee_code == '23' || this.Committee_code == '24') ? {
            Project_name: this.LecturerProjectName,
            Hour: this.LecturerHour,
            Invite: this.LecturerInvite,
            Place: this.LecturerPlace,
            DocNo: this.LecturerDocNo,
            DateDocNo: this.LecturerDateDocOut,
            DateStart: this.LecturerDateStart,
            TimeStart: this.LecturerTimeStart,
            DateEnd: this.LecturerDateEnd,
            TimeEnd: this.LecturerTimeEnd,
          } : null
        })
        this.SubjectForLecturer = ''
        this.dateSTravelForLecturer = ''
        this.dateETravelForLecturer = ''
        this.dateSForLecturer = ''
        this.dateEForLecturer = ''
        this.timeSForLecturer = ''
        this.timeEForLecturer = ''
        this.LecturerProjectName = ''
        this.LecturerHour = ''
        this.LecturerInvite = ''
        this.LecturerPlace = ''
        this.LecturerDocNo = ''
        this.LecturerDateDocOut = ''
        this.LecturerDateStart = ''
        this.LecturerTimeStart = ''
        this.LecturerDateEnd = ''
        this.LecturerTimeEnd = ''
        this.FileProjectExpert = []
        this.filesExpert = []
        this.txtAlertExpert = []
        this.Rm2 = ''
      } else {
        this.$swal.fire({
          icon: 'error',
          title: 'กรุณาระบุข้อมูลให้ครบถ้วน'
        })
      }
    },
    DocumentExec() {
      this.formprint1 = this.editorData
      // axios({
      //   url: 'http://localhost:3006/exec/test', //your url
      //   method: 'GET',
      //   responseType: 'blob', // important
      // }).then((response) => {
      //   const url = window.URL.createObjectURL(new Blob([response.data]));
      //   const link = document.createElement('a');
      //   link.href = url;
      //   link.setAttribute('download', 'file.docx'); //or any other extension
      //   document.body.appendChild(link);
      //   link.click();
      // });
    },
    PrintForm() {
      axios.post('http://localhost:3006/exec/docx', {
        data: {
          val1: this.formprint1, // หลักการและเหตุผล
          val2: this.formprint2, // วัตถุประสงค์
          val3: this.formprint3, // กลุ่มเป้าหมาย
          val4: this.formprint4, // วิธีการจัดอบรม
          val5: this.formprint5, // ระยะเวลาการจัดอบรม
          val6: this.formprint6, // สถานที่จัดอบรม
          val7: this.formprint7, // ผลที่คาดว่าจะได้รับ
          val8: this.formprint8, // ผู้รับผิดชอบโครงการ
          val9: this.formprint9, // ผู้รับผิดชอบโครงการ
          val10: this.formprint10, // วิทยากร
          val11: this.formprint11, // งบประมาณ
          val12: this.formprint12, // หมายเหตุ
          budget: this.budgetData,
          Lecturer: this.LecturerToShow,
          Committee: this.Committee_ToShow,
          projectGroup: this.projectGroupToShow,
          projectname: this.Project_name,
          projectcode: '01010-0220-1541'
        }
      }).then((res) => {
        console.log(res.data)
      })
      // axios({
      //   url: 'http://localhost:3006/exec/test', //your url
      //   method: 'GET',
      //   responseType: 'blob', // important
      // }).then((response) => {
      //   const url = window.URL.createObjectURL(new Blob([response.data]));
      //   const link = document.createElement('a');
      //   link.href = url;
      //   link.setAttribute('download', 'file.pdf'); //or any other extension
      //   document.body.appendChild(link);
      //   link.click();
      // });
      // this.$htmlToPaper('printForm');
      // this.MangeTextForPrint({
      //     process: 'SET',
      //     message: this.editorData
      // }).then(res => {
      //     if (res) {
      //         // console.log(this.textForPrint)
      //         this.$router.push({name: 'PrintFormProject'});
      //         // window.open(routeData.href, '_blank');
      //         // console.log('------------------------------------')
      //         // console.log(this.textForPrint)
      //
      //     }
      // })
    },
    onReady(editor) {
      // Insert the toolbar before the editable area.
      editor.ui.getEditableElement().parentElement.insertBefore(
          editor.ui.view.toolbar.element,
          editor.ui.getEditableElement()
      );
    },
    save() {
      this.snack = true
      this.snackColor = 'success'
      this.snackText = 'Data saved'
    },
    cancel() {
      this.snack = true
      this.snackColor = 'error'
      this.snackText = 'Canceled'
    },
    open() {
      this.snack = true
      this.snackColor = 'info'
      this.snackText = 'Dialog opened'
    },
    close() {
      console.log('Dialog closed')
    },
    AddExpenseData() {
      if (this.BudgetRequest != '') {
        if (this.expenseCost == '' && this.ReqMoney == '') {
          this.$swal.fire({
            icon: 'error',
            title: 'กรุณาระบุรายการค่าใช้จ่าย และ จำนวนเงิน ให้ครบถ้วน'
          })
        } else {
          if ((this.Expense + parseInt(this.ReqMoney)) > parseInt(this.BudgetRequest)) {
            this.$swal.fire({
              icon: 'error',
              title: 'กรุณาระบุค่าใช้จ่าย ห้ามเกินงบประมาณที่ขอในการจัดทำโครงการ'
            })
          } else {
            this.Expense += parseInt(this.ReqMoney)
            var ResultExpenseData = this.expense_Data.filter(item => item.cost_id == this.expenseCost)
            if (ResultExpenseData.length > 0) {
              this.budgetData.push({
                Expense_id: ResultExpenseData[0].cost_id,
                Expense_des: ResultExpenseData[0].cost_desc,
                ReqMoney: this.ReqMoney,
                Rm: this.Rm,
              })

              this.expenseCost = ''
              this.ReqMoney = ''
              this.Rm = ''
            }
          }
        }
      } else {
        this.$swal.fire({
          icon: 'error',
          title: 'กรุณาระบุงบประมาณโครงการ'
        })
      }
    },
    DelExpense(item) {
      this.budgetData.map((bud_I, idx) => {
        if (bud_I.Expense_id == item.Expense_id) {
          this.Expense -= parseInt(item.ReqMoney)
          this.budgetData.splice(idx, 1)
        }
      })
    },
    ShowDetail(item) {
      this.dialogDetail = true
      this.itemToShow = null
      this.itemToShow = item
    },
    onResize() {
      this.isMobile = window.innerWidth < 600
    },
    checkKeyEnter(event) {
      if (event.key == "Enter") {
        this.ChooseEmpolyee_s_owner()
      }
    },
    insertPersonUni() {
      this.personalMedData.map(value => {
        if (this.IdPersonal == value.STAFF_ID) {
          this.JoinPerson.push({
            ...value,
            uid: value.STAFF_ID,
            full_Name: value.STAFF_NAME_THAI + ' ' + value.STAFF_SNAME_THAI,
            name: value.STAFF_NAME_THAI,
            sname: value.STAFF_SNAME_THAI,
            idCard: value.STAFF_PERS_ID,
            affiliation: value.FAC_NAME_THAI,
            position: '',
            phone: '',
            registerType_id: 2,
          })
          this.IdPersonal = ''
        }
      })
    },
    insertStd(msg) {
      if (msg == 'med') {
        this.studentData.map(value => {
          if (this.Idstudent == value.STUDENT_ID) {
            this.JoinPerson.push({
              ...value,
              uid: value.STUDENT_ID,
              full_Name: value.STUD_NAME_THAI + ' ' + value.STUD_SNAME_THAI,
              name: value.STUD_NAME_THAI,
              sname: value.STUD_SNAME_THAI,
              idCard: value.CITIZEN_ID,
              affiliation: 'คณะแพทยศาสตร์',
              position: '',
              phone: '',
              registerType_id: 1,
            })
            this.Idstudent = ''
          }
        })
      } else {
        this.studentUniData.map(value => {
          if (this.IdstudentUni == value.STUDENT_ID) {
            this.JoinPerson.push({
              ...value,
              uid: value.STUDENT_ID,
              full_Name: value.STUD_NAME_THAI + ' ' + value.STUD_SNAME_THAI,
              name: value.STUD_NAME_THAI,
              sname: value.STUD_SNAME_THAI,
              idCard: value.CITIZEN_ID,
              affiliation: value.FAC_NAME_THAI,
              position: '',
              phone: '',
              registerType_id: 3,
            })
            this.IdstudentUni = ''
          }
        })
      }
    },
    Del_item(item) {
      this.JoinPerson = this.JoinPerson.filter(value => value.uid != item.uid)
      this.JoinPersonDel.push({
        ...item,
        Ref_id: this.RoundDataDump.Ref_id
      })
    },
    GetStdPSU() {
      this.studentUniData = []
      axios.get(ConstData.ConnectionHost + '/app-api/v2/?/apis/stdMed/STUDENT2_view/FAC_ID/' + this.IdDepartStd + '/?sort=STUDENT_ID_ASC&limit=99999').then(res => {
        if (res.data) {
          if (res.data.length > 0) {
            res.data.map(item => {
              this.studentUniData.push({
                ...item,
                fullName: 'รหัสนักศึกษา : ' + item.STUDENT_ID + ' ชื่อ-สกุล ' + item.STUD_NAME_THAI + ' ' + item.STUD_SNAME_THAI
              })
            })
          } else {
            this.studentUniData.push({
              ...res.data,
              fullName: 'รหัสนักศึกษา : ' + res.data[0].STUDENT_ID + ' ชื่อ-สกุล ' + res.data[0].STUD_NAME_THAI + ' ' + res.data[0].STUD_SNAME_THAI
            })
          }
        } else {
          this.studentUniData = []
        }
      })
    },
    GetPersonalPSU() {
      axios.get(ConstData.ConnectionHost + '/app-api/v2/?/apis/hrstd/V_STAFF/FAC_ID/' + this.IdDepart + '/?sort=STAFF_ID_ASC&limit=99999').then(res => {
        if (res.data) {
          if (res.data.length > 0) {
            res.data.map(item => {
              this.personalMedData.push({
                ...item,
                FULL_NAME: item.STAFF_NAME_THAI + ' ' + item.STAFF_SNAME_THAI
              })
            })
          } else {
            this.personalMedData.push(res.data)
          }
        } else {
          this.personalMedData = []
        }
      })
    },
    ChooseEmp(item) {
      if (!item.switch) {
        item.switch = true
        if (item.header) {
          if (item.children.length > 0) {
            item.children.map((child_i) => {
              if (item.switch) {
                child_i.switch = true
              } else {
                child_i.switch = false
              }
              this.EmpData.push(child_i)
            })
          }
        } else {
          this.EmpData.push(item)

        }
      } else {
        item.switch = false
        if (item.header) {
          this.EmpData = []
          if (item.children.length > 0) {
            item.children.map((child_i) => {
              child_i.switch = false
            })
          }
        } else {
          if (this.EmpData.length > 0) {
            this.EmpData.map((Emp_i, idx) => {
              if (Emp_i.perid == item.perid) {
                this.EmpData.splice(idx, 1)
              }
            })
          }
        }
      }
    },
    ChooseEmpolyee_c(event) {
      var GetData = []
      if (event.key == "Enter") {
        GetData = this.CardData.filter(value => value.CARD_NO == this.cardSel)
        if (GetData.length > 0) {
          GetData = this.staffData.filter(value => value.perid == GetData[0].PERID)
          this.JoinPerson.push({
            ...GetData[0],
            uid: GetData[0].perid,
            name: GetData[0].name,
            sname: GetData[0].surname,
            idCard: GetData[0].citizen_id,
            affiliation: GetData[0].dep_name,
            position: '',
            phone: '',
            registerType_id: 0,
          })
          this.cardSel = ''
        }
      }
    },
    ChooseEmpolyee_s() {
      var CheckDupe = false
      var CheckDepMatch = false
      // var CheckQuotaProject = false
      var CheckGroupExample = []
      if (!this.ChkJoinPerson && this.JoinPerson.length >= parseInt(this.ProjectQuotaCount)) {
        this.$swal.fire({
          icon: 'error',
          title: 'ไม่สามารถบันทึกข้อมูลได้ เนื่องจากจำนวนผู้เข้าร่วมเกินจำนวนที่โครงการกำหนด'
        })
      } else {
        this.staffData.map((staff_I) => {
          if (staff_I.perid == this.staffSel) {
            if (this.DataCondi.length > 0) {
              CheckGroupExample = this.DataCondi.filter(item => item.PosCode == staff_I.pos_id && this.getAge(new Date(staff_I.date_in), new Date())[0] >= item.workAgeStart && this.getAge(new Date(staff_I.date_in), new Date())[0] <= item.workAgeEnd)

              if (CheckGroupExample.length > 0) {
                if (this.DepQuotaData.length > 0) {
                  this.DepQuotaData.map((dep_quota, idx) => {
                    if (dep_quota.type_id == '0' && !CheckDepMatch) {
                      if (staff_I.dep_id == dep_quota.dep_id) {
                        CheckDepMatch = true
                        if (this.JoinPerson.length > 0) {
                          if (this.JoinPerson.filter(item => item.dep_id == staff_I.dep_id).length < parseInt(dep_quota.count)) {
                            if (this.JoinPerson.filter(item => item.uid == staff_I.perid).length > 0) {
                              CheckDupe = true
                            }

                            if (!CheckDupe) {
                              this.JoinPerson.unshift({
                                ...staff_I,
                                uid: staff_I.perid,
                                name: staff_I.name,
                                sname: staff_I.surname,
                                idCard: staff_I.citizen_id,
                                affiliation: staff_I.dep_name,
                                status_reg: this.rdoRegisterProject,
                                position: '',
                                phone: '',
                                registerType_id: 0,
                              })
                              this.staffSel = ''
                            } else {
                              this.staffSel = ''
                              this.$swal.fire({
                                icon: 'error',
                                title: 'ไม่สามารถบันทึกข้อมูลได้ เนื่องจากมีข้อมูลในระบบอยู่แล้ว'
                              })
                            }
                          } else {
                            this.staffSel = ''
                            this.$swal.fire({
                              icon: 'error',
                              title: 'ไม่สามารถบันทึกข้อมูลได้ เนื่องจากจำนวนผู้เข้าร่วมของหน่วยงาน ' + staff_I.dep_name + ' เกินกำหนดที่ตั้งไว้'
                            })
                          }
                        } else {
                          if (this.JoinPerson.filter(item => item.uid == staff_I.perid).length > 0) {
                            CheckDupe = true
                          }
                          if (!CheckDupe) {
                            this.JoinPerson.unshift({
                              ...staff_I,
                              uid: staff_I.perid,
                              name: staff_I.name,
                              sname: staff_I.surname,
                              idCard: staff_I.citizen_id,
                              affiliation: staff_I.dep_name,
                              status_reg: this.rdoRegisterProject,
                              position: '',
                              phone: '',
                              registerType_id: 0,
                            })
                            this.staffSel = ''
                          } else {
                            this.staffSel = ''
                            this.$swal.fire({
                              icon: 'error',
                              title: 'ไม่สามารถบันทึกข้อมูลได้ เนื่องจากมีข้อมูลในระบบอยู่แล้ว'
                            })
                          }
                        }
                      } else {
                        if (!CheckDepMatch && idx == this.DepQuotaData.length - 1) {
                          if (this.ChkJoinPerson) {
                            if (this.JoinPerson.filter(item => item.uid == staff_I.perid).length > 0) {
                              CheckDupe = true
                            }
                            if (!CheckDupe) {
                              this.JoinPerson.unshift({
                                ...staff_I,
                                uid: staff_I.perid,
                                name: staff_I.name,
                                sname: staff_I.surname,
                                idCard: staff_I.citizen_id,
                                affiliation: staff_I.dep_name,
                                status_reg: this.rdoRegisterProject,
                                position: '',
                                phone: '',
                                registerType_id: 0,
                              })
                              this.staffSel = ''
                            } else {
                              this.staffSel = ''
                              this.$swal.fire({
                                icon: 'error',
                                title: 'ไม่สามารถบันทึกข้อมูลได้ เนื่องจากมีข้อมูลในระบบอยู่แล้ว'
                              })
                            }
                          } else {
                            if ((this.JoinPerson.length + parseInt(this.ProjectQuotaDepCount)) < parseInt(this.ProjectQuotaCount)) {
                              if (this.JoinPerson.filter(item => item.uid == staff_I.perid).length > 0) {
                                CheckDupe = true
                              }
                              if (!CheckDupe) {
                                this.JoinPerson.unshift({
                                  ...staff_I,
                                  uid: staff_I.perid,
                                  name: staff_I.name,
                                  sname: staff_I.surname,
                                  idCard: staff_I.citizen_id,
                                  affiliation: staff_I.dep_name,
                                  status_reg: this.rdoRegisterProject,
                                  position: '',
                                  phone: '',
                                  registerType_id: 0,
                                })
                                this.staffSel = ''
                              } else {
                                this.staffSel = ''
                                this.$swal.fire({
                                  icon: 'error',
                                  title: 'ไม่สามารถบันทึกข้อมูลได้ เนื่องจากมีข้อมูลในระบบอยู่แล้ว'
                                })
                              }
                            } else {
                              this.staffSel = ''
                              this.$swal.fire({
                                icon: 'error',
                                title: 'ไม่สามารถบันทึกข้อมูลได้ เนื่องจากหมดโควต้าบุคคลกรทั่วไปที่ไม่อยู่ภายใต้เงื่อนไข'
                              })
                            }
                          }
                        }
                      }
                    } else {
                      //// ตรงนี้ต้องเช็ค
                      if (!CheckDepMatch) {
                        var DepGroup = this.depart.filter(item => item.dep_group_id == dep_quota.dep_id)
                        if (DepGroup.length > 0) {
                          if (DepGroup.filter(item => item.dep_id == staff_I.dep_id).length > 0) {
                            CheckDepMatch = true
                            if (this.JoinPerson.length > 0) {
                              if (this.JoinPerson.filter(item => item.dep_group_id == staff_I.dep_group_id).length < parseInt(dep_quota.count)) {
                                if (this.JoinPerson.filter(item => item.uid == staff_I.perid).length > 0) {
                                  CheckDupe = true
                                }
                                if (!CheckDupe) {
                                  this.JoinPerson.unshift({
                                    ...staff_I,
                                    uid: staff_I.perid,
                                    name: staff_I.name,
                                    sname: staff_I.surname,
                                    idCard: staff_I.citizen_id,
                                    affiliation: staff_I.dep_name,
                                    status_reg: this.rdoRegisterProject,
                                    position: '',
                                    phone: '',
                                    registerType_id: 0,
                                  })
                                  this.staffSel = ''
                                } else {
                                  this.staffSel = ''
                                  this.$swal.fire({
                                    icon: 'error',
                                    title: 'ไม่สามารถบันทึกข้อมูลได้ เนื่องจากมีข้อมูลในระบบอยู่แล้ว'
                                  })
                                }
                              } else {
                                this.staffSel = ''
                                this.$swal.fire({
                                  icon: 'error',
                                  title: 'ไม่สามารถบันทึกข้อมูลได้ เนื่องจากจำนวนผู้เข้าร่วมของ(กลุ่มหน่วยงาน/กลุ่มภาควิชา) ' + staff_I.dep_name + ' เกินกำหนดที่ตั้งไว้'
                                })
                              }
                            } else {
                              this.JoinPerson.unshift({
                                ...staff_I,
                                uid: staff_I.perid,
                                name: staff_I.name,
                                sname: staff_I.surname,
                                idCard: staff_I.citizen_id,
                                affiliation: staff_I.dep_name,
                                status_reg: this.rdoRegisterProject,
                                position: '',
                                phone: '',
                                registerType_id: 0,
                              })
                              this.staffSel = ''
                            }
                          }
                        }
                      }
                    }
                  })
                } else {
                  if (this.JoinPerson.filter(item => item.uid == staff_I.perid).length > 0) {
                    CheckDupe = true
                  }
                  if (!CheckDupe) {
                    this.JoinPerson.unshift({
                      ...staff_I,
                      uid: staff_I.perid,
                      name: staff_I.name,
                      sname: staff_I.surname,
                      idCard: staff_I.citizen_id,
                      affiliation: staff_I.dep_name,
                      status_reg: this.rdoRegisterProject,
                      position: '',
                      phone: '',
                      registerType_id: 0,
                    })
                    this.staffSel = ''
                  } else {
                    this.staffSel = ''
                    this.$swal.fire({
                      icon: 'error',
                      title: 'ไม่สามารถบันทึกข้อมูลได้ เนื่องจากมีข้อมูลในระบบอยู่แล้ว'
                    })
                  }
                }
              } else {
                this.$swal.fire({
                  icon: 'error',
                  title: 'ไม่สามารถบันทึกข้อมูลได้ เนื่องจากเงื่อนไขอายุงานกลุ่มตัวอย่าง ไม่ตรงกับอายุงานของบุคลากรที่เลือก'
                })
              }
            } else if (this.DepQuotaData.length > 0) {
              this.DepQuotaData.map((dep_quota, idx) => {
                if (dep_quota.type_id == '0' && !CheckDepMatch) {
                  if (staff_I.dep_id == dep_quota.dep_id) {
                    CheckDepMatch = true
                    if (this.JoinPerson.length > 0) {
                      if (this.JoinPerson.filter(item => item.dep_id == staff_I.dep_id).length < parseInt(dep_quota.count)) {
                        if (this.JoinPerson.filter(item => item.uid == staff_I.perid).length > 0) {
                          CheckDupe = true
                        }

                        if (!CheckDupe) {
                          this.JoinPerson.unshift({
                            ...staff_I,
                            uid: staff_I.perid,
                            name: staff_I.name,
                            sname: staff_I.surname,
                            idCard: staff_I.citizen_id,
                            affiliation: staff_I.dep_name,
                            status_reg: this.rdoRegisterProject,
                            position: '',
                            phone: '',
                            registerType_id: 0,
                          })
                          this.staffSel = ''
                        } else {
                          this.staffSel = ''
                          this.$swal.fire({
                            icon: 'error',
                            title: 'ไม่สามารถบันทึกข้อมูลได้ เนื่องจากมีข้อมูลในระบบอยู่แล้ว'
                          })
                        }
                      } else {
                        this.staffSel = ''
                        this.$swal.fire({
                          icon: 'error',
                          title: 'ไม่สามารถบันทึกข้อมูลได้ เนื่องจากจำนวนผู้เข้าร่วมของหน่วยงาน ' + staff_I.dep_name + ' เกินกำหนดที่ตั้งไว้'
                        })
                      }
                    } else {
                      if (this.JoinPerson.filter(item => item.uid == staff_I.perid).length > 0) {
                        CheckDupe = true
                      }
                      if (!CheckDupe) {
                        this.JoinPerson.unshift({
                          ...staff_I,
                          uid: staff_I.perid,
                          name: staff_I.name,
                          sname: staff_I.surname,
                          idCard: staff_I.citizen_id,
                          affiliation: staff_I.dep_name,
                          status_reg: this.rdoRegisterProject,
                          position: '',
                          phone: '',
                          registerType_id: 0,
                        })
                        this.staffSel = ''
                      } else {
                        this.staffSel = ''
                        this.$swal.fire({
                          icon: 'error',
                          title: 'ไม่สามารถบันทึกข้อมูลได้ เนื่องจากมีข้อมูลในระบบอยู่แล้ว'
                        })
                      }
                    }
                  } else {
                    if (!CheckDepMatch && idx == this.DepQuotaData.length - 1) {
                      if (this.ChkJoinPerson) {
                        if (this.JoinPerson.filter(item => item.uid == staff_I.perid).length > 0) {
                          CheckDupe = true
                        }
                        if (!CheckDupe) {
                          this.JoinPerson.unshift({
                            ...staff_I,
                            uid: staff_I.perid,
                            name: staff_I.name,
                            sname: staff_I.surname,
                            idCard: staff_I.citizen_id,
                            affiliation: staff_I.dep_name,
                            status_reg: this.rdoRegisterProject,
                            position: '',
                            phone: '',
                            registerType_id: 0,
                          })
                          this.staffSel = ''
                        } else {
                          this.staffSel = ''
                          this.$swal.fire({
                            icon: 'error',
                            title: 'ไม่สามารถบันทึกข้อมูลได้ เนื่องจากมีข้อมูลในระบบอยู่แล้ว'
                          })
                        }
                      } else {
                        if ((this.JoinPerson.length + parseInt(this.ProjectQuotaDepCount)) < parseInt(this.ProjectQuotaCount)) {
                          if (this.JoinPerson.filter(item => item.uid == staff_I.perid).length > 0) {
                            CheckDupe = true
                          }
                          if (!CheckDupe) {
                            this.JoinPerson.unshift({
                              ...staff_I,
                              uid: staff_I.perid,
                              name: staff_I.name,
                              sname: staff_I.surname,
                              idCard: staff_I.citizen_id,
                              affiliation: staff_I.dep_name,
                              status_reg: this.rdoRegisterProject,
                              position: '',
                              phone: '',
                              registerType_id: 0,
                            })
                            this.staffSel = ''
                          } else {
                            this.staffSel = ''
                            this.$swal.fire({
                              icon: 'error',
                              title: 'ไม่สามารถบันทึกข้อมูลได้ เนื่องจากมีข้อมูลในระบบอยู่แล้ว'
                            })
                          }
                        } else {
                          this.staffSel = ''
                          this.$swal.fire({
                            icon: 'error',
                            title: 'ไม่สามารถบันทึกข้อมูลได้ เนื่องจากหมดโควต้าบุคคลกรทั่วไปที่ไม่อยู่ภายใต้เงื่อนไข'
                          })
                        }
                      }
                    }
                  }
                } else {
                  //// ตรงนี้ต้องเช็ค
                  if (!CheckDepMatch) {
                    var DepGroup = this.depart.filter(item => item.dep_group_id == dep_quota.dep_id)
                    if (DepGroup.length > 0) {
                      if (DepGroup.filter(item => item.dep_id == staff_I.dep_id).length > 0) {
                        CheckDepMatch = true
                        if (this.JoinPerson.length > 0) {
                          if (this.JoinPerson.filter(item => item.dep_group_id == staff_I.dep_group_id).length < parseInt(dep_quota.count)) {
                            if (this.JoinPerson.filter(item => item.uid == staff_I.perid).length > 0) {
                              CheckDupe = true
                            }
                            if (!CheckDupe) {
                              this.JoinPerson.unshift({
                                ...staff_I,
                                uid: staff_I.perid,
                                name: staff_I.name,
                                sname: staff_I.surname,
                                idCard: staff_I.citizen_id,
                                affiliation: staff_I.dep_name,
                                status_reg: this.rdoRegisterProject,
                                position: '',
                                phone: '',
                                registerType_id: 0,
                              })
                              this.staffSel = ''
                            } else {
                              this.staffSel = ''
                              this.$swal.fire({
                                icon: 'error',
                                title: 'ไม่สามารถบันทึกข้อมูลได้ เนื่องจากมีข้อมูลในระบบอยู่แล้ว'
                              })
                            }
                          } else {
                            this.staffSel = ''
                            this.$swal.fire({
                              icon: 'error',
                              title: 'ไม่สามารถบันทึกข้อมูลได้ เนื่องจากจำนวนผู้เข้าร่วมของ(กลุ่มหน่วยงาน/กลุ่มภาควิชา) ' + staff_I.dep_name + ' เกินกำหนดที่ตั้งไว้'
                            })
                          }
                        } else {
                          this.JoinPerson.unshift({
                            ...staff_I,
                            uid: staff_I.perid,
                            name: staff_I.name,
                            sname: staff_I.surname,
                            idCard: staff_I.citizen_id,
                            affiliation: staff_I.dep_name,
                            status_reg: this.rdoRegisterProject,
                            position: '',
                            phone: '',
                            registerType_id: 0,
                          })
                          this.staffSel = ''
                        }
                      }
                    }
                  }
                }
              })
            } else {
              if (this.JoinPerson.filter(item => item.uid == staff_I.perid).length > 0) {
                CheckDupe = true
              }
              if (!CheckDupe) {
                this.JoinPerson.unshift({
                  ...staff_I,
                  uid: staff_I.perid,
                  name: staff_I.name,
                  sname: staff_I.surname,
                  idCard: staff_I.citizen_id,
                  affiliation: staff_I.dep_name,
                  status_reg: this.rdoRegisterProject,
                  position: '',
                  phone: '',
                  registerType_id: 0,
                })
                this.staffSel = ''
              } else {
                this.staffSel = ''
                this.$swal.fire({
                  icon: 'error',
                  title: 'ไม่สามารถบันทึกข้อมูลได้ เนื่องจากมีข้อมูลในระบบอยู่แล้ว'
                })
              }
            }
          }
        })
      }
    },
    ChooseEmpolyee_s_owner() {
      var CheckDupe = false
      this.staffData.map((staff_I) => {
        if (staff_I.perid == this.staffSel) {
          if (this.JoinPerson.filter(item => item.uid == staff_I.perid).length > 0) {
            CheckDupe = true
          }
          if (!CheckDupe) {
            this.JoinPerson.unshift({
              ...staff_I,
              idx: this.JoinPerson.length + 1,
              uid: staff_I.perid,
              name: staff_I.name,
              sname: staff_I.surname,
              idCard: staff_I.citizen_id,
              affiliation: staff_I.dep_name,
              status_reg: this.rdoRegisterProject,
              position: '',
              phone: '',
              registerType_id: 0,
            })
            this.staffSel = ''
          } else {
            this.staffSel = ''
            this.$swal.fire({
              icon: 'error',
              title: 'ไม่สามารถบันทึกข้อมูลได้ เนื่องจากมีข้อมูลในระบบอยู่แล้ว'
            })
          }
        }
      })
    },
    ChooseEmpolyee() {
      this.items = []
      this.AutoMateitems()
    },
    AutoMateitems() {
      var children = []
      if (this.depart.length > 0) {
        this.depart.map((depart_i) => {
          if (depart_i.dep_id == this.departSel) {
            if (this.staffData.length > 0) {
              this.staffData.map((staff_i, idx) => {
                if (staff_i.dep_id == this.departSel) {
                  children.push(
                      {
                        ...staff_i,
                        header: false,
                        switch: false,
                        id: parseInt(idx + 1),
                        name: staff_i.full_Name
                      })
                }
              })
            }
            children.sort((a, b) => {
              return a.perid > b.perid ? 1 : -1
            })
            this.items = [{
              id: 1,
              name: depart_i.dep_name,
              header: true,
              switch: false,
              children,
            }]
          }
        })
      }
    },
    insertDataPerson(type) {
      if (type == 'person') {
        this.JoinPerson.push({
          uid: 'P_' + this.JoinPerson.length,
          full_Name: this.NameP + ' ' + this.SurNameP,
          name: this.NameP,
          sname: this.SurNameP,
          idCard: this.idCard,
          affiliation: this.affiliation,
          position: this.position,
          phone: '',
          registerType_id: 4,
        })
        this.NameP = ''
        this.SurNameP = ''
        this.idCard = ''
        this.affiliation = ''
        this.position = ''
      } else {
        this.JoinPerson.push({
          uid: 'S_' + this.JoinPerson.length,
          full_Name: this.NameStd + ' ' + this.SurNameStd,
          name: this.NameStd,
          sname: this.SurNameStd,
          idCard: this.idCardStd,
          affiliation: this.affiliationStd,
          position: '',
          phone: '',
          registerType_id: 5,
        })
        this.NameStd = ''
        this.SurNameStd = ''
        this.idCardStd = ''
        this.affiliationStd = ''
      }
    },
    SaveToTable() {
      // this.EmpData.map((item) => {
      //   this.JoinPerson.push({
      //     ...item,
      //     uid: item.perid,
      //     name: item.name,
      //     sname: item.surname,
      //     idCard: item.citizen_id,
      //     affiliation: item.dep_name,
      //     position: '',
      //     phone: '',
      //     registerType_id: 0,
      //   })
      // })
      // this.EmpData = []
      // this.items = []
      // this.departSel = ''
      var CheckDupe = false
      var CheckDepMatch = false
      var CheckGroupExample = []
      this.ShowAlertSuc = false
      this.ShowAlertErr = false
      this.MessageSuc = ''
      this.MessageError = ''

      if (this.ChkJoinPerson && this.JoinPerson.length >= parseInt(this.ProjectQuotaCount)) {
        this.$swal.fire({
          icon: 'error',
          title: 'ไม่สามารถบันทึกข้อมูลได้ เนื่องจากจำนวนผู้เข้าร่วมเกินจำนวนที่โครงการกำหนด'
        })
      } else {
        this.EmpData.map((item, EmpIdx) => {
          CheckDupe = false
          CheckDepMatch = false
          CheckGroupExample = []
          this.staffData.map((staff_I) => {
            if (staff_I.perid == item.perid) {
              if (this.DataCondi.length > 0) {
                CheckGroupExample = this.DataCondi.filter(item => item.PosCode == staff_I.pos_id && this.getAge(new Date(staff_I.date_in), new Date())[0] >= item.workAgeStart && this.getAge(new Date(staff_I.date_in), new Date())[0] <= item.workAgeEnd)

                if (CheckGroupExample.length > 0) {
                  if (this.DepQuotaData.length > 0) {
                    this.DepQuotaData.map((dep_quota, idx) => {
                      if (dep_quota.type_id == '0' && !CheckDepMatch) {
                        if (staff_I.dep_id == dep_quota.dep_id) {
                          CheckDepMatch = true
                          if (this.JoinPerson.length > 0) {
                            if (this.JoinPerson.filter(item => item.dep_id == staff_I.dep_id).length < parseInt(dep_quota.count)) {
                              if (this.JoinPerson.filter(item => item.uid == staff_I.perid).length > 0) {
                                CheckDupe = true
                              }

                              if (!CheckDupe) {
                                this.JoinPerson.unshift({
                                  ...staff_I,
                                  uid: staff_I.perid,
                                  name: staff_I.name,
                                  sname: staff_I.surname,
                                  idCard: staff_I.citizen_id,
                                  affiliation: staff_I.dep_name,
                                  status_reg: this.rdoRegisterProject,
                                  position: '',
                                  phone: '',
                                  registerType_id: 0,
                                })
                                this.MessageSuc += '<p style="font-weight: bold;color: green">' + item.full_Name + ' บันทึกข้อมูลสำเร็จ !!</p>'
                                this.ShowAlertSuc = true
                              } else {
                                this.MessageError += '<p style="font-weight: bold;color: red">' + item.full_Name + ' พบข้อมูลผู้เข้าร่วมอยู่แล้ว !!</p>'
                                this.ShowAlertErr = true
                              }
                            } else {
                              this.MessageError += '<p style="font-weight: bold;color: chocolate">' + item.full_Name + ' ไม่สามารถบันทึกข้อมูลได้ จำนวนผู้เข้าร่วมของหน่วยงาน ' + staff_I.dep_name + ' เกินกำหนดที่ตั้งไว้</p>'
                              this.ShowAlertErr = true
                            }
                          } else {
                            if (this.JoinPerson.filter(item => item.uid == staff_I.perid).length > 0) {
                              CheckDupe = true
                            }
                            if (!CheckDupe) {
                              this.JoinPerson.unshift({
                                ...staff_I,
                                uid: staff_I.perid,
                                name: staff_I.name,
                                sname: staff_I.surname,
                                idCard: staff_I.citizen_id,
                                affiliation: staff_I.dep_name,
                                status_reg: this.rdoRegisterProject,
                                position: '',
                                phone: '',
                                registerType_id: 0,
                              })
                              this.MessageSuc += '<p style="font-weight: bold;color: green">' + item.full_Name + ' บันทึกข้อมูลสำเร็จ !!</p>'
                              this.ShowAlertSuc = true
                            } else {
                              this.MessageError += '<p style="font-weight: bold;color: red">' + item.full_Name + ' พบข้อมูลผู้เข้าร่วมอยู่แล้ว !!</p>'
                              this.ShowAlertErr = true
                            }
                          }
                        } else {
                          if (!CheckDepMatch && idx == this.DepQuotaData.length - 1) {
                            if (this.ChkJoinPerson) {
                              if (this.JoinPerson.filter(item => item.uid == staff_I.perid).length > 0) {
                                CheckDupe = true
                              }
                              if (!CheckDupe) {
                                this.JoinPerson.unshift({
                                  ...staff_I,
                                  uid: staff_I.perid,
                                  name: staff_I.name,
                                  sname: staff_I.surname,
                                  idCard: staff_I.citizen_id,
                                  affiliation: staff_I.dep_name,
                                  status_reg: this.rdoRegisterProject,
                                  position: '',
                                  phone: '',
                                  registerType_id: 0,
                                })
                                this.MessageSuc += '<p style="font-weight: bold;color: green">' + item.full_Name + ' บันทึกข้อมูลสำเร็จ !!</p>'
                                this.ShowAlertSuc = true
                              } else {
                                this.MessageError += '<p style="font-weight: bold;color: red">' + item.full_Name + ' พบข้อมูลผู้เข้าร่วมอยู่แล้ว !!</p>'
                                this.ShowAlertErr = true
                              }
                            } else {
                              if ((this.JoinPerson.length + parseInt(this.ProjectQuotaDepCount)) < parseInt(this.ProjectQuotaCount)) {
                                if (this.JoinPerson.filter(item => item.uid == staff_I.perid).length > 0) {
                                  CheckDupe = true
                                }
                                if (!CheckDupe) {
                                  this.JoinPerson.unshift({
                                    ...staff_I,
                                    uid: staff_I.perid,
                                    name: staff_I.name,
                                    sname: staff_I.surname,
                                    idCard: staff_I.citizen_id,
                                    affiliation: staff_I.dep_name,
                                    status_reg: this.rdoRegisterProject,
                                    position: '',
                                    phone: '',
                                    registerType_id: 0,
                                  })
                                  this.MessageSuc += '<p style="font-weight: bold;color: green">' + item.full_Name + ' บันทึกข้อมูลสำเร็จ !!</p>'
                                  this.ShowAlertSuc = true
                                } else {
                                  this.MessageError += '<p style="font-weight: bold;color: red">' + item.full_Name + ' พบข้อมูลผู้เข้าร่วมอยู่แล้ว !!</p>'
                                  this.ShowAlertErr = true
                                }
                              } else {
                                this.MessageError += '<p style="font-weight: bold;color: blueviolet">' + item.full_Name + ' หมดโควต้าบุคคลกรทั่วไปที่ไม่อยู่ภายใต้เงื่อนไข !!</p>'
                                this.ShowAlertErr = true
                              }
                            }
                          }
                        }
                      } else {
                        //// ตรงนี้ต้องเช็ค
                        if (!CheckDepMatch) {
                          var DepGroup = this.depart.filter(item => item.dep_group_id == dep_quota.dep_id)
                          if (DepGroup.length > 0) {
                            if (DepGroup.filter(item => item.dep_id == staff_I.dep_id).length > 0) {
                              CheckDepMatch = true
                              if (this.JoinPerson.length > 0) {
                                if (this.JoinPerson.filter(item => item.dep_group_id == staff_I.dep_group_id).length < parseInt(dep_quota.count)) {
                                  if (this.JoinPerson.filter(item => item.uid == staff_I.perid).length > 0) {
                                    CheckDupe = true
                                  }
                                  if (!CheckDupe) {
                                    this.JoinPerson.unshift({
                                      ...staff_I,
                                      uid: staff_I.perid,
                                      name: staff_I.name,
                                      sname: staff_I.surname,
                                      idCard: staff_I.citizen_id,
                                      affiliation: staff_I.dep_name,
                                      status_reg: this.rdoRegisterProject,
                                      position: '',
                                      phone: '',
                                      registerType_id: 0,
                                    })
                                    this.MessageSuc += '<p style="font-weight: bold;color: green"">' + item.full_Name + ' บันทึกข้อมูลสำเร็จ !!</p>'
                                    this.ShowAlertSuc = true
                                  } else {
                                    this.MessageError += '<p style="font-weight: bold;color: red"">' + item.full_Name + ' พบข้อมูลผู้เข้าร่วมอยู่แล้ว !!</p>'
                                    this.ShowAlertErr = true
                                  }
                                } else {
                                  this.MessageError += '<p style="font-weight: bold;color: chocolate"">' + item.full_Name + ' ไม่สามารถบันทึกข้อมูลได้ จำนวนผู้เข้าร่วมของหน่วยงาน ' + staff_I.dep_name + ' เกินกำหนดที่ตั้งไว้</p>'
                                  this.ShowAlertErr = true
                                }
                              } else {
                                this.JoinPerson.unshift({
                                  ...staff_I,
                                  uid: staff_I.perid,
                                  name: staff_I.name,
                                  sname: staff_I.surname,
                                  idCard: staff_I.citizen_id,
                                  affiliation: staff_I.dep_name,
                                  status_reg: this.rdoRegisterProject,
                                  position: '',
                                  phone: '',
                                  registerType_id: 0,
                                })
                                this.MessageSuc += '<p style="font-weight: bold;color: green"">' + item.full_Name + ' บันทึกข้อมูลสำเร็จ !!</p>'
                                this.ShowAlertSuc = true
                              }
                            }
                          }
                        }
                      }
                    })
                  } else {
                    if (this.JoinPerson.filter(item => item.uid == staff_I.perid).length > 0) {
                      CheckDupe = true
                    }
                    if (!CheckDupe) {
                      this.JoinPerson.unshift({
                        ...staff_I,
                        uid: staff_I.perid,
                        name: staff_I.name,
                        sname: staff_I.surname,
                        idCard: staff_I.citizen_id,
                        affiliation: staff_I.dep_name,
                        status_reg: this.rdoRegisterProject,
                        position: '',
                        phone: '',
                        registerType_id: 0,
                      })
                      this.MessageSuc += '<p style="font-weight: bold;color: green">' + item.full_Name + ' บันทึกข้อมูลสำเร็จ !!</p>'
                      this.ShowAlertSuc = true
                    } else {
                      this.MessageError += '<p style="font-weight: bold;color: red"">' + item.full_Name + ' พบข้อมูลผู้เข้าร่วมอยู่แล้ว !!</p>'
                      this.ShowAlertErr = true
                    }
                  }
                } else {
                  this.MessageError += '<p style="font-weight: bold;color: darkcyan">' + item.full_Name + ' ไม่สามารถบันทึกข้อมูลได้ เงื่อนไขอายุงานกลุ่มตัวอย่าง ไม่ตรงกับอายุงานของบุคลากรที่เลือก</p>'
                  this.ShowAlertErr = true
                }
              } else if (this.DepQuotaData.length > 0) {
                this.DepQuotaData.map((dep_quota, idx) => {
                  if (dep_quota.type_id == '0' && !CheckDepMatch) {
                    if (staff_I.dep_id == dep_quota.dep_id) {
                      CheckDepMatch = true
                      if (this.JoinPerson.length > 0) {
                        if (this.JoinPerson.filter(item => item.dep_id == staff_I.dep_id).length < parseInt(dep_quota.count)) {
                          if (this.JoinPerson.filter(item => item.uid == staff_I.perid).length > 0) {
                            CheckDupe = true
                          }

                          if (!CheckDupe) {
                            this.JoinPerson.unshift({
                              ...staff_I,
                              uid: staff_I.perid,
                              name: staff_I.name,
                              sname: staff_I.surname,
                              idCard: staff_I.citizen_id,
                              affiliation: staff_I.dep_name,
                              status_reg: this.rdoRegisterProject,
                              position: '',
                              phone: '',
                              registerType_id: 0,
                            })
                            this.MessageSuc += '<p style="font-weight: bold;color: green"">' + item.full_Name + ' บันทึกข้อมูลสำเร็จ !!</p>'
                            this.ShowAlertSuc = true
                          } else {
                            this.MessageError += '<p style="font-weight: bold;color: red"">' + item.full_Name + ' พบข้อมูลผู้เข้าร่วมอยู่แล้ว !!</p>'
                            this.ShowAlertErr = true
                          }
                        } else {
                          this.MessageError += '<p style="font-weight: bold;color: chocolate"">' + item.full_Name + ' ไม่สามารถบันทึกข้อมูลได้ จำนวนผู้เข้าร่วมของหน่วยงาน ' + staff_I.dep_name + ' เกินกำหนดที่ตั้งไว้</p>'
                          this.ShowAlertErr = true
                        }
                      } else {
                        if (this.JoinPerson.filter(item => item.uid == staff_I.perid).length > 0) {
                          CheckDupe = true
                        }
                        if (!CheckDupe) {
                          this.JoinPerson.unshift({
                            ...staff_I,
                            uid: staff_I.perid,
                            name: staff_I.name,
                            sname: staff_I.surname,
                            idCard: staff_I.citizen_id,
                            affiliation: staff_I.dep_name,
                            status_reg: this.rdoRegisterProject,
                            position: '',
                            phone: '',
                            registerType_id: 0,
                          })
                          this.MessageSuc += '<p style="font-weight: bold;color: green"">' + item.full_Name + ' บันทึกข้อมูลสำเร็จ !!</p>'
                          this.ShowAlertSuc = true
                        } else {
                          this.MessageError += '<p style="font-weight: bold;color: red"">' + item.full_Name + ' พบข้อมูลผู้เข้าร่วมอยู่แล้ว !!</p>'
                          this.ShowAlertErr = true
                        }
                      }
                    } else {
                      if (!CheckDepMatch && idx == this.DepQuotaData.length - 1) {
                        if (this.ChkJoinPerson) {
                          if (this.JoinPerson.filter(item => item.uid == staff_I.perid).length > 0) {
                            CheckDupe = true
                          }
                          if (!CheckDupe) {
                            this.JoinPerson.unshift({
                              ...staff_I,
                              uid: staff_I.perid,
                              name: staff_I.name,
                              sname: staff_I.surname,
                              idCard: staff_I.citizen_id,
                              affiliation: staff_I.dep_name,
                              status_reg: this.rdoRegisterProject,
                              position: '',
                              phone: '',
                              registerType_id: 0,
                            })
                            this.MessageSuc += '<p style="font-weight: bold;color: green"">' + item.full_Name + ' บันทึกข้อมูลสำเร็จ !!</p>'
                            this.ShowAlertSuc = true
                          } else {
                            this.MessageError += '<p style="font-weight: bold;color: red"">' + item.full_Name + ' พบข้อมูลผู้เข้าร่วมอยู่แล้ว !!</p>'
                            this.ShowAlertErr = true
                          }
                        } else {
                          if ((this.JoinPerson.length + parseInt(this.ProjectQuotaDepCount)) < parseInt(this.ProjectQuotaCount)) {
                            if (this.JoinPerson.filter(item => item.uid == staff_I.perid).length > 0) {
                              CheckDupe = true
                            }
                            if (!CheckDupe) {
                              this.JoinPerson.unshift({
                                ...staff_I,
                                uid: staff_I.perid,
                                name: staff_I.name,
                                sname: staff_I.surname,
                                idCard: staff_I.citizen_id,
                                affiliation: staff_I.dep_name,
                                status_reg: this.rdoRegisterProject,
                                position: '',
                                phone: '',
                                registerType_id: 0,
                              })
                              this.MessageSuc += '<p style="font-weight: bold;color: green"">' + item.full_Name + ' บันทึกข้อมูลสำเร็จ !!</p>'
                              this.ShowAlertSuc = true
                            } else {
                              this.MessageError += '<p style="font-weight: bold;color: red"">' + item.full_Name + ' พบข้อมูลผู้เข้าร่วมอยู่แล้ว !!</p>'
                              this.ShowAlertErr = true
                            }
                          } else {
                            this.MessageError += '<p style="font-weight: bold;color: blueviolet">' + item.full_Name + ' หมดโควต้าบุคคลกรทั่วไปที่ไม่อยู่ภายใต้เงื่อนไข !!</p>'
                            this.ShowAlertErr = true
                          }
                        }
                      }
                    }
                  } else {
                    //// ตรงนี้ต้องเช็ค
                    if (!CheckDepMatch) {
                      var DepGroup = this.depart.filter(item => item.dep_group_id == dep_quota.dep_id)
                      if (DepGroup.length > 0) {
                        if (DepGroup.filter(item => item.dep_id == staff_I.dep_id).length > 0) {
                          CheckDepMatch = true
                          if (this.JoinPerson.length > 0) {
                            if (this.JoinPerson.filter(item => item.dep_group_id == staff_I.dep_group_id).length < parseInt(dep_quota.count)) {
                              if (this.JoinPerson.filter(item => item.uid == staff_I.perid).length > 0) {
                                CheckDupe = true
                              }
                              if (!CheckDupe) {
                                this.JoinPerson.unshift({
                                  ...staff_I,
                                  uid: staff_I.perid,
                                  name: staff_I.name,
                                  sname: staff_I.surname,
                                  idCard: staff_I.citizen_id,
                                  affiliation: staff_I.dep_name,
                                  status_reg: this.rdoRegisterProject,
                                  position: '',
                                  phone: '',
                                  registerType_id: 0,
                                })
                                this.MessageSuc += '<p style="font-weight: bold;color: green"">' + item.full_Name + ' บันทึกข้อมูลสำเร็จ !!</p>'
                                this.ShowAlertSuc = true
                              } else {
                                this.MessageError += '<p style="font-weight: bold;color: red"">' + item.full_Name + ' พบข้อมูลผู้เข้าร่วมอยู่แล้ว !!</p>'
                                this.ShowAlertErr = true
                              }
                            } else {
                              this.MessageError += '<p style="font-weight: bold;color: chocolate"">' + item.full_Name + ' ไม่สามารถบันทึกข้อมูลได้ จำนวนผู้เข้าร่วมของหน่วยงาน ' + staff_I.dep_name + ' เกินกำหนดที่ตั้งไว้</p>'
                              this.ShowAlertErr = true
                            }
                          } else {
                            this.JoinPerson.unshift({
                              ...staff_I,
                              uid: staff_I.perid,
                              name: staff_I.name,
                              sname: staff_I.surname,
                              idCard: staff_I.citizen_id,
                              affiliation: staff_I.dep_name,
                              status_reg: this.rdoRegisterProject,
                              position: '',
                              phone: '',
                              registerType_id: 0,
                            })
                            this.MessageSuc += '<p style="font-weight: bold;color: green"">' + item.full_Name + ' บันทึกข้อมูลสำเร็จ !!</p>'
                            this.ShowAlertSuc = true
                          }
                        }
                      }
                    }
                  }
                })
              } else {
                if (this.JoinPerson.filter(item => item.uid == staff_I.perid).length > 0) {
                  CheckDupe = true
                }
                if (!CheckDupe) {
                  this.JoinPerson.unshift({
                    ...staff_I,
                    uid: staff_I.perid,
                    name: staff_I.name,
                    sname: staff_I.surname,
                    idCard: staff_I.citizen_id,
                    affiliation: staff_I.dep_name,
                    status_reg: this.rdoRegisterProject,
                    position: '',
                    phone: '',
                    registerType_id: 0,
                  })
                  this.MessageSuc += '<p style="font-weight: bold;color: green"">' + item.full_Name + ' บันทึกข้อมูลสำเร็จ !!</p>'
                  this.ShowAlertSuc = true
                } else {
                  this.MessageError += '<p style="font-weight: bold;color: red"">' + item.full_Name + ' พบข้อมูลผู้เข้าร่วมอยู่แล้ว !!</p>'
                  this.ShowAlertErr = true
                }
              }
            }
          })
          if (EmpIdx == this.EmpData.length - 1) {
            this.EmpData = []
            this.items = []
            this.departSel = ''
          }
        })
      }
    },
    SaveToTable_owner() {
      var CheckDupe = false
      this.MessageError = ''
      this.MessageSuc = ''
      this.EmpData.map((item) => {
        CheckDupe = false
        if (this.JoinPerson.filter(Join_I => Join_I.uid == item.perid).length > 0) {
          CheckDupe = true
        }
        if (!CheckDupe) {
          this.JoinPerson.unshift({
            ...item,
            idx: this.JoinPerson.length + 1,
            uid: item.perid,
            name: item.name,
            sname: item.surname,
            idCard: item.citizen_id,
            affiliation: item.dep_name,
            status_reg: this.rdoRegisterProject,
            position: '',
            phone: '',
            registerType_id: 0,
          })
          this.MessageSuc += '<p style="font-weight: bold;color: green">' + item.full_Name + ' บันทึกข้อมูลสำเร็จ !!</p>'
          this.ShowAlertSuc = true
        } else {
          this.MessageError += '<p style="font-weight: bold;color: red">' + item.full_Name + ' พบข้อมูลผู้เข้าร่วมอยู่แล้ว !!</p>'
          this.ShowAlertErr = true
        }
      })
      this.EmpData = []
      this.items = []
      this.departSel = ''
    },
    InsertCompetency() {
      if (this.Competency_code == '' || this.UPercent == '') {
        this.$swal.fire({
          icon: 'error',
          title: 'กรุณาตรวจสอบข้อมูลอีกครั้ง'
        })
      } else {
        if (this.competency_DataForSubmit.length > 0) {
          this.competency_DataForSubmit.map((compe_i_s) => {
            if (compe_i_s.Competency_code == this.Competency_code) {
              this.$swal.fire({
                icon: 'error',
                title: 'มี Competency นี้อยู่แล้ว !! ไม่สามารถเพิ่มข้อมูลได้อีก'
              })
            } else {
              this.Competency_Data.map((compe_i) => {
                if (compe_i.Competency_code == this.Competency_code) {
                  this.competency_DataForSubmit.push({
                    Project_code: this.Project_code,
                    Competency_code: this.Competency_code,
                    Competency_des: compe_i.Competency_des,
                    UPercent: this.UPercent,
                  })
                }
              })
            }
          })
        } else {
          this.Competency_Data.map((compe_i) => {
            if (compe_i.Competency_code == this.Competency_code) {
              this.competency_DataForSubmit.push({
                Project_code: this.Project_code,
                Competency_code: this.Competency_code,
                Competency_des: compe_i.Competency_des,
                UPercent: this.UPercent,
              })
            }
          })
        }
      }
      this.Competency_code = ''
      this.UPercent = ''
    },
    AddExpense() {
      var CheckDupe = false
      var CheckDupeExpense = false
      var CheckDep = false
      if (this.radioGroup2 == '0') {
        if (this.moneyCost == '' || this.expenseCost == '') {
          this.$swal.fire({
            icon: 'error',
            title: 'กรุณาตรวจสอบข้อมูลอีกครั้ง'
          })
        } else {
          if (this.expense_p_DataForSubmit.length > 0) {
            this.expense_p_DataForSubmit.map((item) => {
              item.Expense_data.map((item_expense) => {
                if (item_expense.Expense_id == this.expenseCost) {
                  CheckDupe = true
                }
              });
            })
          }
          if (CheckDupe) {
            this.$swal.fire({
              icon: 'error',
              title: 'ไม่สามารถบันทึกข้อมูลได้ เนื่องจากมีรหัสค่าเบิก/จ่ายหมายเลขที่เลือกอยู่แล้ว'
            })
          } else {
            if (this.expense_p_DataForSubmit.length > 0) {
              this.expense_p_DataForSubmit.map((item) => {
                CheckDep = false
                this.depart.map((dep_i) => {
                  if (dep_i.dep_id == this.DepCost) {
                    this.expense_Data.map((expense_i) => {
                      if (expense_i.Expense_id == this.expenseCost) {
                        item.Expense_data.push({
                          Dep_Cost: this.DepCost,
                          Dep_Cost_Name: dep_i.dep_name,
                          Expense_id: this.expenseCost,
                          Expense_des: expense_i.Expense_des,
                          ReqMoney: this.moneyCost
                        })
                        item.SumCost += parseInt(this.moneyCost)
                        this.expenseCostSum += parseInt(this.moneyCost)
                      }
                    })
                    CheckDep = true
                  }
                })
                if (!CheckDep) {
                  this.expense_Data.map((expense_i) => {
                    if (expense_i.Expense_id == this.expenseCost) {
                      item.Expense_data.push({
                        Dep_Cost: '',
                        Dep_Cost_Name: '',
                        Expense_id: this.expenseCost,
                        Expense_des: expense_i.Expense_des,
                        ReqMoney: this.moneyCost
                      })
                      item.SumCost += parseInt(this.moneyCost)
                      this.expenseCostSum += parseInt(this.moneyCost)
                    }
                  })
                }
              })
            } else {
              this.expense_p_DataForSubmit.push({
                id: this.expense_p_DataForSubmit.length + 1,
                Project_code: this.Project_code,
                SumCost: 0,
                Expense_data: []
              })
              this.expense_p_DataForSubmit.map((item) => {
                CheckDep = false
                this.depart.map((dep_i) => {
                  if (dep_i.dep_id == this.DepCost) {
                    this.expense_Data.map((expense_i) => {
                      if (expense_i.Expense_id == this.expenseCost) {
                        item.Expense_data.push({
                          Dep_Cost: this.DepCost,
                          Dep_Cost_Name: dep_i.dep_name,
                          Expense_id: this.expenseCost,
                          Expense_des: expense_i.Expense_des,
                          ReqMoney: this.moneyCost
                        })
                        item.SumCost += parseInt(this.moneyCost)
                        this.expenseCostSum += parseInt(this.moneyCost)
                      }
                    })
                    CheckDep = true
                  }
                })
                if (!CheckDep) {
                  this.expense_Data.map((expense_i) => {
                    if (expense_i.Expense_id == this.expenseCost) {
                      item.Expense_data.push({
                        Dep_Cost: '',
                        Dep_Cost_Name: '',
                        Expense_id: this.expenseCost,
                        Expense_des: expense_i.Expense_des,
                        ReqMoney: this.moneyCost
                      })
                      item.SumCost += parseInt(this.moneyCost)
                      this.expenseCostSum += parseInt(this.moneyCost)
                    }
                  })
                }
              })
            }
          }
          this.peridCost = ''
          this.moneyCost = ''
          this.expenseCost = ''
        }
      } else {
        if (this.peridCost == '' || this.moneyCost == '' || this.expenseCost == '') {
          this.$swal.fire({
            icon: 'error',
            title: 'กรุณาตรวจสอบข้อมูลอีกครั้ง'
          })
        } else {
          if (this.expense_DataForSubmit.length > 0) {
            this.expense_DataForSubmit.map((item) => {
              if (item.PERID == this.peridCost) {
                CheckDupe = true
                this.expense_p_DataForSubmit.map((item) => {
                  item.Expense_data.map((item_expense) => {
                    if (item_expense.Expense_id == this.expenseCost) {
                      CheckDupeExpense = true
                    }
                  });
                })
              }
            })
          }
          if (CheckDupe) {
            if (CheckDupeExpense) {
              this.$swal.fire({
                icon: 'error',
                title: 'ไม่สามารถบันทึกข้อมูลได้ เนื่องจากมีรหัสค่าเบิก/จ่ายหมายเลขที่เลือกอยู่แล้ว'
              })
            } else {
              if (this.expense_DataForSubmit.length > 0) {
                this.expense_DataForSubmit.map((item) => {
                  if (item.PERID == this.peridCost) {
                    CheckDep = false
                    this.depart.map((dep_i) => {
                      if (dep_i.dep_id == this.DepCost) {
                        this.expense_Data.map((expense_i) => {
                          if (expense_i.Expense_id == this.expenseCost) {
                            item.Expense_data.push({
                              Dep_Cost: this.DepCost,
                              Dep_Cost_Name: dep_i.dep_name,
                              Expense_id: this.expenseCost,
                              Expense_des: expense_i.Expense_des,
                              ReqMoney: this.moneyCost
                            })
                            item.SumCost += parseInt(this.moneyCost)
                            this.expenseCostSum += parseInt(this.moneyCost)
                          }
                        })
                        CheckDep = true
                      }
                    })
                    if (!CheckDep) {
                      this.expense_Data.map((expense_i) => {
                        if (expense_i.Expense_id == this.expenseCost) {
                          item.Expense_data.push({
                            Dep_Cost: '',
                            Dep_Cost_Name: '',
                            Expense_id: this.expenseCost,
                            Expense_des: expense_i.Expense_des,
                            ReqMoney: this.moneyCost
                          })
                          item.SumCost += parseInt(this.moneyCost)
                          this.expenseCostSum += parseInt(this.moneyCost)
                        }
                      })
                    }
                  }
                })
              }
            }
          } else {
            this.staffData.map((staff_i) => {
              if (staff_i.perid == this.peridCost) {
                this.expense_DataForSubmit.push({
                  id: this.expense_DataForSubmit.length + 1,
                  PERID: this.peridCost,
                  full_Name: staff_i.full_Name,
                  Dep_Code: this.dep_id,
                  Dep_name: staff_i.dep_name,
                  Project_code: this.Project_code,
                  SumCost: 0,
                  Expense_data: []
                })
              }
            })
            if (this.expense_DataForSubmit.length > 0) {
              this.expense_DataForSubmit.map((item) => {
                if (item.PERID == this.peridCost) {
                  CheckDep = false
                  this.depart.map((dep_i) => {
                    if (dep_i.dep_id == this.DepCost) {
                      this.expense_Data.map((expense_i) => {
                        if (expense_i.Expense_id == this.expenseCost) {
                          item.Expense_data.push({
                            Dep_Cost: this.DepCost,
                            Dep_Cost_Name: dep_i.dep_name,
                            Expense_id: this.expenseCost,
                            Expense_des: expense_i.Expense_des,
                            ReqMoney: this.moneyCost
                          })
                          item.SumCost += parseInt(this.moneyCost)
                          this.expenseCostSum += parseInt(this.moneyCost)
                        }
                      })
                      CheckDep = true
                    }
                  })
                  if (!CheckDep) {
                    this.expense_Data.map((expense_i) => {
                      if (expense_i.Expense_id == this.expenseCost) {
                        item.Expense_data.push({
                          Dep_Cost: '',
                          Dep_Cost_Name: '',
                          Expense_id: this.expenseCost,
                          Expense_des: expense_i.Expense_des,
                          ReqMoney: this.moneyCost
                        })
                        item.SumCost += parseInt(this.moneyCost)
                        this.expenseCostSum += parseInt(this.moneyCost)
                      }
                    })
                  }
                }
              })
            }
          }
          this.peridCost = ''
          this.moneyCost = ''
          this.expenseCost = ''
        }
      }
    },
    onInput(val) {
      this.steps = parseInt(val)
    },
    backStep(n) {
      this.e1 = n
    },
    nextStep(n) {
      if (n === this.steps) {
        this.e1 = 1
      } else {
        this.e1 = n + 1
        if (this.e1 == 2) {
          if (this.Project_name == '' || this.Project_group == '' || this.PLACE == ''
              || this.WorkBy == '' || this.Location == ''
              || this.DateStart == '' || this.DateEnd == '' || this.BudgetRequest == ''
              || this.CalCredit == '' || this.CalHourse == '') {
            this.CheckStep1 = false
          } else {
            if (this.PLACE == '2' && this.Province_id == '') {
              this.CheckStep1 = false
            } else if (this.PLACE == '3' && this.Country_id == '') {
              this.CheckStep1 = false
            } else {
              this.CheckStep1 = true
            }
          }
        }
      }

      if (this.e1 == 6) {
        var GroupExample = ''
        var committeeTxt = ''
        var lecturerTxt = ''
        var budgetTxt = ''
        if (this.Committee_ToShow.length > 0) {
          this.Committee_ToShow.map((item, idx) => {
            committeeTxt += '<p class="custom-block-indent-a" style="margin-left:80px"><span style="font-family:THSarabunNew;">' + (idx + 1) + '. ' + item.Name + '&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;' + item.Committee_des + '</span></p>'
          })
        }
        if (this.DataCondi.length > 0) {
          this.DataCondi.map((item, idx) => {
            if (item.workAgeStart != item.workAgeEnd) {
              GroupExample += '<p class="custom-block-indent-a" style="margin-left:80px"><span style="font-family:THSarabunNew;">' + (idx + 1) + '. ' + item.PosName + '&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; อายุงาน &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;' + item.workAgeStart + '&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; - &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;' + item.workAgeEnd + '&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; ปี</span></p>'
            } else {
              GroupExample += '<p class="custom-block-indent-a" style="margin-left:80px"><span style="font-family:THSarabunNew;">' + (idx + 1) + '. ' + item.PosName + '&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; อายุงาน &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;' + item.workAgeStart + '&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; ปี</span></p>'

            }
          })
        }
        if (this.LecturerToShow.length > 0) {
          this.LecturerToShow.map((item, idx) => {
            if (item.Perid != '') {
              if (this.levelData.filter(lv_i => lv_i.LevelCode == item.pos_lv).length > 0) {
                lecturerTxt += '<p class="custom-block-indent-a" style="margin-left:80px"><span style="font-family:THSarabunNew;">' + (idx + 1) + '. ' + item.Name + '&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;' + item.pos_name + this.levelData.filter(lv_i => lv_i.LevelCode == item.pos_lv)[0].LevelName + '</span></p>'
              } else {
                lecturerTxt += '<p class="custom-block-indent-a" style="margin-left:80px"><span style="font-family:THSarabunNew;">' + (idx + 1) + '. ' + item.Name + '</span></p>'
              }
            } else {
              lecturerTxt += '<p class="custom-block-indent-a" style="margin-left:80px"><span style="font-family:THSarabunNew;">' + (idx + 1) + '. ' + item.Name + '</span></p>'
            }
          })
        }
        if (this.budgetData.length > 0) {
          this.budgetData.map((item, idx) => {
            if (item.Rm != '') {
              budgetTxt += '<p class="custom-block-indent-a"  style="margin-left:80px;"><span style="font-family:THSarabunNew;">' + (idx + 1) + '. ' + item.Expense_des + '(' + item.Rm + ') &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;  = &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;' + item.ReqMoney + '  บาท</span></p>'
            } else {
              budgetTxt += '<p class="custom-block-indent-a" style="margin-left:80px;"><span style="font-family:THSarabunNew;">' + (idx + 1) + '. ' + item.Expense_des + ' &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; =  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;' + item.ReqMoney + '  บาท</span></p>'
            }
            if (idx == this.budgetData.length - 1) {
              budgetTxt += '<p class="custom-block-indent-a"  style="margin-left:150px;"><span style="font-family:THSarabunNew;">' + ' รวม &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; =  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;' + this.Expense + '  บาท</span></p>'
            }
          })
        }
        if (this.DateStart == '' || this.DateEnd == '') {
          this.editorDataGenerate = '<p style="text-align:center;"><span style="font-family:THSarabunNew;;font-size:28px;">โครงการ' + this.projectGroupToShow + '</span></p><p style="text-align:center;"><span style="font-family:THSarabunNew;;font-size:28px;">เรื่อง ' + this.Project_name + '</span></p><p class="custom-block-indent-a" style="margin-left:40px" ><span style="font-family:THSarabunNew;;"><strong>หลักการและเหตุผล</strong></span></p><p class="custom-block-indent-a" style="margin-left:40px" >&nbsp;</p><p class="custom-block-indent-a" style="margin-left:40px" ><span style="font-family:THSarabunNew;;"><strong>วัตถุประสงค์</strong></span></p><p class="custom-block-indent-a" style="margin-left:40px" >&nbsp;</p><p class="custom-block-indent-a" style="margin-left:40px" ><span style="font-family:THSarabunNew;;"><strong>กลุ่มเป้าหมาย</strong></span></p><p class="custom-block-indent-a" style="margin-left:80px;"><span style="font-family:THSarabunNew;">' + GroupExample + '</span></p><p class="custom-block-indent-a" style="margin-left:40px" >&nbsp;</p><p class="custom-block-indent-a" style="margin-left:40px" ><span style="font-family:THSarabunNew;;"><strong>วิธีการจัดอบรม</strong></span></p><p class="custom-block-indent-a" style="margin-left:40px" >&nbsp;</p><p class="custom-block-indent-a" style="margin-left:40px" ><span style="font-family:THSarabunNew;;"><strong>ระยะเวลาจัดอบรม</strong></span></p><p class="custom-block-indent-a" style="margin-left:40px" >&nbsp;</p><p class="custom-block-indent-a" style="margin-left:40px" ><span style="font-family:THSarabunNew;;"><strong>ค่าลงทะเบียน</strong></span></p><p class="custom-block-indent-a" style="margin-left:40px" >&nbsp;</p><p class="custom-block-indent-a" style="margin-left:40px" ><span style="font-family:THSarabunNew;;"><strong>สถานที่จัดอบรม</strong></span></p><p class="custom-block-indent-a" style="margin-left:80px;"><span style="font-family:THSarabunNew;">' + this.Location + '</span></p><p class="custom-block-indent-a" style="margin-left:40px" >&nbsp;</p><p class="custom-block-indent-a" style="margin-left:40px" ><span style="font-family:THSarabunNew;;"><strong>ผลที่คาดว่าจะได้รับ</strong></span></p><p class="custom-block-indent-a" style="margin-left:40px" >&nbsp;</p><p class="custom-block-indent-a" style="margin-left:40px" ><span style="font-family:THSarabunNew;;"><strong>ผู้รับผิดชอบโครงการ</strong></span></p>' + committeeTxt + '<p class="custom-block-indent-a" style="margin-left:40px" >&nbsp;</p><p class="custom-block-indent-a" style="margin-left:40px" ><span style="font-family:THSarabunNew;;"><strong>วิทยากร</strong></span></p>' + lecturerTxt + '<p class="custom-block-indent-a" style="margin-left:40px" >&nbsp;</p><p class="custom-block-indent-a" style="margin-left:40px" ><span style="font-family:THSarabunNew;;"><strong>งบประมาณ</strong></span></p>' + budgetTxt + '<p class="custom-block-indent-a" style="margin-left:40px" >&nbsp;</p><p class="custom-block-indent-a" style="margin-left:40px" ><span style="font-family:THSarabunNew;;"><strong>หมายเหตุ</strong></span></p><p class="custom-block-indent-a" style="margin-left:40px" >&nbsp;</p><p class="custom-block-indent-a" style="margin-left:40px" >&nbsp;</p>'
          this.editorDataGenerate2 =
              '<div style="margin-left: 30px;">' +
              '<img src="PSU_Logo.png" width="90" height="100">' +
              '<strong><p style="font-family: Sarabun, sans-serif;font-size: 24px;text-align: center;margin-top: -40px">บันทึกข้อความ</p></strong>' +
              '</div>' +
              '<div style="margin-left: 30px;"><span style="font-weight: bold;font-family: Sarabun, sans-serif;font-size: 16px">ส่วนงาน </span> <span style="font-family: Sarabun, sans-serif;margin-left: 30px">ฝ่ายทรัพยากรมนุษย์</span> <span style="font-family: Sarabun, sans-serif;margin-left: 30px">คณะแพทยศาสตร์</span> <span style="font-family: Sarabun, sans-serif;margin-left: 30px">โทร.</span> <span style="font-family: Sarabun, sans-serif;margin-left: 10px">1143</span></div>' +
              '<div style="line-height: 2;margin-left: 30px;"><span style="font-weight: bold;font-family: Sarabun, sans-serif;font-size: 16px">ที่ </span> <span style="font-family: Sarabun, sans-serif;margin-left: 30px">......................</span> <span style="font-family: Sarabun, sans-serif;margin-left: 30px;font-weight: bold">วันที่</span> <span style="font-family: Sarabun, sans-serif;margin-left: 30px">' + Vue.filter('DateToThai')(this.GetCurrentDate()) + '</span></div>' +
              '<div style="line-height: 2;margin-left: 30px;"><span style="font-weight: bold;font-family: Sarabun, sans-serif;font-size: 16px">เรื่อง </span> <span style="font-family: Sarabun, sans-serif;margin-left: 30px">ขออนุมัติหลุกการและค่าใช้จ่ายเข้าร่วมอบรมโครงการ' + this.Project_name + '</span></div>' +
              '<div style="line-height: 2;margin-left: 30px;"><span style="font-weight: bold;font-family: Sarabun, sans-serif;font-size: 16px">เรียน </span> <span style="font-family: Sarabun, sans-serif;margin-left: 30px">คณบดี</span></div>' +
              '<p style="margin-left: 30px;"><span style="font-family: Sarabun, sans-serif;font-size: 16px;">&nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; ............................................</span></p>'
        } else {
          this.editorDataGenerate = '<p style="text-align:center;"><span style="font-family:THSarabunNew;;font-size:28px;">โครงการ' + this.projectGroupToShow + '</span></p><p style="text-align:center;"><span style="font-family:THSarabunNew;;font-size:28px;">เรื่อง ' + this.Project_name + '</span></p><p class="custom-block-indent-a" style="margin-left:40px" ><span style="font-family:THSarabunNew;;"><strong>หลักการและเหตุผล</strong></span></p><p class="custom-block-indent-a" style="margin-left:40px" >&nbsp;</p><p class="custom-block-indent-a" style="margin-left:40px" ><span style="font-family:THSarabunNew;;"><strong>วัตถุประสงค์</strong></span></p><p class="custom-block-indent-a" style="margin-left:40px" >&nbsp;</p><p class="custom-block-indent-a" style="margin-left:40px" ><span style="font-family:THSarabunNew;;"><strong>กลุ่มเป้าหมาย</strong></span></p><p class="custom-block-indent-a" style="margin-left:80px;"><span style="font-family:THSarabunNew;">' + GroupExample + '</span></p><p class="custom-block-indent-a" style="margin-left:40px" >&nbsp;</p><p class="custom-block-indent-a" style="margin-left:40px" ><span style="font-family:THSarabunNew;;"><strong>วิธีการจัดอบรม</strong></span></p><p class="custom-block-indent-a" style="margin-left:40px" >&nbsp;</p><p class="custom-block-indent-a" style="margin-left:40px" ><span style="font-family:THSarabunNew;;"><strong>ระยะเวลาจัดอบรม</strong></span></p><p class="custom-block-indent-a" style="margin-left:80px;"><span style="font-family:THSarabunNew;">วันที่ &nbsp;&nbsp;&nbsp;&nbsp;' + Vue.filter('DateToThai')(this.DateStart) + '&nbsp;&nbsp;&nbsp;&nbsp;ถึง&nbsp;&nbsp;&nbsp;&nbsp;' + Vue.filter('DateToThai')(this.DateEnd) + '</span></p><p class="custom-block-indent-a" style="margin-left:40px" >&nbsp;</p><p class="custom-block-indent-a" style="margin-left:40px" ><span style="font-family:THSarabunNew;;"><strong>ค่าลงทะเบียน</strong></span></p><p class="custom-block-indent-a" style="margin-left:40px" >&nbsp;</p><p class="custom-block-indent-a" style="margin-left:40px" ><span style="font-family:THSarabunNew;;"><strong>สถานที่จัดอบรม</strong></span></p><p class="custom-block-indent-a" style="margin-left:80px;"><span style="font-family:THSarabunNew;">' + this.Location + '</span></p><p class="custom-block-indent-a" style="margin-left:40px" >&nbsp;</p><p class="custom-block-indent-a" style="margin-left:40px" ><span style="font-family:THSarabunNew;;"><strong>ผลที่คาดว่าจะได้รับ</strong></span></p><p class="custom-block-indent-a" style="margin-left:40px" >&nbsp;</p><p class="custom-block-indent-a" style="margin-left:40px" ><span style="font-family:THSarabunNew;;"><strong>ผู้รับผิดชอบโครงการ</strong></span></p>' + committeeTxt + '<p class="custom-block-indent-a" style="margin-left:40px" >&nbsp;</p><p class="custom-block-indent-a" style="margin-left:40px" ><span style="font-family:THSarabunNew;;"><strong>วิทยากร</strong></span></p>' + lecturerTxt + '<p class="custom-block-indent-a" style="margin-left:40px" >&nbsp;</p><p class="custom-block-indent-a" style="margin-left:40px" ><span style="font-family:THSarabunNew;;"><strong>งบประมาณ</strong></span></p>' + budgetTxt + '<p class="custom-block-indent-a" style="margin-left:40px" >&nbsp;</p><p class="custom-block-indent-a" style="margin-left:40px" ><span style="font-family:THSarabunNew;;"><strong>หมายเหตุ</strong></span></p><p class="custom-block-indent-a" style="margin-left:40px" >&nbsp;</p><p class="custom-block-indent-a" style="margin-left:40px" >&nbsp;</p>'
          this.editorDataGenerate2 =
              '<div style="margin-left: 30px;">' +
              '<img src="PSU_Logo.png" width="90" height="100">' +
              '<strong><p style="font-family: Sarabun, sans-serif;font-size: 24px;text-align: center;margin-top: -40px">บันทึกข้อความ</p></strong>' +
              '</div>' +
              '<div style="margin-left: 30px;"><span style="font-weight: bold;font-family: Sarabun, sans-serif;font-size: 16px">ส่วนงาน </span> <span style="font-family: Sarabun, sans-serif;margin-left: 30px">ฝ่ายทรัพยากรมนุษย์</span> <span style="font-family: Sarabun, sans-serif;margin-left: 30px">คณะแพทยศาสตร์</span> <span style="font-family: Sarabun, sans-serif;margin-left: 30px">โทร.</span> <span style="font-family: Sarabun, sans-serif;margin-left: 10px">1143</span></div>' +
              '<div style="line-height: 2;margin-left: 30px;"><span style="font-weight: bold;font-family: Sarabun, sans-serif;font-size: 16px">ที่ </span> <span style="font-family: Sarabun, sans-serif;margin-left: 30px">......................</span> <span style="font-family: Sarabun, sans-serif;margin-left: 30px;font-weight: bold">วันที่</span> <span style="font-family: Sarabun, sans-serif;margin-left: 30px">' + Vue.filter('DateToThai')(this.GetCurrentDate()) + '</span></div>' +
              '<div style="line-height: 2;margin-left: 30px;"><span style="font-weight: bold;font-family: Sarabun, sans-serif;font-size: 16px">เรื่อง </span> <span style="font-family: Sarabun, sans-serif;margin-left: 30px">ขออนุมัติหลุกการและค่าใช้จ่ายเข้าร่วมอบรมโครงการ' + this.Project_name + '</span></div>' +
              '<div style="line-height: 2;margin-left: 30px;"><span style="font-weight: bold;font-family: Sarabun, sans-serif;font-size: 16px">เรียน </span> <span style="font-family: Sarabun, sans-serif;margin-left: 30px">คณบดี</span></div>' +
              '<p style="margin-left: 30px;"><span style="font-family: Sarabun, sans-serif;font-size: 16px;">&nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; ............................................</span></p>'
        }
      }
    },
    getFormGenerate() {
      var GroupExample = ''
      var committeeTxt = ''
      var lecturerTxt = ''
      var budgetTxt = ''
      if (this.Committee_ToShow.length > 0) {
        this.Committee_ToShow.map((item, idx) => {
          committeeTxt += '<p class="custom-block-indent-a" style="margin-left:80px"><span style="font-family:THSarabunNew;">' + (idx + 1) + '. ' + item.Name + '&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;' + item.Committee_des + '</span></p>'
        })
      }
      if (this.DataCondi.length > 0) {
        this.DataCondi.map((item, idx) => {
          if (item.workAgeStart != item.workAgeEnd) {
            GroupExample += '<p class="custom-block-indent-a" style="margin-left:80px"><span style="font-family:THSarabunNew;">' + (idx + 1) + '. ' + item.PosName + '&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; อายุงาน &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;' + item.workAgeStart + '&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; - &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;' + item.workAgeEnd + '&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; ปี</span></p>'
          } else {
            GroupExample += '<p class="custom-block-indent-a" style="margin-left:80px"><span style="font-family:THSarabunNew;">' + (idx + 1) + '. ' + item.PosName + '&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; อายุงาน &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;' + item.workAgeStart + '&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; ปี</span></p>'

          }
        })
      }
      if (this.LecturerToShow.length > 0) {
        this.LecturerToShow.map((item, idx) => {
          if (item.Perid != '') {
            if (this.levelData.filter(lv_i => lv_i.LevelCode == item.pos_lv).length > 0) {
              lecturerTxt += '<p class="custom-block-indent-a" style="margin-left:80px"><span style="font-family:THSarabunNew;">' + (idx + 1) + '. ' + item.Name + '&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;' + item.pos_name + this.levelData.filter(lv_i => lv_i.LevelCode == item.pos_lv)[0].LevelName + '</span></p>'
            } else {
              lecturerTxt += '<p class="custom-block-indent-a" style="margin-left:80px"><span style="font-family:THSarabunNew;">' + (idx + 1) + '. ' + item.Name + '</span></p>'
            }
          } else {
            lecturerTxt += '<p class="custom-block-indent-a" style="margin-left:80px"><span style="font-family:THSarabunNew;">' + (idx + 1) + '. ' + item.Name + '</span></p>'
          }
        })
      }
      if (this.budgetData.length > 0) {
        this.budgetData.map((item, idx) => {
          if (item.Rm != '') {
            budgetTxt += '<p class="custom-block-indent-a"  style="margin-left:80px;"><span style="font-family:THSarabunNew;">' + (idx + 1) + '. ' + item.Expense_des + '(' + item.Rm + ') &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;  = &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;' + item.ReqMoney + '  บาท</span></p>'
          } else {
            budgetTxt += '<p class="custom-block-indent-a" style="margin-left:80px;"><span style="font-family:THSarabunNew;">' + (idx + 1) + '. ' + item.Expense_des + ' &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; =  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;' + item.ReqMoney + '  บาท</span></p>'
          }
          if (idx == this.budgetData.length - 1) {
            budgetTxt += '<p class="custom-block-indent-a"  style="margin-left:150px;"><span style="font-family:THSarabunNew;">' + ' รวม &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; =  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;' + this.Expense + '  บาท</span></p>'
          }
        })
      }
      if (this.DateStart == '' || this.DateEnd == '') {
        this.editorDataGenerate = '<p style="text-align:center;"><span style="font-family:THSarabunNew;;font-size:28px;">โครงการ' + this.projectGroupToShow + '</span></p><p style="text-align:center;"><span style="font-family:THSarabunNew;;font-size:28px;">เรื่อง ' + this.Project_name + '</span></p><p class="custom-block-indent-a" style="margin-left:40px" ><span style="font-family:THSarabunNew;;"><strong>หลักการและเหตุผล</strong></span></p><p class="custom-block-indent-a" style="margin-left:40px" >&nbsp;</p><p class="custom-block-indent-a" style="margin-left:40px" ><span style="font-family:THSarabunNew;;"><strong>วัตถุประสงค์</strong></span></p><p class="custom-block-indent-a" style="margin-left:40px" >&nbsp;</p><p class="custom-block-indent-a" style="margin-left:40px" ><span style="font-family:THSarabunNew;;"><strong>กลุ่มเป้าหมาย</strong></span></p><p class="custom-block-indent-a" style="margin-left:80px;"><span style="font-family:THSarabunNew;">' + GroupExample + '</span></p><p class="custom-block-indent-a" style="margin-left:40px" >&nbsp;</p><p class="custom-block-indent-a" style="margin-left:40px" ><span style="font-family:THSarabunNew;;"><strong>วิธีการจัดอบรม</strong></span></p><p class="custom-block-indent-a" style="margin-left:40px" >&nbsp;</p><p class="custom-block-indent-a" style="margin-left:40px" ><span style="font-family:THSarabunNew;;"><strong>ระยะเวลาจัดอบรม</strong></span></p><p class="custom-block-indent-a" style="margin-left:40px" >&nbsp;</p><p class="custom-block-indent-a" style="margin-left:40px" ><span style="font-family:THSarabunNew;;"><strong>ค่าลงทะเบียน</strong></span></p><p class="custom-block-indent-a" style="margin-left:40px" >&nbsp;</p><p class="custom-block-indent-a" style="margin-left:40px" ><span style="font-family:THSarabunNew;;"><strong>สถานที่จัดอบรม</strong></span></p><p class="custom-block-indent-a" style="margin-left:80px;"><span style="font-family:THSarabunNew;">' + this.Location + '</span></p><p class="custom-block-indent-a" style="margin-left:40px" >&nbsp;</p><p class="custom-block-indent-a" style="margin-left:40px" ><span style="font-family:THSarabunNew;;"><strong>ผลที่คาดว่าจะได้รับ</strong></span></p><p class="custom-block-indent-a" style="margin-left:40px" >&nbsp;</p><p class="custom-block-indent-a" style="margin-left:40px" ><span style="font-family:THSarabunNew;;"><strong>ผู้รับผิดชอบโครงการ</strong></span></p>' + committeeTxt + '<p class="custom-block-indent-a" style="margin-left:40px" >&nbsp;</p><p class="custom-block-indent-a" style="margin-left:40px" ><span style="font-family:THSarabunNew;;"><strong>วิทยากร</strong></span></p>' + lecturerTxt + '<p class="custom-block-indent-a" style="margin-left:40px" >&nbsp;</p><p class="custom-block-indent-a" style="margin-left:40px" ><span style="font-family:THSarabunNew;;"><strong>งบประมาณ</strong></span></p>' + budgetTxt + '<p class="custom-block-indent-a" style="margin-left:40px" >&nbsp;</p><p class="custom-block-indent-a" style="margin-left:40px" ><span style="font-family:THSarabunNew;;"><strong>หมายเหตุ</strong></span></p><p class="custom-block-indent-a" style="margin-left:40px" >&nbsp;</p><p class="custom-block-indent-a" style="margin-left:40px" >&nbsp;</p>'
        this.editorDataGenerate2 =
            '<div style="margin-left: 30px;">' +
            '<img src="PSU_Logo.png" width="90" height="100">' +
            '<strong><p style="font-family: Sarabun, sans-serif;font-size: 24px;text-align: center;margin-top: -40px">บันทึกข้อความ</p></strong>' +
            '</div>' +
            '<div style="margin-left: 30px;"><span style="font-weight: bold;font-family: Sarabun, sans-serif;font-size: 16px">ส่วนงาน </span> <span style="font-family: Sarabun, sans-serif;margin-left: 30px">ฝ่ายทรัพยากรมนุษย์</span> <span style="font-family: Sarabun, sans-serif;margin-left: 30px">คณะแพทยศาสตร์</span> <span style="font-family: Sarabun, sans-serif;margin-left: 30px">โทร.</span> <span style="font-family: Sarabun, sans-serif;margin-left: 10px">1143</span></div>' +
            '<div style="line-height: 2;margin-left: 30px;"><span style="font-weight: bold;font-family: Sarabun, sans-serif;font-size: 16px">ที่ </span> <span style="font-family: Sarabun, sans-serif;margin-left: 30px">......................</span> <span style="font-family: Sarabun, sans-serif;margin-left: 30px;font-weight: bold">วันที่</span> <span style="font-family: Sarabun, sans-serif;margin-left: 30px">' + Vue.filter('DateToThai')(this.GetCurrentDate()) + '</span></div>' +
            '<div style="line-height: 2;margin-left: 30px;"><span style="font-weight: bold;font-family: Sarabun, sans-serif;font-size: 16px">เรื่อง </span> <span style="font-family: Sarabun, sans-serif;margin-left: 30px">ขออนุมัติหลุกการและค่าใช้จ่ายเข้าร่วมอบรมโครงการ' + this.Project_name + '</span></div>' +
            '<div style="line-height: 2;margin-left: 30px;"><span style="font-weight: bold;font-family: Sarabun, sans-serif;font-size: 16px">เรียน </span> <span style="font-family: Sarabun, sans-serif;margin-left: 30px">คณบดี</span></div>' +
            '<p style="margin-left: 30px;"><span style="font-family: Sarabun, sans-serif;font-size: 16px;">&nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; ............................................</span></p>'
      } else {
        this.editorDataGenerate = '<p style="text-align:center;"><span style="font-family:THSarabunNew;;font-size:28px;">โครงการ' + this.projectGroupToShow + '</span></p><p style="text-align:center;"><span style="font-family:THSarabunNew;;font-size:28px;">เรื่อง ' + this.Project_name + '</span></p><p class="custom-block-indent-a" style="margin-left:40px" ><span style="font-family:THSarabunNew;;"><strong>หลักการและเหตุผล</strong></span></p><p class="custom-block-indent-a" style="margin-left:40px" >&nbsp;</p><p class="custom-block-indent-a" style="margin-left:40px" ><span style="font-family:THSarabunNew;;"><strong>วัตถุประสงค์</strong></span></p><p class="custom-block-indent-a" style="margin-left:40px" >&nbsp;</p><p class="custom-block-indent-a" style="margin-left:40px" ><span style="font-family:THSarabunNew;;"><strong>กลุ่มเป้าหมาย</strong></span></p><p class="custom-block-indent-a" style="margin-left:80px;"><span style="font-family:THSarabunNew;">' + GroupExample + '</span></p><p class="custom-block-indent-a" style="margin-left:40px" >&nbsp;</p><p class="custom-block-indent-a" style="margin-left:40px" ><span style="font-family:THSarabunNew;;"><strong>วิธีการจัดอบรม</strong></span></p><p class="custom-block-indent-a" style="margin-left:40px" >&nbsp;</p><p class="custom-block-indent-a" style="margin-left:40px" ><span style="font-family:THSarabunNew;;"><strong>ระยะเวลาจัดอบรม</strong></span></p><p class="custom-block-indent-a" style="margin-left:80px;"><span style="font-family:THSarabunNew;">วันที่ &nbsp;&nbsp;&nbsp;&nbsp;' + Vue.filter('DateToThai')(this.DateStart) + '&nbsp;&nbsp;&nbsp;&nbsp;ถึง&nbsp;&nbsp;&nbsp;&nbsp;' + Vue.filter('DateToThai')(this.DateEnd) + '</span></p><p class="custom-block-indent-a" style="margin-left:40px" >&nbsp;</p><p class="custom-block-indent-a" style="margin-left:40px" ><span style="font-family:THSarabunNew;;"><strong>ค่าลงทะเบียน</strong></span></p><p class="custom-block-indent-a" style="margin-left:40px" >&nbsp;</p><p class="custom-block-indent-a" style="margin-left:40px" ><span style="font-family:THSarabunNew;;"><strong>สถานที่จัดอบรม</strong></span></p><p class="custom-block-indent-a" style="margin-left:80px;"><span style="font-family:THSarabunNew;">' + this.Location + '</span></p><p class="custom-block-indent-a" style="margin-left:40px" >&nbsp;</p><p class="custom-block-indent-a" style="margin-left:40px" ><span style="font-family:THSarabunNew;;"><strong>ผลที่คาดว่าจะได้รับ</strong></span></p><p class="custom-block-indent-a" style="margin-left:40px" >&nbsp;</p><p class="custom-block-indent-a" style="margin-left:40px" ><span style="font-family:THSarabunNew;;"><strong>ผู้รับผิดชอบโครงการ</strong></span></p>' + committeeTxt + '<p class="custom-block-indent-a" style="margin-left:40px" >&nbsp;</p><p class="custom-block-indent-a" style="margin-left:40px" ><span style="font-family:THSarabunNew;;"><strong>วิทยากร</strong></span></p>' + lecturerTxt + '<p class="custom-block-indent-a" style="margin-left:40px" >&nbsp;</p><p class="custom-block-indent-a" style="margin-left:40px" ><span style="font-family:THSarabunNew;;"><strong>งบประมาณ</strong></span></p>' + budgetTxt + '<p class="custom-block-indent-a" style="margin-left:40px" >&nbsp;</p><p class="custom-block-indent-a" style="margin-left:40px" ><span style="font-family:THSarabunNew;;"><strong>หมายเหตุ</strong></span></p><p class="custom-block-indent-a" style="margin-left:40px" >&nbsp;</p><p class="custom-block-indent-a" style="margin-left:40px" >&nbsp;</p>'
        this.editorDataGenerate2 =
            '<div style="margin-left: 30px;">' +
            '<img src="PSU_Logo.png" width="90" height="100">' +
            '<strong><p style="font-family: Sarabun, sans-serif;font-size: 24px;text-align: center;margin-top: -40px">บันทึกข้อความ</p></strong>' +
            '</div>' +
            '<div style="margin-left: 30px;"><span style="font-weight: bold;font-family: Sarabun, sans-serif;font-size: 16px">ส่วนงาน </span> <span style="font-family: Sarabun, sans-serif;margin-left: 30px">ฝ่ายทรัพยากรมนุษย์</span> <span style="font-family: Sarabun, sans-serif;margin-left: 30px">คณะแพทยศาสตร์</span> <span style="font-family: Sarabun, sans-serif;margin-left: 30px">โทร.</span> <span style="font-family: Sarabun, sans-serif;margin-left: 10px">1143</span></div>' +
            '<div style="line-height: 2;margin-left: 30px;"><span style="font-weight: bold;font-family: Sarabun, sans-serif;font-size: 16px">ที่ </span> <span style="font-family: Sarabun, sans-serif;margin-left: 30px">......................</span> <span style="font-family: Sarabun, sans-serif;margin-left: 30px;font-weight: bold">วันที่</span> <span style="font-family: Sarabun, sans-serif;margin-left: 30px">' + Vue.filter('DateToThai')(this.GetCurrentDate()) + '</span></div>' +
            '<div style="line-height: 2;margin-left: 30px;"><span style="font-weight: bold;font-family: Sarabun, sans-serif;font-size: 16px">เรื่อง </span> <span style="font-family: Sarabun, sans-serif;margin-left: 30px">ขออนุมัติหลุกการและค่าใช้จ่ายเข้าร่วมอบรมโครงการ' + this.Project_name + '</span></div>' +
            '<div style="line-height: 2;margin-left: 30px;"><span style="font-weight: bold;font-family: Sarabun, sans-serif;font-size: 16px">เรียน </span> <span style="font-family: Sarabun, sans-serif;margin-left: 30px">คณบดี</span></div>' +
            '<p style="margin-left: 30px;"><span style="font-family: Sarabun, sans-serif;font-size: 16px;">&nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; ............................................</span></p>'
      }
      this.editorData = this.editorDataGenerate
      this.editorData2 = this.editorDataGenerate2
    },
    ShowData: function (dataUrl) {
      window.open(
          dataUrl,
          '_blank' // <- This is what makes it open in a new window.
      );

    },
    DeleteFile(file_i) {
      const headerAxiosDel = {
        headers: {
          'Content-Type': 'application/json',
          'X-REST-METHOD': 'DELETE'
        }
      }
      axios.post(ConstData.ConnectionHost + '/app-api/v2/?/apis/hrtrain/D_project_files/id/' + file_i.id, '', headerAxiosDel).then(res => {
        if (res.data.status) {
          if (this.FileProject.length > 0) {
            this.FileProject.map((item, idx) => {
              if (item.name == file_i.name) {
                this.FileProject.splice(idx, 1)
              }
            })
          }
        }
      })
    },
    DeleteFile2(file_i) {
      this.FileProjectExpert.map((item, idx) => {
        if (item.name == file_i.name) {
          this.FileProjectExpert.splice(idx, 1)
        }
      })
    },
    FileSelect: function () {
      // var count = 0
      this.txtAlert = []
      // this.FileProject = []
      this.alert = false
      if (this.files.length > 0) {
        this.files.map((item) => {
          var Checkfile = false;
          switch (item.type) {
            case 'image/jpg':
            case 'image/jpeg':
            case 'image/gif':
            case 'image/bmp':
            case 'image/png':
              Checkfile = true;
              break
            case 'application/pdf':
              Checkfile = true;
              break
            default:
              Checkfile = false;
              break
          }

          if (Checkfile) {
            if (item.size > 25000000) {
              this.txtAlert.push({
                id: this.txtAlert.length + 1,
                Detail: 'ไฟล์ ' + item.name + ' ขนาดเกิน 25 mb*'
              })
            } else {
              const fd = new FormData()
              fd.append('file', item, item.name)
              const headerAxios = {
                headers: {
                  'Content-Type': 'multipart/form-data',
                  'WithCredentials': true,
                  "Access-Control-Allow-Origin": "*"
                  // "Accept": 'multipart/form-data'
                }
              }

              axios.post(ConstData.ConnectionHost + '/rest/v1/hrcardnew/uploadfile', fd, headerAxios).then(res => {
                if (res.data.status) {
                  switch (item.type) {
                    case 'image/jpg':
                    case 'image/jpeg':
                    case 'image/gif':
                    case 'image/bmp':
                    case 'image/png':
                      this.FileProject.push({
                        name: item.name,
                        src: URL.createObjectURL(item),
                        path: res.data.path,
                        type: 'image',
                        type_Img: item.type
                      })
                      break
                    case 'application/pdf':
                      this.FileProject.push({
                        name: item.name,
                        src: URL.createObjectURL(item),
                        path: res.data.path,
                        type: 'pdf',
                        type_Img: item.type
                      })
                      break
                    default:
                      break
                  }

                  // count++
                  //
                  // if (count === this.files.length) {
                  //     this.FileProjectPdf = []
                  //     this.FileProject = []
                  // }
                }
              })
            }
          } else {
            this.txtAlert.push({
              id: this.txtAlert.length + 1,
              Detail: 'ไม่สนับสนุนนามสกุลไฟล์ ' + item.type.split('/')[1] + ' ( ' + item.name + ' ) '
            })
            this.alert = true
          }
        })
      }

      // if (this.txtAlert.length == 0) {
      //     this.files.map((item) => {
      //         const fd = new FormData()
      //         fd.append('file', item, item.name)
      //         const headerAxios = {
      //             headers: {
      //                 'Content-Type': 'multipart/form-data',
      //                 'WithCredentials': true,
      //                 "Access-Control-Allow-Origin": "*"
      //                 // "Accept": 'multipart/form-data'
      //             }
      //         }
      //
      //         axios.post(ConstData.ConnectionHost + '/rest/v1/hrcardnew/uploadfile', fd, headerAxios).then(res => {
      //             if (res.data.status) {
      //                 switch (item.type) {
      //                     case 'image/jpg':
      //                     case 'image/jpeg':
      //                     case 'image/gif':
      //                     case 'image/bmp':
      //                     case 'image/png':
      //                         this.FileProject.push({
      //                             name: item.name,
      //                             src: URL.createObjectURL(item),
      //                             path: res.data.path,
      //                             type: 'image',
      //                             type_Img: item.type
      //                         })
      //                         break
      //                     case 'application/pdf':
      //                         this.FileProject.push({
      //                             name: item.name,
      //                             src: URL.createObjectURL(item),
      //                             path: res.data.path,
      //                             type: 'pdf',
      //                             type_Img: item.type
      //                         })
      //                         break
      //                     default:
      //                         break
      //                 }
      //
      //                 // count++
      //                 //
      //                 // if (count === this.files.length) {
      //                 //     this.FileProjectPdf = []
      //                 //     this.FileProject = []
      //                 // }
      //             }
      //         })
      //     })
      //
      // } else {
      //     this.alert = true
      // }

    },
    FileSelectExpert: function () {
      // var count = 0
      this.txtAlert = []
      this.FileProjectExpert = []
      this.alertExpert = false
      if (this.filesExpert.length > 0) {
        this.filesExpert.map((item) => {
          var Checkfile = false;
          switch (item.type) {
            case 'image/jpg':
            case 'image/jpeg':
            case 'image/gif':
            case 'image/bmp':
            case 'image/png':
              Checkfile = true;
              break
            case 'application/pdf':
              Checkfile = true;
              break
            default:
              Checkfile = false;
              break
          }

          if (Checkfile) {
            if (item.size > 4096 * 4096) {
              this.txtAlertExpert.push({
                id: this.txtAlertExpert.length + 1,
                Detail: 'ไฟล์ ' + item.name + ' ขนาดเกิน 8 mb*'
              })
            }
          } else {
            this.txtAlertExpert.push({
              id: this.txtAlertExpert.length + 1,
              Detail: 'ไม่สนับสนุนนามสกุลไฟล์ ' + item.type.split('/')[1] + ' ( ' + item.name + ' ) '
            })
          }
        })
      }

      if (this.txtAlertExpert.length == 0) {
        this.filesExpert.map((item) => {
          const fd = new FormData()
          fd.append('file', item, item.name)
          const headerAxios = {
            headers: {
              'Content-Type': 'multipart/form-data',
              'WithCredentials': true,
              "Access-Control-Allow-Origin": "*"
              // "Accept": 'multipart/form-data'
            }
          }

          axios.post(ConstData.ConnectionHost + '/rest/v1/hrcardnew/uploadfile', fd, headerAxios).then(res => {
            if (res.data.status) {
              switch (item.type) {
                case 'image/jpg':
                case 'image/jpeg':
                case 'image/gif':
                case 'image/bmp':
                case 'image/png':
                  this.FileProjectExpert.push({
                    name: item.name,
                    src: URL.createObjectURL(item),
                    path: res.data.path,
                    type: 'image',
                    type_Img: item.type,
                    File_name: item.name,
                    File_path: res.data.path,
                    File_type: 'image',
                  })
                  break
                case 'application/pdf':
                  this.FileProjectExpert.push({
                    name: item.name,
                    src: URL.createObjectURL(item),
                    path: res.data.path,
                    type: 'pdf',
                    type_Img: item.type,
                    File_name: item.name,
                    File_path: res.data.path,
                    File_type: 'image',
                  })
                  break
                default:
                  break
              }

              // count++
              //
              // if (count === this.files.length) {
              //     this.FileProjectPdf = []
              //     this.FileProject = []
              // }
            }
          })
        })

      } else {
        this.alertExpert = true
      }
    },
    DeleteExpense_p(item) {
      this.expense_p_DataForSubmit.map((item_e, idx) => {
        if (item.id == item_e.id) {
          this.expense_p_DataForSubmit.splice(idx, 1)
        }
      })
    },
    DeleteExpense(item) {
      this.expense_DataForSubmit.map((item_e, idx) => {
        if (item.id == item_e.id) {
          this.expense_DataForSubmit.splice(idx, 1)
        }
      })
    },
    DeleteCoordinator(data) {
      this.Coordinator.map((item, idx) => {
        if (item.name == data.name) {
          this.Coordinator.splice(idx, 1)
        }
      })
      this.WorkGroupData.map((item, idx) => {
        if (item.perid == data.Perid) {
          this.WorkGroupData.splice(idx, 1)
        }
      })
    },
    UpdateName(perid) {
      this.staffData.map((item) => {
        if (item.perid == perid) {
          this.full_name = item.full_Name
        }
      })
    },
    InsertCoordinator(Condi) {
      var committ_desc = ''

      if (this.full_name != '' && this.phone != '' && this.Committee_code != '') {

        if ((this.Committee_code == '6' || this.Committee_code == '23' || this.Committee_code == '24') && !Condi) {
          if (this.radioGroup == '1' || this.radioGroup == '3') {
            if (this.committee_Posi.filter(commit_i => commit_i.Committee_code == this.Committee_code).length > 0) {
              committ_desc = this.committee_Posi.filter(commit_i => commit_i.Committee_code == this.Committee_code)[0].committee_des
            }

            if (this.Coordinator.length > 0) {
              if (this.radioGroup == '0') {
                var CheckCupe = false
                this.Coordinator.map((CoorItem) => {
                  if (CoorItem.Name == this.full_name && CoorItem.Committee_code == this.Committee_code) {
                    CheckCupe = true
                  }
                })
                if (CheckCupe) {
                  this.$swal.fire({
                    icon: 'error',
                    title: 'พบข้อมูลรายชื่อ ' + this.full_name + ' และตำแหน่งที่เลือกในระบบอยู่แล้ว'
                  })
                } else {
                  this.staffData.map((item) => {
                    if (item.perid == this.perid) {
                      if (this.radioGroup == '0') {
                        this.Coordinator.push({
                          ...item,
                          Project_code: this.Project_code,
                          Committee_code: this.Committee_code,
                          Committee_type: this.radioGroup,
                          Committee_des: committ_desc,
                          Name: this.full_name,
                          Perid: this.perid,
                          TEL: this.phone,
                        })
                      } else {
                        this.Coordinator.push({
                          ...item,
                          Project_code: this.Project_code,
                          Committee_code: this.Committee_code,
                          Committee_type: this.radioGroup,
                          Committee_des: committ_desc,
                          Name: this.full_name,
                          Perid: '',
                          TEL: this.phone,
                        })
                      }
                    }
                  })
                  this.Committee_ToShow = this.Coordinator.filter(itemLecturer => itemLecturer.Committee_code != '6' && itemLecturer.Committee_code != '23' && itemLecturer.Committee_code != '24')
                  this.LecturerToShow = this.Coordinator.filter(itemLecturer => itemLecturer.Committee_code == '6' || itemLecturer.Committee_code == '23' || itemLecturer.Committee_code == '24')
                  if (this.Committee_ToShow.length > 0) {
                    this.Committee_ToShow.map((Committee_i, idx) => {
                      Committee_i.index = (idx + 1)
                    })
                  }
                  if (this.LecturerToShow.length > 0) {
                    this.LecturerToShow.map((lecture_i, idx) => {
                      lecture_i.index = (idx + 1)
                    })
                  }
                  this.Committee_code = ''
                  this.perid = ''
                  this.full_name = ''
                  this.phone = ''
                }
              } else {
                this.Coordinator.push({
                  Project_code: this.Project_code,
                  Committee_code: this.Committee_code,
                  Committee_type: this.radioGroup,
                  Committee_des: committ_desc,
                  Name: this.full_name,
                  Perid: '',
                  TEL: this.phone,
                })
                this.Committee_ToShow = this.Coordinator.filter(itemLecturer => itemLecturer.Committee_code != '6' && itemLecturer.Committee_code != '23' && itemLecturer.Committee_code != '24')
                this.LecturerToShow = this.Coordinator.filter(itemLecturer => itemLecturer.Committee_code == '6' || itemLecturer.Committee_code == '23' || itemLecturer.Committee_code == '24')
                this.Committee_code = ''
                this.perid = ''
                this.full_name = ''
                this.phone = ''
              }
            } else {
              if (this.radioGroup == '0') {
                this.staffData.map((item) => {
                  if (item.perid == this.perid) {
                    if (this.radioGroup == '0') {
                      this.Coordinator.push({
                        ...item,
                        Project_code: this.Project_code,
                        Committee_code: this.Committee_code,
                        Committee_type: this.radioGroup,
                        Committee_des: committ_desc,
                        Name: this.full_name,
                        Perid: this.perid,
                        TEL: this.phone,
                      })
                    } else {
                      this.Coordinator.push({
                        ...item,
                        Project_code: this.Project_code,
                        Committee_code: this.Committee_code,
                        Committee_type: this.radioGroup,
                        Committee_des: committ_desc,
                        Name: this.full_name,
                        Perid: '',
                        TEL: this.phone,
                      })
                    }
                  }
                })
                this.Committee_ToShow = this.Coordinator.filter(itemLecturer => itemLecturer.Committee_code != '6' && itemLecturer.Committee_code != '23' && itemLecturer.Committee_code != '24')
                this.LecturerToShow = this.Coordinator.filter(itemLecturer => itemLecturer.Committee_code == '6' || itemLecturer.Committee_code == '23' || itemLecturer.Committee_code == '24')
                if (this.Committee_ToShow.length > 0) {
                  this.Committee_ToShow.map((Committee_i, idx) => {
                    Committee_i.index = (idx + 1)
                  })
                }
                if (this.LecturerToShow.length > 0) {
                  this.LecturerToShow.map((lecture_i, idx) => {
                    lecture_i.index = (idx + 1)
                  })
                }
                this.Committee_code = ''
                this.perid = ''
                this.full_name = ''
                this.phone = ''
              } else {
                this.Coordinator.push({
                  Project_code: this.Project_code,
                  Committee_code: this.Committee_code,
                  Committee_type: this.radioGroup,
                  Committee_des: committ_desc,
                  Name: this.full_name,
                  Perid: '',
                  TEL: this.phone,
                })
                this.Committee_ToShow = this.Coordinator.filter(itemLecturer => itemLecturer.Committee_code != '6' && itemLecturer.Committee_code != '23' && itemLecturer.Committee_code != '24')
                this.LecturerToShow = this.Coordinator.filter(itemLecturer => itemLecturer.Committee_code == '6' || itemLecturer.Committee_code == '23' || itemLecturer.Committee_code == '24')
                this.Committee_code = ''
                this.perid = ''
                this.full_name = ''
                this.phone = ''
              }
            }
          } else {
            this.dialogLecturer = true
            this.LecturerProjectName = this.Project_name
            this.LecturerHour = this.CalHourse
            this.LecturerInvite = this.WorkByName
            this.LecturerPlace = this.Location
            this.dateSForLecturer = this.DateStart
            this.dateEForLecturer = this.DateEnd
          }
        } else {
          if ((this.Committee_code == '6' || this.Committee_code == '23' || this.Committee_code == '24') && this.Lecturer.length == 0) {
            this.$swal.fire({
              icon: 'error',
              title: 'กรุณากรอกข้อมูลการเป็นวิทยากรให้ครบถ้วน'
            })
          } else {
            this.dialogLecturer = false
            this.WorkGroupData = this.WorkGroupData.concat(this.Lecturer)
            this.SubjectForLecturer = ''
            this.dateSTravelForLecturer = ''
            this.dateETravelForLecturer = ''
            this.dateSForLecturer = ''
            this.dateEForLecturer = ''
            this.timeSForLecturer = ''
            this.timeEForLecturer = ''
            this.FileProjectExpert = []
            this.filesExpert = []
            this.txtAlertExpert = []
            this.Lecturer = []

            if (this.committee_Posi.filter(commit_i => commit_i.Committee_code == this.Committee_code).length > 0) {
              committ_desc = this.committee_Posi.filter(commit_i => commit_i.Committee_code == this.Committee_code)[0].committee_des
            }

            if (this.Coordinator.length > 0) {
              if (this.radioGroup == '0') {
                CheckCupe = false
                this.Coordinator.map((CoorItem) => {
                  if (CoorItem.Name == this.full_name && CoorItem.Committee_code == this.Committee_code) {
                    CheckCupe = true
                  }
                })
                if (CheckCupe) {
                  this.$swal.fire({
                    icon: 'error',
                    title: 'พบข้อมูลรายชื่อ ' + this.full_name + ' และตำแหน่งที่เลือกในระบบอยู่แล้ว'
                  })
                } else {
                  this.staffData.map((item) => {
                    if (item.perid == this.perid) {
                      if (this.radioGroup == '0') {
                        this.Coordinator.push({
                          ...item,
                          Project_code: this.Project_code,
                          Committee_code: this.Committee_code,
                          Committee_type: this.radioGroup,
                          Committee_des: committ_desc,
                          Name: this.full_name,
                          Perid: this.perid,
                          TEL: this.phone,
                        })
                      } else {
                        this.Coordinator.push({
                          ...item,
                          Project_code: this.Project_code,
                          Committee_code: this.Committee_code,
                          Committee_type: this.radioGroup,
                          Committee_des: committ_desc,
                          Name: this.full_name,
                          Perid: '',
                          TEL: this.phone,
                        })
                      }
                    }
                  })
                  this.Committee_ToShow = this.Coordinator.filter(itemLecturer => itemLecturer.Committee_code != '6' && itemLecturer.Committee_code != '23' && itemLecturer.Committee_code != '24')
                  this.LecturerToShow = this.Coordinator.filter(itemLecturer => itemLecturer.Committee_code == '6' || itemLecturer.Committee_code == '23' || itemLecturer.Committee_code == '24')
                  if (this.Committee_ToShow.length > 0) {
                    this.Committee_ToShow.map((Committee_i, idx) => {
                      Committee_i.index = (idx + 1)
                    })
                  }
                  if (this.LecturerToShow.length > 0) {
                    this.LecturerToShow.map((lecture_i, idx) => {
                      lecture_i.index = (idx + 1)
                    })
                  }
                  this.Committee_code = ''
                  this.perid = ''
                  this.full_name = ''
                  this.phone = ''
                }
              } else {
                this.Coordinator.push({
                  Project_code: this.Project_code,
                  Committee_code: this.Committee_code,
                  Committee_type: this.radioGroup,
                  Committee_des: committ_desc,
                  Name: this.full_name,
                  Perid: '',
                  TEL: this.phone,
                })
                this.Committee_ToShow = this.Coordinator.filter(itemLecturer => itemLecturer.Committee_code != '6' && itemLecturer.Committee_code != '23' && itemLecturer.Committee_code != '24')
                this.LecturerToShow = this.Coordinator.filter(itemLecturer => itemLecturer.Committee_code == '6' || itemLecturer.Committee_code == '23' || itemLecturer.Committee_code == '24')
                this.Committee_code = ''
                this.perid = ''
                this.full_name = ''
                this.phone = ''
              }
            } else {
              if (this.radioGroup == '0') {
                this.staffData.map((item) => {
                  if (item.perid == this.perid) {
                    if (this.radioGroup == '0') {
                      this.Coordinator.push({
                        ...item,
                        Project_code: this.Project_code,
                        Committee_code: this.Committee_code,
                        Committee_type: this.radioGroup,
                        Committee_des: committ_desc,
                        Name: this.full_name,
                        Perid: this.perid,
                        TEL: this.phone,
                      })
                    } else {
                      this.Coordinator.push({
                        ...item,
                        Project_code: this.Project_code,
                        Committee_code: this.Committee_code,
                        Committee_type: this.radioGroup,
                        Committee_des: committ_desc,
                        Name: this.full_name,
                        Perid: '',
                        TEL: this.phone,
                      })
                    }
                  }
                })
                this.Committee_ToShow = this.Coordinator.filter(itemLecturer => itemLecturer.Committee_code != '6' && itemLecturer.Committee_code != '23' && itemLecturer.Committee_code != '24')
                this.LecturerToShow = this.Coordinator.filter(itemLecturer => itemLecturer.Committee_code == '6' || itemLecturer.Committee_code == '23' || itemLecturer.Committee_code == '24')
                if (this.Committee_ToShow.length > 0) {
                  this.Committee_ToShow.map((Committee_i, idx) => {
                    Committee_i.index = (idx + 1)
                  })
                }
                if (this.LecturerToShow.length > 0) {
                  this.LecturerToShow.map((lecture_i, idx) => {
                    lecture_i.index = (idx + 1)
                  })
                }
                this.Committee_code = ''
                this.perid = ''
                this.full_name = ''
                this.phone = ''
              } else {
                this.Coordinator.push({
                  Project_code: this.Project_code,
                  Committee_code: this.Committee_code,
                  Committee_type: this.radioGroup,
                  Committee_des: committ_desc,
                  Name: this.full_name,
                  Perid: '',
                  TEL: this.phone,
                })
                this.Committee_ToShow = this.Coordinator.filter(itemLecturer => itemLecturer.Committee_code != '6' && itemLecturer.Committee_code != '23' && itemLecturer.Committee_code != '24')
                this.LecturerToShow = this.Coordinator.filter(itemLecturer => itemLecturer.Committee_code == '6' || itemLecturer.Committee_code == '23' || itemLecturer.Committee_code == '24')
                this.Committee_code = ''
                this.perid = ''
                this.full_name = ''
                this.phone = ''
              }
            }
          }
        }
      } else {
        this.$swal.fire({
          icon: 'error',
          title: 'กรุณากรอกชื่อ-สกุล ตำแหน่ง และ เบอร์โทร,ของผู้ประสานงานโครงการให้ครบถ้วน'
        })
      }
    },
    getLecturer(param) {
      return new Promise(resolve => {
        var dumpArr = []
        axios.get(ConstData.ConnectionHost + '/app-api/v2/?/apis/hrtrain/Lecturer/perid/' + param.perid + '/Ref_id/' + param.Ref_id).then(res => {
          if (res.data) {
            if (res.data.length > 0) {
              dumpArr = res.data
            } else {
              dumpArr.push(res.data)
            }
          } else {
            dumpArr = null
          }
          resolve(dumpArr)
        }).catch(res => {
          if (res) {
            resolve(null)
          }
        })
      })
    },
    getTrainFiles(Ref_id) {
      return new Promise(resolve => {
        var dumpArr = []
        axios.get(ConstData.ConnectionHost + '/app-api/v2/?/apis/hrtrain/train_files/Ref_id/' + Ref_id).then(res => {
          if (res.data) {
            if (res.data.length > 0) {
              dumpArr = res.data
            } else {
              dumpArr.push(res.data)
            }
          } else {
            dumpArr = []
          }
          resolve(dumpArr)
        })
      })
    },
    Choose_Project() {
      this.Expense = 0
      this.files = []
      this.Coordinator = []
      this.courseCondi = []
      this.competency_DataForSubmit = []
      this.expense_DataForSubmit = []
      this.expense_p_DataForSubmit = []
      this.FileProject = []
      this.DataCondi = []
      this.JoinPerson = []
      this.selection = []
      this.budgetData = []
      this.Lecturer = []
      this.TemplateProject = []
      this.DepQuotaData = []
      this.ChooseTypeDep = '0'
      this.ChooseTypRegis = '1'
      this.ChooseTypRegis2 = '0'
      this.dateRegStart = ''
      this.dateRegEnd = ''
      this.ProjectQuotaCount = ''
      this.ProjectQuotaDepCount = 0
      this.MessageSuc = ''
      this.MessageError = ''
      this.ChkJoinPerson = true
      this.ShowAlertErr = false
      this.ShowAlertSuc = false
      this.DepQuotaSelect = ''
      this.DepQuotaCount = ''
      this.DepQuotaData = []
      this.RoundData = []
      this.e1 = '1'
      this.Ref_id = ''
      this.DataCondiDel = []
      this.RoundDataDel = []
      this.JoinPersonDel = []
      this.DepQuotaDataDel = []
      this.IsRoundStatus = ''

      this.projectNeed = false
      this.initProjectCompetencyData({
        Project_code: this.Project_Choose
      }).then(res => {
        if (res) {
          this.ProjectCompetency.map(ProjectCom => {
            this.selection.push(ProjectCom.DelvNo)
          })
        }
      })

      this.initProjectExpenseData({
        Project_code: this.Project_Choose
      }).then(res => {
        if (res) {
          this.ProjectExpense.map(ProjectEx => {
            this.expense_Data.map(expenseData => {
              if (ProjectEx.Expense_id == expenseData.cost_id) {
                this.budgetData.push({
                  Expense_id: expenseData.cost_id,
                  Expense_des: expenseData.cost_desc,
                  ReqMoney: ProjectEx.ReqMoney,
                  Rm: ProjectEx.Rm
                })
                this.Expense += parseFloat(ProjectEx.ReqMoney)
              }
            })

          })
        }
      })

      axios.get(ConstData.ConnectionHost + '/app-api/v2/?/apis/hrtrain/D_project_view/Project_code/' + this.Project_Choose).then(res => {
        if (res.data) {
          this.Project_code = res.data.Project_code
          this.Project_name = res.data.Project_name
          this.Course_code = res.data.Course_code
          this.course_group = res.data.Course_group
          this.Project_type = res.data.Project_type
          this.Remarks = res.data.Remarks
          this.CalCredit = res.data.CalCredit
          this.CalHourse = res.data.CalHourse
          this.PLACE = res.data.PLACE
          this.Province_id = res.data.Province_id
          this.Country_id = res.data.Country_id
          this.BudgetRequest = res.data.BudgetRequest
          this.Location = res.data.Location
          this.WorkBy = res.data.WorkBy
          this.WorkByName = res.data.WorkByName
          this.DateStart = res.data.DateStart
          this.DateEnd = res.data.DateEnd
          this.DepSelect = res.data.Dep_Code
          this.Approve = res.data.Approve
          this.ApproveRadio = res.data.Approve
          this.Project_group = res.data.Project_group
          this.FiscalYear = parseInt(res.data.FiscalYear)
          this.IsPlan = res.data.IsPlan
          this.itemCode = res.data.Item_Code

          // this.ChooseTypeDep = res.data.Approve
          this.ChooseTypRegis = res.data.Status_Reg
          this.ChooseTypRegis2 = res.data.Status_Type_Reg
          this.dateRegStart = res.data.DateS_Reg
          this.dateRegEnd = res.data.DateE_Reg
          this.ProjectQuotaCount = res.data.Count_Reg

          if (res.data.IsRoundStatus == '0') {
            this.roundNeed = false

            if (res.data.Status_Count_Reg == '0') {
              this.ChkJoinPerson = false
            } else {
              this.ChkJoinPerson = true
            }
          } else {
            this.roundNeed = true

            var CheckJoin = false
            this.getProjectRoundData({
              Project_code: this.Project_Choose
            }).then(res => {
              if (res) {
                if (this.ProjectRound.length > 0) {
                  this.ProjectRound.map(itemR => {
                    CheckJoin = false
                    this.ExecGroupExamProject(this.Project_Choose, itemR).then(resGroup => {
                      this.ExecQuotaDepartRegisterProject(this.Project_Choose, itemR).then(resQoutaDep => {
                        this.ExecJoinProject(this.Project_Choose, itemR).then(resJoin => {
                          if (itemR.Status_Count_Reg == '0') {
                            CheckJoin = false
                          } else {
                            CheckJoin = true
                          }

                          this.RoundData.push({
                            id: this.RoundData.length,
                            Ref_id: itemR.id,
                            round: itemR.Round,
                            round_name: itemR.Round_name,
                            dateRegS: itemR.DateS,
                            dateRegE: itemR.DateE,
                            time_start: itemR.TimeS,
                            time_end: itemR.TimeE,
                            WorkAgeData: resGroup,
                            ChooseTypRegis: itemR.Status_Reg,
                            ChooseTypRegis2: itemR.Status_Type_Reg,
                            dateRegStart: itemR.DateS_Reg,
                            dateRegEnd: itemR.DateE_Reg,
                            ChkJoinPerson: CheckJoin,
                            ProjectQuotaCount: itemR.Count_Reg,
                            DepQuotaData: resQoutaDep,
                            JoinPersonData: resJoin,
                            count_person: resJoin.length
                          })
                        })
                      })
                    })
                  })
                }
              }
            })
          }

          this.SelProjectGroup()
          this.getCourseType()
          if (res.data.IsRoundStatus == '0') {
            this.IsRoundStatus = '0'
            axios.get(ConstData.ConnectionHost + '/app-api/v2/?/apis/hrtrain/quata_dep_reg/Project_code/' + this.Project_Choose + '/?limit=9999').then(res => {
              if (res.data) {
                var type = ''
                if (res.data.length > 0) {
                  this.projectNeed = true
                  res.data.map((item_qua) => {
                    type = ''
                    if (item_qua.dep_type == '0') {
                      type = 'หน่วยงาน/ภาควิชา'
                    } else {
                      type = 'กลุ่มหน่วยงาน/กลุ่มภาควิชา'
                    }
                    this.DepQuotaData.push({
                      quotaType: item_qua.dep_type,
                      type: type,
                      type_id: item_qua.dep_type,
                      dep_name: this.depart.filter(item => item.dep_id == item_qua.dep_id)[0].dep_name,
                      dep_id: this.depart.filter(item => item.dep_id == item_qua.dep_id)[0].dep_id,
                      dep_group_id: this.depart.filter(item => item.dep_id == item_qua.dep_id)[0].dep_group_id,
                      count: item_qua.count
                    })
                  })
                } else {
                  this.projectNeed = true
                  type = ''
                  if (res.data.dep_type == '0') {
                    type = 'หน่วยงาน/ภาควิชา'
                  } else {
                    type = 'กลุ่มหน่วยงาน/กลุ่มภาควิชา'
                  }
                  this.DepQuotaData.push({
                    quotaType: res.data.dep_type,
                    type: type,
                    type_id: res.data.dep_type,
                    dep_name: this.depart.filter(item => item.dep_id == res.data.dep_id)[0].dep_name,
                    dep_id: this.depart.filter(item => item.dep_id == res.data.dep_id)[0].dep_id,
                    dep_group_id: this.depart.filter(item => item.dep_id == res.data.dep_id)[0].dep_group_id,
                    count: res.data.count
                  })
                }

                if (this.DepQuotaData.length > 0) {
                  this.DepQuotaData.map(item_dep_q => {
                    this.ProjectQuotaDepCount += parseInt(item_dep_q.count)
                  })
                }
              } else {
                this.projectNeed = false
                this.DepQuotaData = []
              }
            })
          }

          axios.get(ConstData.ConnectionHost + '/app-api/v2/?/apis/hrtrain/History_Experts/Project_code/' + this.Project_Choose + '/type/6/?limit=9999').then(res => {
            if (res.data) {
              if (res.data.length > 0) {
                this.projectNeed = true
                this.WorkGroupData = res.data
              } else {
                this.projectNeed = true
                this.WorkGroupData.push(res.data)
              }

              if (this.WorkGroupData.length > 0) {
                this.WorkGroupData.map(item_w => {
                  this.getLecturer(item_w).then(res => {
                    item_w.Lecturer = res[0]
                  })
                  this.getTrainFiles(item_w.Ref_id).then(res => {
                    item_w.files = res
                  })
                })
              }
            } else {
              this.projectNeed = false
              this.WorkGroupData = []
            }
          })

          axios.get(ConstData.ConnectionHost + '/app-api/v2/?/apis/hrtrain/TemplateProject/Project_code/' + this.Project_Choose).then(res => {
            if (res.data) {
              if (res.data.length > 0) {
                this.projectNeed = true
                this.TemplateProject = res.data
              } else {
                this.projectNeed = true
                this.TemplateProject.push(res.data)
              }
              if (this.TemplateProject.length > 0) {
                this.editorDataFormDB = this.TemplateProject[0].Template
                this.editorData = this.editorDataFormDB.replaceAll('&quot;', '"')
                this.editorData2 = this.TemplateProject[0].CoverSheet.replaceAll('&quot;', '"')
              }
            } else {
              this.projectNeed = false
              this.TemplateProject = []
            }
          })

          if (res.data.IsRoundStatus == '0') {
            axios.get(ConstData.ConnectionHost + '/app-api/v2/?/apis/hrtrain/C_person_level_view/Project_code/' + this.Project_Choose + '/?limit=9999').then(res => {
              if (res.data) {
                if (res.data.length > 0) {
                  this.projectNeed = true
                  this.DataCondi = res.data
                } else {
                  this.projectNeed = true
                  this.DataCondi.push(res.data)
                }
                if (this.DataCondi.length > 0) {
                  this.DataCondi.map(item => {
                    item.workAgeStart = item.WSYear
                    item.workAgeEnd = item.WEYear
                  })
                }
              } else {
                this.projectNeed = false
                this.DataCondi = []
              }
            })
          }

          axios.get(ConstData.ConnectionHost + '/app-api/v2/?/apis/hrtrain/D_project_committee/Project_code/' + this.Project_Choose + '/?limit=9999').then(res => {
            if (res.data) {
              if (res.data.length > 0) {
                this.Coordinator = res.data
              } else {
                this.Coordinator.push(res.data)
              }

              this.Committee_ToShow = this.Coordinator.filter(itemLecturer => itemLecturer.Committee_code != '6' && itemLecturer.Committee_code != '23' && itemLecturer.Committee_code != '24')
              this.LecturerToShow = this.Coordinator.filter(itemLecturer => itemLecturer.Committee_code == '6' || itemLecturer.Committee_code == '23' || itemLecturer.Committee_code == '24')
              if (this.Committee_ToShow.length > 0) {
                this.Committee_ToShow.map(item => {
                  item.Committee_des = this.committee_Posi.filter(commit_i => commit_i.Committee_code == item.Committee_code)[0].committee_des
                })
              }
              if (this.LecturerToShow.length > 0) {
                this.LecturerToShow.map(item => {
                  item.Committee_des = this.committee_Posi.filter(commit_i => commit_i.Committee_code == item.Committee_code)[0].committee_des
                })
              }
            } else {
              this.projectNeed = false
              this.Coordinator = []
            }
          })

          axios.get(ConstData.ConnectionHost + '/app-api/v2/?/apis/hrtrain/D_project_files/Type/0/Project_code/' + this.Project_Choose + '/?limit=9999').then(res => {
            if (res.data) {
              if (res.data.length > 0) {
                res.data.map((item) => {
                  switch (item.File_type) {
                    case 'image/jpg':
                    case 'image/jpeg':
                    case 'image/gif':
                    case 'image/bmp':
                    case 'image/png':
                      this.FileProject.push({
                        id: item.id,
                        name: item.File_name,
                        src: ConstData.ConnectionHost + '/rest/files' + item.File_path,
                        path: item.File_path,
                        type: 'image',
                        type_Img: item.File_type
                      })
                      break
                    case 'application/pdf':
                      this.FileProject.push({
                        id: item.id,
                        name: item.File_name,
                        src: ConstData.ConnectionHost + '/rest/files' + item.File_path,
                        path: item.File_path,
                        type: 'pdf',
                        type_Img: item.File_type
                      })
                      break
                    default:
                      break
                  }
                })
              } else {
                switch (res.data.File_type) {
                  case 'image/jpg':
                  case 'image/jpeg':
                  case 'image/gif':
                  case 'image/bmp':
                  case 'image/png':
                    this.FileProject.push({
                      id: res.data.id,
                      name: res.data.File_name,
                      src: ConstData.ConnectionHost + '/rest/files' + res.data.File_path,
                      path: res.data.File_path,
                      type: 'image',
                      type_Img: res.data.File_type
                    })
                    break
                  case 'application/pdf':
                    this.FileProject.push({
                      id: res.data.id,
                      name: res.data.File_name,
                      src: ConstData.ConnectionHost + '/rest/files' + res.data.File_path,
                      path: res.data.File_path,
                      type: 'pdf',
                      type_Img: res.data.File_type
                    })
                    break
                  default:
                    break
                }
              }
            } else {
              this.FileProject = []
            }
          })

          if (res.data.IsRoundStatus == '0') {
            axios.get(ConstData.ConnectionHost + '/app-api/v2/?/apis/hrtrain/join_project/Project_code/' + this.Project_Choose + '/active/1/?limit=9999').then(res => {
              if (res.data) {
                if (res.data.length > 0) {
                  res.data.map((item) => {
                    this.staffData.map(staff_i => {
                      if (staff_i.perid == item.uid) {
                        this.JoinPerson.push({
                          ...item,
                          ...staff_i,
                          full_Name: item.name + ' ' + item.sname,
                          idCard: item.id_card,
                          status_reg: item.join_status
                        })
                      }
                    })
                  })
                  if (this.JoinPerson.length > 0) {
                    this.JoinPerson.map((item, idx) => {
                      item.idx = (this.JoinPerson.length - (idx + 1)) + 1
                    })
                  }
                } else {
                  this.staffData.map(staff_i => {
                    if (staff_i.perid == res.data.uid) {
                      this.JoinPerson.push({
                        ...res.data,
                        ...staff_i,
                        idx: this.JoinPerson.length + 1,
                        full_Name: res.data.name + ' ' + res.data.sname,
                        idCard: res.data.id_card,
                        status_reg: res.data.join_status
                      })
                    }
                  })
                  if (this.JoinPerson.length > 0) {
                    this.JoinPerson.map((item, idx) => {
                      item.idx = (this.JoinPerson.length - (idx + 1)) + 1
                    })
                  }
                }
              } else {
                this.JoinPerson = []
              }
            })
          }
        }
      })
    },
    ExecQuotaDepartRegisterProject(Project_code, objItem) {
      var QuotaDepDump = []
      return new Promise(resolve => {
        this.getQuotaDepartRegisterByCordi({
          Project_code: Project_code,
          id: objItem.id
        }).then(resQuota => {
          if (resQuota) {
            if (this.QuotaDepartData.length > 0) {
              var type = ''
              this.QuotaDepartData.map((item_qua) => {
                type = ''
                if (item_qua.dep_type == '0') {
                  type = 'หน่วยงาน/ภาควิชา'
                } else {
                  type = 'กลุ่มหน่วยงาน/กลุ่มภาควิชา'
                }
                QuotaDepDump.push({
                  quotaType: item_qua.dep_type,
                  type: type,
                  type_id: item_qua.dep_type,
                  dep_name: this.depart.filter(item => item.dep_id == item_qua.dep_id)[0].dep_name,
                  dep_id: this.depart.filter(item => item.dep_id == item_qua.dep_id)[0].dep_id,
                  dep_group_id: this.depart.filter(item => item.dep_id == item_qua.dep_id)[0].dep_group_id,
                  count: item_qua.count
                })
              })
            }
            resolve(QuotaDepDump)
          }
        }).catch(reason => {
          if (reason) {
            resolve([])
          }
        })
      })
    },
    ExecJoinProject(Project_code, objItem) {
      var JoinPersonDump = []
      return new Promise(resolve => {
        this.getJoinProjectByCordi({
          Project_code: Project_code,
          id: objItem.id
        }).then(resJoin => {
          if (resJoin) {
            if (this.JoinProjectData.length > 0) {
              this.JoinProjectData.map((item) => {
                JoinPersonDump.push({
                  ...item,
                  full_Name: item.name + ' ' + item.sname,
                  idCard: item.id_card,
                  status_reg: item.join_status
                })
              })
            }
            resolve(JoinPersonDump)
          }
        }).catch(reason => {
          if (reason) {
            resolve([])
          }
        })
      })
    },
    ExecGroupExamProject(Project_code, objItem) {
      return new Promise(resolve => {
        this.getGroupExamProjectByCordi({
          Project_code: Project_code,
          id: objItem.id
        }).then(resGroup => {
          if (resGroup) {
            if (this.GroupExamData.length > 0) {
              resolve(this.GroupExamData)
            }
          }
        }).catch(reason => {
          if (reason) {
            resolve([])
          }
        })
      })
    },
    getCourseType() {
      this.courseData.map((item) => {
        if (item.Course_code == this.Course_code) {
          this.course_group = item.Course_type_des
          this.Period_code = item.Period_code
        }
      })
    },
    DeleteDataCondi(DataCor) {
      this.DataCondi.map((item, index) => {
        if (item.PosCode == DataCor.PosCode) {
          this.DataCondi.splice(index, 1)
        }
      })
      this.DataCondiDel.push({
        ...DataCor,
        Ref_id: this.RoundDataDump.Ref_id
      })
    },
    DeleteDepQuotaCondi(DataCor) {
      this.ProjectQuotaDepCount -= parseInt(DataCor.count)
      this.DepQuotaData.map((item, index) => {
        if (item.dep_id == DataCor.dep_id) {
          this.DepQuotaData.splice(index, 1)
        }
      })
      this.DepQuotaDataDel.push({
        ...DataCor,
        Ref_id: this.RoundDataDump.Ref_id
      })
    },
    DataCondiFunc() {
      var CheckDupe = false
      if (this.workAgeStart_Condi > this.workAgeEnd_Condi) {
        this.$swal.fire({
          icon: 'error',
          title: 'พบข้อผิดพลาด คุณกรอกอายุงานไม่ถูกต้อง'
        })
      } else if (this.workAgeStart_Condi == '' || this.workAgeEnd_Condi == '') {
        this.$swal.fire({
          icon: 'error',
          title: 'พบข้อผิดพลาด โปรดกรอกอายุงานให้ครบถ้วน'
        })
      } else {
        this.DataCondi.map((item) => {
          if (item.PosCode == this.posiCondi) {
            if (this.workAgeStart_Condi >= item.workAgeStart && this.workAgeStart_Condi <= item.workAgeEnd) {
              CheckDupe = true
            } else if (this.workAgeEnd_Condi >= item.workAgeStart && this.workAgeEnd_Condi <= item.workAgeEnd) {
              CheckDupe = true
            }
          }
        })
        if (CheckDupe) {
          this.$swal.fire({
            icon: 'error',
            title: 'พบข้อผิดพลาด อายุงานที่เลือก มีในระบบอยู่แล้ว โปรดตรวจสอบข้อมูลอายุงาน'
          })
        } else {
          this.positions.map((item) => {
            if (item.PosCode == this.posiCondi) {
              this.DataCondi.push({
                ...item,
                workAgeStart: this.workAgeStart_Condi,
                workAgeEnd: this.workAgeEnd_Condi,
              })
            }
          })
          this.posiCondi = ''
          this.levelCondi = ''
          this.workAgeStart_Condi = ''
          this.workAgeEnd_Condi = ''
          this.Course_Choose = ''
        }
      }

    },
    DeleteCourse(DataCourse) {
      this.courseCondi.map((item, index) => {
        if (item.Course_code == DataCourse.Course_code) {
          this.courseCondi.splice(index, 1)
        }
      })
    },
    CourseCondiFunc() {
      var CheckDupe = false
      this.courseCondi.map((item) => {
        if (item.Course_code == this.ChooseCourse) {
          CheckDupe = true
        }
      })
      if (CheckDupe) {
        this.$swal.fire({
          icon: 'error',
          title: 'มีข้อมูลหลักสูตรแล้ว ไม่สามารถเพิ่มข้อมูลได้อีก'
        })
      } else {
        this.courseData.map((item) => {
          if (item.Course_code == this.ChooseCourse) {
            this.courseCondi.push(item)
          }
        })
        this.ChooseCourse = ''
      }
    },
    dateFunctionEvents(date) {
      const [, , day] = date.split('-')
      if ([12, 17, 28].includes(parseInt(day, 10))) return true
      if ([1, 19, 22].includes(parseInt(day, 10))) return ['red', '#00f']
      return false
    },
    monthFunctionEvents(date) {
      const month = parseInt(date.split('-')[1], 10)
      if ([1, 3, 7].includes(month)) return true
      if ([2, 5, 12].includes(month)) return ['error', 'purple', 'rgba(0, 128, 0, 0.5)']
      return false
    },
    CheckJoinPerson() { //เช็คว่าถ้าโครงการมีการจัดเป็นรุ่นอยู่ แล้วต้องการกลับไปจัดแบบไม่มีรุ่น จะต้องลบผู้เข้าร่วมออกด้วย ไม่งั่นจะติดผู้เข้าร่วมจากรุ่น เข้าไปในโครงการหลักด้วย
      this.clearRoundData()
      if (this.IsRoundStatus == '1' && !this.roundNeed) {
        this.JoinPerson = []
      }
    },
    ChangeForm(idForm) {
      if (idForm == '1') {
        this.form1 = true
        this.form2 = false
      } else {
        this.form1 = false
        this.form2 = true
      }
    },
    clearRoundData() {
      this.posiCondi = null
      this.workAgeStart_Condi = ''
      this.workAgeEnd_Condi = ''
      this.DataCondi = []
      this.ChooseTypRegis = '1'
      this.ChooseTypRegis2 = '0'
      this.dateRegStart = ''
      this.dateRegEnd = ''
      this.ProjectQuotaCount = ''
      this.ProjectQuotaDepCount = 0
      this.ChkJoinPerson = true
      this.ChooseTypeDep = '0'
      this.DepQuotaSelect = ''
      this.DepQuotaCount = ''
      this.DepQuotaData = []
    },
    UpdateProject() {
      this.$swal.fire({
        title: 'ยืนยันการทำรายการ',
        text: "กรุณาตรวจสอบข้อมูลให้ถูกต้อง ก่อนทำการยืนยันแก้ไขข้อมูล",
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'ตกลง',
        cancelButtonText: 'ยกเลิก'
      }).then((result) => {
        if (result.value) {
          this.btnDisable = true
          this.CheckPermission().then(resPermiss => {
            if (resPermiss) {
              if (this.Project_code == '' || this.Project_name == '' || this.Project_group == '' || this.PLACE == ''
                  || this.WorkBy == '' || this.WorkByName == '' || this.Location == '' || this.DateStart == '' || this.DateEnd == '' || this.BudgetRequest == ''
                  || this.CalCredit == '' || this.CalHourse == '' || this.DepSelect == null) {
                this.$swal.fire({
                  icon: 'error',
                  title: 'พบข้อผิดพลาด',
                  text: 'โปรดกรอกข้อมูลให้ครบถ้วน',
                })
                this.btnDisable = false
              } else if (this.Project_group == '101' || this.Project_group == '102' || this.Project_group == '103' || this.Project_group == '104') {
                if (this.Course_code == '0000000' || this.Course_code == '') {
                  this.$swal.fire({
                    icon: 'error',
                    title: 'พบข้อผิดพลาด',
                    text: 'เลือกประเภทโครงการ : จัดบริหารวิชาการ,จัดพัฒนาบุคลากร เงื่อนไขหลักสูตรต้องห้ามว่าง',
                  })
                  this.btnDisable = false
                } else {
                  this.updateData()
                }
              } else if (this.PLACE == '2' && this.Province_id == '') {
                this.$swal.fire({
                  icon: 'error',
                  title: 'พบข้อผิดพลาด',
                  text: 'โปรดกรอกข้อมูลจังหวัด',
                })
                this.btnDisable = false
              } else if (this.PLACE == '3' && this.Country_id == '') {
                this.$swal.fire({
                  icon: 'error',
                  title: 'พบข้อผิดพลาด',
                  text: 'โปรดกรอกข้อมูลประเทศ',
                })
                this.btnDisable = false
              } else if (!this.ChkJoinPerson && (this.ProjectQuotaCount == '' || parseInt(this.ProjectQuotaCount) == 0)) {
                this.$swal.fire({
                  icon: 'error',
                  title: 'พบข้อผิดพลาด',
                  text: 'โปรดกรอกจำนวนผู้เข้าร่วมโครงการ',
                })
                this.btnDisable = false
              } else {
                this.updateData()
              }
            } else {
              this.btnDisable = length
              this.$swal.fire({
                icon: 'error',
                title: 'ขออภัย คุณไม่ได้รับสิทธิ์ในการจัดการข้อมูลส่วนนี้'
              })
            }
          })
        }
      })
    },
    updateData() {
      var Ref_id = this.getRandomFileName()
      var Project_code = this.Project_code
      var Project_group = this.Project_group
      var Project_name = this.Project_name
      var DateStart = this.DateStart
      var DateEnd = this.DateEnd

      this.D_Project.Project_code = this.Project_Choose

      this.D_Project.Project_name = this.Project_name
      this.courseData.map((item) => {
        if (item.Course_code == this.Course_code) {
          this.D_Project.Course_code = item.Course_code
          this.D_Project.course_group = item.Course_group
        }
      })
      this.D_Project.Project_group = this.Project_group
      this.D_Project.Project_type = this.Project_type
      this.D_Project.Remarks = this.Remarks
      this.D_Project.CalCredit = this.CalCredit
      this.D_Project.CalHourse = this.CalHourse
      this.D_Project.PLACE = this.PLACE
      this.D_Project.Province_id = this.Province_id
      this.D_Project.Country_id = this.Country_id
      this.D_Project.BudgetRequest = this.BudgetRequest
      this.D_Project.Location = this.Location
      this.D_Project.WorkBy = this.WorkBy
      this.D_Project.WorkByName = this.WorkByName
      this.D_Project.DateStart = this.DateStart
      this.D_Project.DateEnd = this.DateEnd
      this.D_Project.Approve = this.ApproveRadio
      this.D_Project.FiscalYear = this.FiscalYear
      this.D_Project.IsPlan = this.IsPlan

      this.D_Project.Status_Reg = this.ChooseTypRegis
      this.D_Project.Status_Type_Reg = this.ChooseTypRegis2
      this.D_Project.DateS_Reg = this.dateRegStart
      this.D_Project.DateE_Reg = this.dateRegEnd
      if (this.ChkJoinPerson) {
        this.D_Project.Status_Count_Reg = '1'
      } else {
        this.D_Project.Status_Count_Reg = '0'
      }
      this.D_Project.Count_Reg = this.ProjectQuotaCount
      this.D_Project.Dep_Code = this.DepSelect
      this.D_Project.Status = '0'
      this.D_Project.Update_By = this.MeData[0].perid

      if (this.roundNeed) {
        this.D_Project.IsRoundStatus = '1'
      } else {
        this.D_Project.IsRoundStatus = '0'
      }

      const headerAxios = {
        headers: {
          'Content-Type': 'application/json'
        }
      }
      axios.post(ConstData.ConnectionHost + '/app-api/v2/?/apis/hrtrain/D_project/Project_code/' + this.Project_Choose, this.D_Project, headerAxios).then(res => {
        if (res.data.status) {
          this.DataCourse.Project_code = this.Project_Choose

          if (!this.roundNeed) {
            axios.get(ConstData.ConnectionHost + '/app-api/v2/?/apis/hrtrain/D_project_need/Project_code/' + this.DataCourse.Project_code).then(res => {
              if (res.data) {
                const headerAxiosDel = {
                  headers: {
                    'Content-Type': 'application/json',
                    'X-REST-METHOD': 'DELETE'
                  }
                }
                axios.post(ConstData.ConnectionHost + '/app-api/v2/?/apis/hrtrain/D_project_need/Project_code/' + this.DataCourse.Project_code, '', headerAxiosDel).then(res => {
                  if (res.data.status) {
                    if (this.courseCondi.length > 0) {
                      const headerAxiosPUT = {
                        headers: {
                          'Content-Type': 'application/json',
                          'X-REST-METHOD': 'PUT'
                        }
                      }
                      var Count = 0
                      this.courseCondi.map((item) => {
                        axios.post(ConstData.ConnectionHost + '/app-api/v2/?/apis/hrtrain/D_project_need', {
                          Project_code: this.DataCourse.Project_code,
                          Course_code: item.Course_code,
                          Credit: item.General_credit
                        }, headerAxiosPUT).then(res => {
                          if (res.data.status) {
                            Count++
                            if (Count == this.courseCondi.length - 1) {
                              this.courseCondi = []
                              this.projectNeed = false
                            }
                          }
                        })
                      })
                    } else {
                      this.courseCondi = []
                      this.projectNeed = false
                    }
                  } else {
                    this.courseCondi = []
                    this.projectNeed = false
                  }
                })
              } else {
                this.courseCondi.map((item) => {
                  const headerAxiosPUT = {
                    headers: {
                      'Content-Type': 'application/json',
                      'X-REST-METHOD': 'PUT'
                    }
                  }
                  var Count = 0
                  axios.post(ConstData.ConnectionHost + '/app-api/v2/?/apis/hrtrain/D_project_need', {
                    Project_code: this.DataCourse.Project_code,
                    Course_code: item.Course_code,
                    Credit: item.General_credit
                  }, headerAxiosPUT).then(res => {
                    if (res.data.status) {
                      Count++
                      if (Count == this.courseCondi.length - 1) {
                        this.courseCondi = []
                        this.projectNeed = false
                      }
                    }
                  })
                })
              }
            })
          }

          axios.get(ConstData.ConnectionHost + '/app-api/v2/?/apis/hrtrain/C_person_level/Project_code/' + this.DataCourse.Project_code).then(res => {
            if (res.data) {
              const headerAxiosDel = {
                headers: {
                  'Content-Type': 'application/json',
                  'X-REST-METHOD': 'DELETE'
                }
              }
              axios.post(ConstData.ConnectionHost + '/app-api/v2/?/apis/hrtrain/C_person_level/Project_code/' + this.DataCourse.Project_code, '', headerAxiosDel).then(res => {
                if (res.data.status) {
                  if (this.DataCondi.length > 0) {
                    const headerAxiosPUT = {
                      headers: {
                        'Content-Type': 'application/json',
                        'X-REST-METHOD': 'PUT'
                      }
                    }
                    var Count = 0
                    this.DataCondi.map((item) => {
                      axios.post(ConstData.ConnectionHost + '/app-api/v2/?/apis/hrtrain/C_person_level', {
                        PosCode: item.PosCode,
                        Level: item.Level,
                        WSYear: item.WSYear,
                        WEYear: item.WEYear,
                        Project_code: this.DataCourse.Project_code
                      }, headerAxiosPUT).then(res => {
                        if (res.data.status) {
                          Count++
                          if (Count == this.DataCondi.length) {
                            this.DataCondi = []
                            this.projectNeed = false
                          }
                        }
                      })
                    })
                  } else {
                    this.DataCondi = []
                    this.projectNeed = false
                  }
                } else {
                  this.DataCondi = []
                  this.projectNeed = false
                }
              })
            } else {
              this.DataCondi.map((item) => {
                const headerAxiosPUT = {
                  headers: {
                    'Content-Type': 'application/json',
                    'X-REST-METHOD': 'PUT'
                  }
                }
                var Count = 0
                axios.post(ConstData.ConnectionHost + '/app-api/v2/?/apis/hrtrain/C_person_level', {
                  PosCode: item.PosCode,
                  Level: item.Level,
                  WSYear: item.WSYear,
                  WEYear: item.WEYear,
                  Project_code: this.DataCourse.Project_code
                }, headerAxiosPUT).then(res => {
                  if (res.data.status) {
                    Count++
                    if (Count == this.DataCondi.length) {
                      this.DataCondi = []
                      this.projectNeed = false
                    }
                  }
                })
              })
            }
          })

          axios.get(ConstData.ConnectionHost + '/app-api/v2/?/apis/hrtrain/D_project_committee/Project_code/' + this.DataCourse.Project_code).then(res => {
            if (res.data) {
              const headerAxiosDel = {
                headers: {
                  'Content-Type': 'application/json',
                  'X-REST-METHOD': 'DELETE'
                }
              }
              axios.post(ConstData.ConnectionHost + '/app-api/v2/?/apis/hrtrain/D_project_committee/Project_code/' + this.DataCourse.Project_code, '', headerAxiosDel).then(res => {
                if (res.data.status) {
                  if (this.Coordinator.length > 0) {
                    const headerAxiosPUT = {
                      headers: {
                        'Content-Type': 'application/json',
                        'X-REST-METHOD': 'PUT'
                      }
                    }
                    var CountCoordinator = 0
                    this.Coordinator.map((item) => {
                      item.Project_code = this.Project_code
                      item.Project_name = this.Project_name
                      item.date_start = this.DateStart
                      item.date_end = this.DateEnd
                      axios.post(ConstData.ConnectionHost + '/app-api/v2/?/apis/hrtrain/D_project_committee', {
                        Project_code: this.Project_code,
                        Committee_code: item.Committee_code,
                        Perid: item.Perid,
                        Name: item.Name,
                        Committee_type: item.Committee_type,
                        TEL: item.TEL,
                      }, headerAxiosPUT).then(res => {
                        if (res.data.status) {
                          if (item.Committee_code != '6' && item.Committee_code != '23' && item.Committee_code != '24') {
                            axios.post(ConstData.ConnectionHost + '/app-api/v2/?/apis/hrtrain/History_Experts', {
                              perid: item.Perid,
                              Project_code: this.Project_code,
                              type: item.Committee_code,
                              subject: item.Project_name,
                              date_start: item.date_start,
                              date_end: item.date_end,
                              date_travel_start: '',
                              date_travel_end: '',
                              time_start: '',
                              time_end: '',
                              Rm: item.Rm,
                              Ref_id: Ref_id,
                              create_by: this.MeData[0].perid,
                              create_time: 'now()',
                              update_by: this.MeData[0].perid
                            }, headerAxiosPUT)
                          }
                          CountCoordinator++
                          if (CountCoordinator == this.Coordinator.length) {
                            this.Coordinator = []
                            this.projectNeed = false
                          }
                        }
                      })
                    })
                  } else {
                    this.Coordinator = []
                    this.projectNeed = false
                  }
                } else {
                  this.Coordinator = []
                  this.projectNeed = false
                }
              })
            } else {
              const headerAxiosPUT = {
                headers: {
                  'Content-Type': 'application/json',
                  'X-REST-METHOD': 'PUT'
                }
              }
              var CountCoordinator = 0
              if (this.Coordinator.length > 0) {
                this.Coordinator.map((item) => {
                  item.Project_code = this.Project_code
                  item.Project_name = this.Project_name
                  item.date_start = this.DateStart
                  item.date_end = this.DateEnd
                  axios.post(ConstData.ConnectionHost + '/app-api/v2/?/apis/hrtrain/D_project_committee', {
                    Project_code: this.Project_code,
                    Committee_code: item.Committee_code,
                    Perid: item.Perid,
                    Name: item.Name,
                    Committee_type: item.Committee_type,
                    TEL: item.TEL,
                  }, headerAxiosPUT).then(res => {
                    if (res.data.status) {
                      if (item.Committee_code != '6' && item.Committee_code != '23' && item.Committee_code != '24') {
                        axios.post(ConstData.ConnectionHost + '/app-api/v2/?/apis/hrtrain/History_Experts', {
                          perid: item.Perid,
                          Project_code: this.Project_code,
                          type: item.Committee_code,
                          subject: item.Project_name,
                          date_start: item.date_start,
                          date_end: item.date_end,
                          date_travel_start: '',
                          date_travel_end: '',
                          time_start: '',
                          time_end: '',
                          Rm: item.Rm,
                          Ref_id: Ref_id,
                          create_by: this.MeData[0].perid,
                          create_time: 'now()',
                          update_by: this.MeData[0].perid
                        }, headerAxiosPUT)
                      }
                      CountCoordinator++
                      if (CountCoordinator == this.Coordinator.length) {
                        this.Coordinator = []
                        this.projectNeed = false
                      }
                    }
                  })
                })
              } else {
                this.Coordinator = []
                this.projectNeed = false
              }
            }
          })


          // ------------------------------- ประวัติการเป็นวิทยากร

          axios.get(ConstData.ConnectionHost + '/app-api/v2/?/apis/hrtrain/History_Experts/Project_code/' + this.DataCourse.Project_code).then(res => {
            if (res.data) {
              const headerAxiosDel = {
                headers: {
                  'Content-Type': 'application/json',
                  'X-REST-METHOD': 'DELETE'
                }
              }
              if (res.data.length > 0) {
                res.data.map(OldEx => {
                  if (OldEx.type == '6' || OldEx.type == '23' || OldEx.type == '24') {
                    axios.post(ConstData.ConnectionHost + '/app-api/v2/?/apis/hrtrain/Lecturer/Ref_id/' + OldEx.Ref_id, '', headerAxiosDel)
                  }
                })
              } else {
                if (res.data.type == '6' || res.data.type == '23' || res.data.type == '24') {
                  axios.post(ConstData.ConnectionHost + '/app-api/v2/?/apis/hrtrain/Lecturer/Ref_id/' + res.data.Ref_id, '', headerAxiosDel)
                }
              }

              axios.post(ConstData.ConnectionHost + '/app-api/v2/?/apis/hrtrain/History_Experts/Project_code/' + this.DataCourse.Project_code, '', headerAxiosDel).then(res => {
                if (res.data.status) {
                  if (this.WorkGroupData.length > 0) {
                    const headerAxiosPUT = {
                      headers: {
                        'Content-Type': 'application/json',
                        'X-REST-METHOD': 'PUT'
                      }
                    }
                    var CountLecturer = 0
                    this.WorkGroupData.map((item) => {
                      item.Project_code = this.Project_code
                      axios.post(ConstData.ConnectionHost + '/app-api/v2/?/apis/hrtrain/History_Experts', {
                        perid: item.perid,
                        Project_code: this.Project_code,
                        type: item.type,
                        subject: item.subject,
                        date_start: item.date_start,
                        date_end: item.date_end,
                        date_travel_start: item.date_travel_start,
                        date_travel_end: item.date_travel_end,
                        time_start: item.time_start,
                        time_end: item.time_end,
                        Rm: item.Rm,
                        Ref_id: Ref_id,
                        create_by: this.MeData[0].perid,
                        create_time: 'now()',
                        update_by: this.MeData[0].perid,
                      }, headerAxiosPUT).then(res => {
                        if (res.data.status) {
                          CountLecturer++
                          if (item.Lecturer != null) {
                            axios.post(ConstData.ConnectionHost + '/app-api/v2/?/apis/hrtrain/Lecturer', {
                              perid: item.perid,
                              Project_name: item.Lecturer.Project_name,
                              Hour: item.Lecturer.Hour,
                              Invite: item.Lecturer.Invite,
                              Place: item.Lecturer.Place,
                              DocNo: item.Lecturer.DocNo,
                              DateDocNo: item.Lecturer.DateDocNo,
                              DateStart: item.Lecturer.DateStart,
                              TimeStart: item.Lecturer.TimeStart,
                              DateEnd: item.Lecturer.DateEnd,
                              TimeEnd: item.Lecturer.TimeEnd,
                              Ref_id: Ref_id,
                            }, headerAxiosPUT)
                          }
                          if (item.files.length > 0) {
                            item.files.map(file => {
                              axios.post(ConstData.ConnectionHost + '/app-api/v2/?/apis/hrtrain/train_files', {
                                File_name: file.name,
                                File_path: file.path,
                                File_type: file.type,
                                Ref_id: Ref_id,
                                Create_By: this.MeData[0].perid,
                                Create_Time: 'now()',
                              }, headerAxiosPUT)
                            })
                          }
                          if (CountLecturer == this.WorkGroupData.length) {
                            this.WorkGroupData = []
                            this.projectNeed = false
                          }
                        }
                      })
                    })
                  } else {
                    this.WorkGroupData = []
                    this.projectNeed = false
                  }
                } else {
                  this.WorkGroupData = []
                  this.projectNeed = false
                }
              })
            } else {
              const headerAxiosPUT = {
                headers: {
                  'Content-Type': 'application/json',
                  'X-REST-METHOD': 'PUT'
                }
              }
              var CountLecturer = 0
              this.WorkGroupData.map((item) => {
                item.Project_code = this.Project_code
                axios.post(ConstData.ConnectionHost + '/app-api/v2/?/apis/hrtrain/History_Experts', {
                  perid: item.perid,
                  Project_code: this.Project_code,
                  type: item.type,
                  subject: item.subject,
                  date_start: item.date_start,
                  date_end: item.date_end,
                  date_travel_start: item.date_travel_start,
                  date_travel_end: item.date_travel_end,
                  time_start: item.time_start,
                  time_end: item.time_end,
                  Rm: item.Rm,
                  Ref_id: Ref_id,
                  create_by: this.MeData[0].perid,
                  create_time: 'now()',
                  update_by: this.MeData[0].perid,
                }, headerAxiosPUT).then(res => {
                  if (res.data.status) {
                    CountLecturer++
                    if (item.Lecturer != null) {
                      axios.post(ConstData.ConnectionHost + '/app-api/v2/?/apis/hrtrain/Lecturer', {
                        perid: item.perid,
                        Project_name: item.Lecturer.Project_name,
                        Hour: item.Lecturer.Hour,
                        Invite: item.Lecturer.Invite,
                        Place: item.Lecturer.Place,
                        DocNo: item.Lecturer.DocNo,
                        DateDocNo: item.Lecturer.DateDocNo,
                        DateStart: item.Lecturer.DateStart,
                        TimeStart: item.Lecturer.TimeStart,
                        DateEnd: item.Lecturer.DateEnd,
                        TimeEnd: item.Lecturer.TimeEnd,
                        Ref_id: Ref_id,
                      }, headerAxiosPUT)
                    }
                    if (item.files.length > 0) {
                      item.files.map(file => {
                        axios.post(ConstData.ConnectionHost + '/app-api/v2/?/apis/hrtrain/train_files', {
                          File_name: file.name,
                          File_path: file.path,
                          File_type: file.type,
                          Ref_id: Ref_id,
                          Create_By: this.MeData[0].perid,
                          Create_Time: 'now()',
                        }, headerAxiosPUT)
                      })
                    }
                    if (CountLecturer == this.WorkGroupData.length) {
                      this.WorkGroupData = []
                      this.projectNeed = false
                    }
                  }
                })
              })
            }
          })

          //--------------------------------

          /*
              * บันทึกข้อมูล template โครงการ สำหรับปริ้น
              * ----------------------------------------------------------------------------------------------------
              * */
          axios.get(ConstData.ConnectionHost + '/app-api/v2/?/apis/hrtrain/TemplateProject/Project_code/' + this.Project_code + '/?limit=1').then(resTemplate => {
            if (resTemplate.data) {
              axios.post(ConstData.ConnectionHost + '/app-api/v2/?/apis/hrtrain/TemplateProject/id/' + resTemplate.data.id, {
                Project_code: this.Project_code,
                Template: this.editorData,
                CoverSheet: this.editorData2,
                Update_By: this.MeData[0].perid
              }, {
                headers: {
                  'Content-Type': 'application/json'
                }
              })
            } else {
              axios.post(ConstData.ConnectionHost + '/app-api/v2/?/apis/hrtrain/TemplateProject/', {
                Project_code: this.Project_code,
                Template: this.editorData,
                CoverSheet: this.editorData2,
                Create_By: this.MeData[0].perid,
                Create_Time: 'now()',
              }, {
                headers: {
                  'Content-Type': 'application/json',
                  'X-REST-METHOD': 'PUT'
                }
              })
            }
          })

          /*
              * ----------------------------------------------------------------------------------------------------
              * */


          axios.get(ConstData.ConnectionHost + '/app-api/v2/?/apis/hrtrain/D_project_expense/Project_code/' + this.DataCourse.Project_code).then(res => {
            if (res.data) {
              const headerAxiosDel = {
                headers: {
                  'Content-Type': 'application/json',
                  'X-REST-METHOD': 'DELETE'
                }
              }
              axios.post(ConstData.ConnectionHost + '/app-api/v2/?/apis/hrtrain/D_project_expense/Project_code/' + this.DataCourse.Project_code, '', headerAxiosDel).then(res => {
                if (res.data.status) {
                  if (this.budgetData.length > 0) {
                    const headerAxiosPUT = {
                      headers: {
                        'Content-Type': 'application/json',
                        'X-REST-METHOD': 'PUT'
                      }
                    }

                    var countbudgetData = 0

                    if (this.budgetData.length > 0) {
                      this.budgetData.map((item_exp) => {
                        axios.post(ConstData.ConnectionHost + '/app-api/v2/?/apis/hrtrain/D_project_expense', {
                          Project_code: this.DataCourse.Project_code,
                          Expense_id: item_exp.Expense_id,
                          ReqMoney: item_exp.ReqMoney,
                          AppMoney: '',
                          Rm: item_exp.Rm,
                        }, headerAxiosPUT).then(res => {
                          if (res.data.status) {
                            countbudgetData++
                            if (countbudgetData == this.budgetData.length) {
                              this.budgetData = []
                            }
                          }
                        })
                      })
                    }
                  } else {
                    this.budgetData = []
                  }
                } else {
                  this.budgetData = []
                }
              })
            } else {
              if (this.budgetData.length > 0) {
                const headerAxiosPUT = {
                  headers: {
                    'Content-Type': 'application/json',
                    'X-REST-METHOD': 'PUT'
                  }
                }

                var countbudgetData = 0

                if (this.budgetData.length > 0) {
                  this.budgetData.map((item_exp) => {
                    axios.post(ConstData.ConnectionHost + '/app-api/v2/?/apis/hrtrain/D_project_expense', {
                      Project_code: this.DataCourse.Project_code,
                      Expense_id: item_exp.Expense_id,
                      ReqMoney: item_exp.ReqMoney,
                      AppMoney: '',
                      Rm: item_exp.Rm,
                    }, headerAxiosPUT).then(res => {
                      if (res.data.status) {
                        countbudgetData++
                        if (countbudgetData == this.budgetData.length) {
                          this.budgetData = []
                        }
                      }
                    })
                  })
                }
              }
            }
          })

          if (!this.roundNeed) {
            axios.get(ConstData.ConnectionHost + '/app-api/v2/?/apis/hrtrain/quata_dep_reg/Project_code/' + this.DataCourse.Project_code).then(res => {
              if (res.data) {
                const headerAxiosDel = {
                  headers: {
                    'Content-Type': 'application/json',
                    'X-REST-METHOD': 'DELETE'
                  }
                }
                axios.post(ConstData.ConnectionHost + '/app-api/v2/?/apis/hrtrain/quata_dep_reg/Project_code/' + this.DataCourse.Project_code, '', headerAxiosDel).then(res => {
                  if (res.data.status) {
                    if (this.DepQuotaData.length > 0) {
                      const headerAxiosPUT = {
                        headers: {
                          'Content-Type': 'application/json',
                          'X-REST-METHOD': 'PUT'
                        }
                      }

                      var countDepQuota = 0

                      if (this.DepQuotaData.length > 0) {
                        this.DepQuotaData.map((item_dep_q) => {
                          axios.post(ConstData.ConnectionHost + '/app-api/v2/?/apis/hrtrain/quata_dep_reg', {
                            Project_code: this.Project_code,
                            dep_type: item_dep_q.type_id,
                            dep_id: item_dep_q.dep_id,
                            dep_group_id: item_dep_q.dep_group_id,
                            count: item_dep_q.count,
                            create_by: this.MeData[0].perid,
                            create_time: 'now()',
                          }, headerAxiosPUT).then(res => {
                            if (res.data.status) {
                              countDepQuota++
                              if (countDepQuota == this.DepQuotaData.length) {
                                this.DepQuotaData = []
                              }
                            }
                          })
                        })
                      }
                    } else {
                      this.DepQuotaData = []
                    }
                  } else {
                    this.DepQuotaData = []
                  }
                })
              } else {
                if (this.DepQuotaData.length > 0) {
                  const headerAxiosPUT = {
                    headers: {
                      'Content-Type': 'application/json',
                      'X-REST-METHOD': 'PUT'
                    }
                  }

                  var countDepQuota = 0

                  if (this.DepQuotaData.length > 0) {
                    this.DepQuotaData.map((item_dep_q) => {
                      axios.post(ConstData.ConnectionHost + '/app-api/v2/?/apis/hrtrain/quata_dep_reg', {
                        Project_code: this.Project_code,
                        dep_type: item_dep_q.type_id,
                        dep_id: item_dep_q.dep_id,
                        dep_group_id: item_dep_q.dep_group_id,
                        count: item_dep_q.count,
                        create_by: this.MeData[0].perid,
                        create_time: 'now()',
                      }, headerAxiosPUT).then(res => {
                        if (res.data.status) {
                          countDepQuota++
                          if (countDepQuota == this.DepQuotaData.length) {
                            this.DepQuotaData = []
                          }
                        }
                      })
                    })
                  }
                }
              }
            })
          }


          axios.get(ConstData.ConnectionHost + '/app-api/v2/?/apis/hrtrain/D_project_files/Type/0/Project_code/' + this.DataCourse.Project_code).then(res => {
            if (res.data) {
              const headerAxiosDel = {
                headers: {
                  'Content-Type': 'application/json',
                  'X-REST-METHOD': 'DELETE'
                }
              }
              axios.post(ConstData.ConnectionHost + '/app-api/v2/?/apis/hrtrain/D_project_files/Project_code/' + this.DataCourse.Project_code, '', headerAxiosDel).then(res => {
                if (res.data.status) {
                  if (this.FileProject.length > 0) {
                    const headerAxiosPUT = {
                      headers: {
                        'Content-Type': 'application/json',
                        'X-REST-METHOD': 'PUT'
                      }
                    }

                    var Count = 0

                    if (this.FileProject.length > 0) {
                      this.FileProject.map((item) => {
                        axios.post(ConstData.ConnectionHost + '/app-api/v2/?/apis/hrtrain/D_project_files', {
                          Project_code: this.DataCourse.Project_code,
                          File_name: item.name,
                          File_path: item.path,
                          File_type: item.type_Img,
                          Type: '0'
                        }, headerAxiosPUT).then(res => {
                          if (res.data.status) {
                            Count++
                            if (Count == this.FileProject.length) {
                              this.FileProject = []
                              this.files = []
                            }
                          }
                        })
                      })
                    }
                  } else {
                    this.FileProject = []
                    this.files = []
                  }
                } else {
                  this.FileProject = []
                  this.files = []
                }
              })
            } else {
              if (this.FileProject.length > 0) {
                const headerAxiosPUT = {
                  headers: {
                    'Content-Type': 'application/json',
                    'X-REST-METHOD': 'PUT'
                  }
                }

                var Count = 0

                if (this.FileProject.length > 0) {
                  this.FileProject.map((item) => {
                    axios.post(ConstData.ConnectionHost + '/app-api/v2/?/apis/hrtrain/D_project_files', {
                      Project_code: this.DataCourse.Project_code,
                      File_name: item.name,
                      File_path: item.path,
                      File_type: item.type_Img,
                      Type: '0'
                    }, headerAxiosPUT).then(res => {
                      if (res.data.status) {
                        Count++
                        if (Count == this.FileProject.length) {
                          this.FileProject = []
                          this.files = []
                        }
                      }
                    })
                  })
                }
              }
            }
          })

          if (!this.roundNeed) {
            axios.get(ConstData.ConnectionHost + '/app-api/v2/?/apis/hrtrain/join_project/Project_code/' + this.DataCourse.Project_code + '/active/1').then(res => {
              if (res.data) {
                const headerAxiosDel = {
                  headers: {
                    'Content-Type': 'application/json',
                    'X-REST-METHOD': 'DELETE'
                  }
                }
                // if (res.data.length > 0) {
                //   res.data.map(OldEx => {
                //     if ((OldEx.uid != '' | OldEx.perid != null) && (OldEx.Project_code != '' | OldEx.Project_code != null)) {
                //       axios.post(ConstData.ConnectionHost + '/app-api/v2/?/apis/hrtrain/History_Experts/perid/' + OldEx.uid + '/Project_code/' + OldEx.Project_code, headerAxiosDel)
                //     }
                //   })
                // } else {
                //   if ((res.data.uid != '' | res.data.perid != null) && (res.data.Project_code != '' | res.data.Project_code != null)) {
                //     axios.post(ConstData.ConnectionHost + '/app-api/v2/?/apis/hrtrain/History_Experts/perid/' + res.data.uid + '/Project_code/' + res.data.Project_code, headerAxiosDel)
                //   }
                // }

                axios.post(ConstData.ConnectionHost + '/app-api/v2/?/apis/hrtrain/join_project/Project_code/' + this.DataCourse.Project_code, '', headerAxiosDel).then(res => {
                  if (res.data.status) {
                    if (this.JoinPerson.length > 0) {
                      var CountJoin = 0
                      const headerAxiosPUT = {
                        headers: {
                          'Content-Type': 'application/json',
                          'X-REST-METHOD': 'PUT'
                        }
                      }
                      this.JoinPerson.map((item) => {
                        const RegObj = {
                          Project_code: this.DataCourse.Project_code,
                          uid: item.uid,
                          name: item.name.split(' ')[0],
                          sname: item.sname,
                          id_card: item.idCard,
                          affiliation: item.affiliation,
                          position: item.position,
                          join_status: item.status_reg,
                          phone: '',
                          registerType_id: item.registerType_id,
                          Create_By: this.MeData[0].perid,
                          Create_Time: 'now()',
                        }
                        axios.post(ConstData.ConnectionHost + '/app-api/v2/?/apis/hrtrain/join_project', RegObj, headerAxiosPUT).then(res => {
                          if (res.data.status) {
                            if (item.status_reg == '1') {
                              axios.post(ConstData.ConnectionHost + '/app-api/v2/?/apis/hrtrain/History_Experts', {
                                perid: item.uid,
                                Project_code: Project_code,
                                type: (Project_group == '106' || Project_group == '107' || Project_group == '109') ? '18' : '17',
                                subject: Project_name,
                                date_start: DateStart,
                                date_end: DateEnd,
                                date_travel_start: '',
                                date_travel_end: '',
                                time_start: '',
                                time_end: '',
                                Rm: '',
                                Ref_id: Ref_id,
                                active: '0',
                                create_by: this.MeData[0].perid,
                                create_time: 'now()',
                                update_by: this.MeData[0].perid,
                              }, headerAxiosPUT)
                            }
                            CountJoin++
                            if (CountJoin == this.JoinPerson.length) {
                              this.JoinPerson = []
                            }
                          }
                        })
                      })
                    } else {
                      this.JoinPerson = []
                    }
                  } else {
                    this.JoinPerson = []
                  }
                })
              } else {
                var CountJoin = 0
                const headerAxiosPUT = {
                  headers: {
                    'Content-Type': 'application/json',
                    'X-REST-METHOD': 'PUT'
                  }
                }
                this.JoinPerson.map((item) => {
                  const RegObj2 = {
                    Project_code: this.DataCourse.Project_code,
                    uid: item.uid,
                    name: item.name.split(' ')[0],
                    sname: item.sname,
                    id_card: item.idCard,
                    affiliation: item.affiliation,
                    position: item.position,
                    join_status: item.status_reg,
                    phone: '',
                    registerType_id: item.registerType_id,
                    Create_By: this.MeData[0].perid,
                    Create_Time: 'now()',
                  }
                  axios.post(ConstData.ConnectionHost + '/app-api/v2/?/apis/hrtrain/join_project', RegObj2, headerAxiosPUT).then(res => {
                    if (res.data.status) {
                      if (item.status_reg == '1') {
                        axios.post(ConstData.ConnectionHost + '/app-api/v2/?/apis/hrtrain/History_Experts', {
                          perid: item.uid,
                          Project_code: Project_code,
                          type: (Project_group == '106' || Project_group == '107' || Project_group == '109') ? '18' : '17',
                          subject: Project_name,
                          date_start: DateStart,
                          date_end: DateEnd,
                          date_travel_start: '',
                          date_travel_end: '',
                          time_start: '',
                          time_end: '',
                          Rm: '',
                          Ref_id: Ref_id,
                          active: '0',
                          create_by: this.MeData[0].perid,
                          create_time: 'now()',
                          update_by: this.MeData[0].perid,
                        }, headerAxiosPUT)
                      }
                      CountJoin++
                      if (CountJoin == this.JoinPerson.length) {
                        this.JoinPerson = []
                      }
                    }
                  })
                })
              }
            })

            // ลบข้อมูลรอบโครงการออก
            axios.post(ConstData.ConnectionHost + '/app-api/v2/?/apis/hrtrain/D_project_round/Project_code/' + this.DataCourse.Project_code, {
              active: '0'
            }, {
              headers: {
                'Content-Type': 'application/json',
                // 'X-REST-METHOD': 'DELETE'
              }
            })
          }

          if (this.roundNeed) {
            var Status_Count_Dump = ''
            if (this.RoundData.length > 0) {
              this.RoundData.map((Round_i, idx_Round) => {
                Status_Count_Dump = ''
                if (Round_i.ChkJoinPerson) {
                  Status_Count_Dump = '1'
                } else {
                  Status_Count_Dump = '0'
                }

                axios.get(ConstData.ConnectionHost + '/app-api/v2/?/apis/hrtrain/D_project_round/id/' + Round_i.Ref_id + '/active/1').then(res => {
                  if (res.data) {
                    const headerAxiosDel = {
                      headers: {
                        'Content-Type': 'application/json',
                        'X-REST-METHOD': 'DELETE'
                      }
                    }
                    axios.post(ConstData.ConnectionHost + '/app-api/v2/?/apis/hrtrain/D_project_round/id/' + Round_i.Ref_id, '', headerAxiosDel).then(res => {
                      if (res.data.status) {
                        axios.post(ConstData.ConnectionHost + '/app-api/v2/?/apis/hrtrain/D_project_round', {
                          id: Round_i.Ref_id,
                          Round: Round_i.round,
                          Round_name: Round_i.round_name,
                          DateS: Round_i.dateRegS,
                          DateE: Round_i.dateRegE,
                          TimeS: Round_i.time_start,
                          TimeE: Round_i.time_end,
                          Project_code: this.DataCourse.Project_code,
                          Status_Reg: Round_i.ChooseTypRegis,
                          Status_Type_Reg: Round_i.ChooseTypRegis2,
                          DateS_Reg: Round_i.dateRegStart,
                          DateE_Reg: Round_i.dateRegEnd,
                          Status_Count_Reg: Status_Count_Dump,
                          Count_Reg: Round_i.ProjectQuotaCount,
                          Create_By: this.MeData[0].perid,
                          Create_Time: 'now()',
                        }, {
                          headers: {
                            'Content-Type': 'application/json',
                            'X-REST-METHOD': 'PUT'
                          }
                        })
                      }
                    })
                  } else {
                    axios.post(ConstData.ConnectionHost + '/app-api/v2/?/apis/hrtrain/D_project_round', {
                      id: Round_i.Ref_id,
                      Round: Round_i.round,
                      Round_name: Round_i.round_name,
                      DateS: Round_i.dateRegS,
                      DateE: Round_i.dateRegE,
                      TimeS: Round_i.time_start,
                      TimeE: Round_i.time_end,
                      Project_code: this.DataCourse.Project_code,
                      Status_Reg: Round_i.ChooseTypRegis,
                      Status_Type_Reg: Round_i.ChooseTypRegis2,
                      DateS_Reg: Round_i.dateRegStart,
                      DateE_Reg: Round_i.dateRegEnd,
                      Status_Count_Reg: Status_Count_Dump,
                      Count_Reg: Round_i.ProjectQuotaCount,
                      Create_By: this.MeData[0].perid,
                      Create_Time: 'now()',
                    }, {
                      headers: {
                        'Content-Type': 'application/json',
                        'X-REST-METHOD': 'PUT'
                      }
                    })
                  }
                })


                axios.get(ConstData.ConnectionHost + '/app-api/v2/?/apis/hrtrain/C_person_level/D_project_round_id/' + Round_i.Ref_id).then(res => {
                  if (res.data) {
                    const headerAxiosDel = {
                      headers: {
                        'Content-Type': 'application/json',
                        'X-REST-METHOD': 'DELETE'
                      }
                    }
                    axios.post(ConstData.ConnectionHost + '/app-api/v2/?/apis/hrtrain/C_person_level/D_project_round_id/' + Round_i.Ref_id, '', headerAxiosDel).then(res => {
                      if (res.data.status) {
                        if (Round_i.WorkAgeData.length > 0) {
                          var countDataCondi = 0
                          Round_i.WorkAgeData.map((item) => {
                            const DataObj = {
                              PosCode: item.PosCode,
                              Level: item.Level,
                              WSYear: item.workAgeStart,
                              WEYear: item.workAgeEnd,
                              Project_code: this.DataCourse.Project_code,
                              D_project_round_id: Round_i.Ref_id
                            }
                            axios.post(ConstData.ConnectionHost + '/app-api/v2/?/apis/hrtrain/C_person_level', DataObj, {
                              headers: {
                                'Content-Type': 'application/json',
                                'X-REST-METHOD': 'PUT'
                              }
                            }).then(res => {
                              if (res.data.status) {
                                countDataCondi++
                                if (countDataCondi == Round_i.WorkAgeData.length) {
                                  Round_i.WorkAgeData = []
                                }
                              }
                            })
                          })
                        }
                      }
                    })
                  } else {
                    if (Round_i.WorkAgeData.length > 0) {
                      var countDataCondi = 0
                      Round_i.WorkAgeData.map((item) => {
                        const DataObj = {
                          PosCode: item.PosCode,
                          Level: item.Level,
                          WSYear: item.workAgeStart,
                          WEYear: item.workAgeEnd,
                          Project_code: this.DataCourse.Project_code,
                          D_project_round_id: Round_i.Ref_id
                        }
                        axios.post(ConstData.ConnectionHost + '/app-api/v2/?/apis/hrtrain/C_person_level', DataObj, {
                          headers: {
                            'Content-Type': 'application/json',
                            'X-REST-METHOD': 'PUT'
                          }
                        }).then(res => {
                          if (res.data.status) {
                            countDataCondi++
                            if (countDataCondi == Round_i.WorkAgeData.length) {
                              Round_i.WorkAgeData = []
                            }
                          }
                        })
                      })
                    }
                  }
                })


                axios.get(ConstData.ConnectionHost + '/app-api/v2/?/apis/hrtrain/quata_dep_reg/D_project_round_id/' + Round_i.Ref_id).then(res => {
                  if (res.data) {
                    const headerAxiosDel = {
                      headers: {
                        'Content-Type': 'application/json',
                        'X-REST-METHOD': 'DELETE'
                      }
                    }
                    axios.post(ConstData.ConnectionHost + '/app-api/v2/?/apis/hrtrain/quata_dep_reg/D_project_round_id/' + Round_i.Ref_id, '', headerAxiosDel).then(res => {
                      if (res.data.status) {
                        if (Round_i.DepQuotaData.length > 0) {
                          var countDepQuota = 0
                          Round_i.DepQuotaData.map((item_dep_q) => {
                            axios.post(ConstData.ConnectionHost + '/app-api/v2/?/apis/hrtrain/quata_dep_reg', {
                              Project_code: this.DataCourse.Project_code,
                              dep_type: item_dep_q.type_id,
                              dep_id: item_dep_q.dep_id,
                              dep_group_id: item_dep_q.dep_group_id,
                              count: item_dep_q.count,
                              D_project_round_id: Round_i.Ref_id,
                              create_by: this.MeData[0].perid,
                              create_time: 'now()',
                            }, {
                              headers: {
                                'Content-Type': 'application/json',
                                'X-REST-METHOD': 'PUT'
                              }
                            }).then(res => {
                              if (res.data.status) {
                                countDepQuota++
                                if (countDepQuota == Round_i.DepQuotaData.length) {
                                  Round_i.DepQuotaData = []
                                }
                              }
                            })
                          })
                        }
                      }
                    })
                  } else {
                    if (Round_i.DepQuotaData.length > 0) {
                      var countDepQuota = 0
                      Round_i.DepQuotaData.map((item_dep_q) => {
                        axios.post(ConstData.ConnectionHost + '/app-api/v2/?/apis/hrtrain/quata_dep_reg', {
                          Project_code: this.DataCourse.Project_code,
                          dep_type: item_dep_q.type_id,
                          dep_id: item_dep_q.dep_id,
                          dep_group_id: item_dep_q.dep_group_id,
                          count: item_dep_q.count,
                          D_project_round_id: Round_i.Ref_id,
                          create_by: this.MeData[0].perid,
                          create_time: 'now()',
                        }, {
                          headers: {
                            'Content-Type': 'application/json',
                            'X-REST-METHOD': 'PUT'
                          }
                        }).then(res => {
                          if (res.data.status) {
                            countDepQuota++
                            if (countDepQuota == Round_i.DepQuotaData.length) {
                              Round_i.DepQuotaData = []
                            }
                          }
                        })
                      })
                    }
                  }
                })


                axios.get(ConstData.ConnectionHost + '/app-api/v2/?/apis/hrtrain/join_project/D_project_round_id/' + Round_i.Ref_id + '/active/1').then(res => {
                  if (res.data) {
                    const headerAxiosDel = {
                      headers: {
                        'Content-Type': 'application/json',
                        'X-REST-METHOD': 'DELETE'
                      }
                    }
                    axios.post(ConstData.ConnectionHost + '/app-api/v2/?/apis/hrtrain/join_project/D_project_round_id/' + Round_i.Ref_id, '', headerAxiosDel).then(res => {
                      if (res.data.status) {
                        if (Round_i.JoinPersonData.length > 0) {
                          var CountJoin = 0
                          Round_i.JoinPersonData.map((item) => {
                            const RegObj = {
                              Project_code: this.DataCourse.Project_code,
                              uid: item.uid,
                              name: item.name.split(' ')[0],
                              sname: item.sname,
                              id_card: item.idCard,
                              affiliation: item.affiliation,
                              position: item.position,
                              join_status: item.status_reg,
                              phone: '',
                              registerType_id: item.registerType_id,
                              D_project_round_id: Round_i.Ref_id,
                              Create_By: this.MeData[0].perid,
                              Create_Time: 'now()',
                            }
                            axios.post(ConstData.ConnectionHost + '/app-api/v2/?/apis/hrtrain/join_project', RegObj, {
                              headers: {
                                'Content-Type': 'application/json',
                                'X-REST-METHOD': 'PUT'
                              }
                            }).then(res => {
                              if (res.data.status) {
                                if (item.status_reg == '1') {
                                  axios.post(ConstData.ConnectionHost + '/app-api/v2/?/apis/hrtrain/History_Experts', {
                                    perid: item.uid,
                                    Project_code: Project_code,
                                    type: (Project_group == '106' || Project_group == '107' || Project_group == '109') ? '18' : '17',
                                    subject: Project_name,
                                    date_start: DateStart,
                                    date_end: DateEnd,
                                    date_travel_start: '',
                                    date_travel_end: '',
                                    time_start: '',
                                    time_end: '',
                                    Rm: '',
                                    Ref_id: Ref_id,
                                    active: '0',
                                    create_by: this.MeData[0].perid,
                                    create_time: 'now()',
                                    update_by: this.MeData[0].perid,
                                  }, {
                                    headers: {
                                      'Content-Type': 'application/json',
                                      'X-REST-METHOD': 'PUT'
                                    }
                                  })
                                }
                                CountJoin++
                                if (CountJoin == Round_i.JoinPersonData.length) {
                                  Round_i.JoinPersonData = []
                                  this.JoinPerson = []
                                }
                              }
                            })
                          })
                        }
                      }
                    })
                  } else {
                    if (Round_i.JoinPersonData.length > 0) {
                      var CountJoin = 0
                      Round_i.JoinPersonData.map((item) => {
                        const RegObj = {
                          Project_code: this.DataCourse.Project_code,
                          uid: item.uid,
                          name: item.name.split(' ')[0],
                          sname: item.sname,
                          id_card: item.idCard,
                          affiliation: item.affiliation,
                          position: item.position,
                          join_status: item.status_reg,
                          phone: '',
                          registerType_id: item.registerType_id,
                          D_project_round_id: Round_i.Ref_id,
                          Create_By: this.MeData[0].perid,
                          Create_Time: 'now()',
                        }
                        axios.post(ConstData.ConnectionHost + '/app-api/v2/?/apis/hrtrain/join_project', RegObj, {
                          headers: {
                            'Content-Type': 'application/json',
                            'X-REST-METHOD': 'PUT'
                          }
                        }).then(res => {
                          if (res.data) {
                            if (item.status_reg == '1') {
                              axios.post(ConstData.ConnectionHost + '/app-api/v2/?/apis/hrtrain/History_Experts', {
                                perid: item.uid,
                                Project_code: Project_code,
                                type: (Project_group == '106' || Project_group == '107' || Project_group == '109') ? '18' : '17',
                                subject: Project_name,
                                date_start: DateStart,
                                date_end: DateEnd,
                                date_travel_start: '',
                                date_travel_end: '',
                                time_start: '',
                                time_end: '',
                                Rm: '',
                                Ref_id: Ref_id,
                                active: '0',
                                create_by: this.MeData[0].perid,
                                create_time: 'now()',
                                update_by: this.MeData[0].perid,
                              }, {
                                headers: {
                                  'Content-Type': 'application/json',
                                  'X-REST-METHOD': 'PUT'
                                }
                              })
                            }
                            CountJoin++
                            if (CountJoin == Round_i.JoinPersonData.length) {
                              Round_i.JoinPersonData = []
                              this.JoinPerson = []
                            }
                          }
                        })
                      })
                    }
                  }
                })

                if (idx_Round == this.RoundData.length - 1) {
                  this.RoundData = []
                }
              })
            }

            if (this.RoundDataDel.length > 0) {
              this.RoundDataDel.map((itemDel, idxDel) => {
                axios.post(ConstData.ConnectionHost + '/app-api/v2/?/apis/hrtrain/D_project_round/id/' + itemDel.Ref_id, {
                  active: '0'
                }, {
                  headers: {
                    'Content-Type': 'application/json',
                    // 'X-REST-METHOD': 'DELETE'
                  }
                })
                if (idxDel == this.RoundDataDel.length - 1) {
                  this.RoundDataDel = []
                }
              })
            }

            if (this.DataCondiDel.length > 0) {
              this.DataCondiDel.map((itemDel, idxDel) => {
                axios.post(ConstData.ConnectionHost + '/app-api/v2/?/apis/hrtrain/C_person_level/D_project_round_id/' + itemDel.Ref_id, {
                  active: '0'
                }, {
                  headers: {
                    'Content-Type': 'application/json',
                    // 'X-REST-METHOD': 'DELETE'
                  }
                })
                if (idxDel == this.DataCondiDel.length - 1) {
                  this.DataCondiDel = []
                }
              })
            }

            if (this.DepQuotaDataDel.length > 0) {
              this.DepQuotaDataDel.map((itemDel, idxDel) => {
                axios.post(ConstData.ConnectionHost + '/app-api/v2/?/apis/hrtrain/quata_dep_reg/D_project_round_id/' + itemDel.Ref_id, {
                  active: '0'
                }, {
                  headers: {
                    'Content-Type': 'application/json',
                    // 'X-REST-METHOD': 'DELETE'
                  }
                })
                if (idxDel == this.DepQuotaDataDel.length - 1) {
                  this.DepQuotaDataDel = []
                }
              })
            }

            if (this.JoinPersonDel.length > 0) {
              this.JoinPersonDel.map((itemDel, idxDel) => {
                axios.post(ConstData.ConnectionHost + '/app-api/v2/?/apis/hrtrain/join_project/D_project_round_id/' + itemDel.Ref_id, {
                  active: '0'
                }, {
                  headers: {
                    'Content-Type': 'application/json',
                    // 'X-REST-METHOD': 'DELETE'
                  }
                })
                if (idxDel == this.JoinPersonDel.length - 1) {
                  this.JoinPersonDel = []
                }
              })
            }
          }


          // เช็คว่าถ้าโครงการมีการจัดเป็นรุ่นอยู่ แล้วต้องการกลับไปจัดแบบไม่มีรุ่น จะต้องลบผู้เข้าร่วมออกด้วย ไม่งั่นจะติดผู้เข้าร่วมจากรุ่น เข้าไปในโครงการหลักด้วย
          // if (this.IsRoundStatus == '1' && !this.roundNeed) {
          //   axios.post(ConstData.ConnectionHost + '/app-api/v2/?/apis/hrtrain/join_project/Project_code/' + this.DataCourse.Project_code, {
          //     active: '0'
          //   }, {
          //     headers: {
          //       'Content-Type': 'application/json',
          //       // 'X-REST-METHOD': 'DELETE'
          //     }
          //   })
          // }

          this.AddCompetency().then(res => {
            if (res) {
              this.init()
              this.initProjectData({
                perid: this.MeData[0].perid
              })

              this.$swal.fire({
                icon: 'success',
                title: 'แก้ไขข้อมูลสำเร็จ'
              })

              this.btnDisable = false

              this.e1 = '1'

              this.Project_code = ''
              this.Project_name = ''
              this.Course_code = '0000000'
              this.course_group = ''
              this.Project_type = ''
              this.Remarks = ''
              this.WorkBy = ''
              this.Location = ''
              this.DateStart = ''
              this.DateEnd = ''
              this.CalHourse = ''
              this.CalCredit = ''
              this.PLACE = ''
              this.Province_id = ''
              this.BudgetRequest = ''
              this.ChooseTypeDep = '0'
              this.ChooseTypRegis = '1'
              this.ChooseTypRegis2 = '0'
              this.dateRegStart = ''
              this.dateRegEnd = ''
              this.ProjectQuotaCount = ''
              this.ProjectQuotaDepCount = 0
              this.MessageSuc = ''
              this.MessageError = ''
              this.ChkJoinPerson = true
              this.ShowAlertErr = false
              this.ShowAlertSuc = false
              this.Project_Choose = ''
              this.Project_group = ''
              this.DepSelect = null
              this.Period_code = ''
              this.editorData = ''
              this.editorData2 = ''
              this.FiscalYear = ''
              this.IsPlan = ''
              this.ProjectPlan = ''
              this.WorkByName = ''
              this.roundNeed = false
              this.ApproveRadio = '0'

            } else {
              this.$swal.fire({
                icon: 'error',
                title: 'พบข้อผิดพลาด',
                text: 'ไม่สามารถบันทึกข้อมูลได้',
              })
              this.Project_code = ''
              this.Project_name = ''
              this.Course_code = '0000000'
              this.course_group = ''
              this.Project_type = ''
              this.Remarks = ''
              this.WorkBy = ''
              this.Location = ''
              this.DateStart = ''
              this.DateEnd = ''
              this.CalHourse = ''
              this.CalCredit = ''
              this.PLACE = ''
              this.Province_id = ''
              this.BudgetRequest = ''
              this.ChooseTypeDep = '0'
              this.ChooseTypRegis = '1'
              this.ChooseTypRegis2 = '0'
              this.dateRegStart = ''
              this.dateRegEnd = ''
              this.ProjectQuotaCount = ''
              this.ProjectQuotaDepCount = 0
              this.MessageSuc = ''
              this.MessageError = ''
              this.ChkJoinPerson = true
              this.ShowAlertErr = false
              this.ShowAlertSuc = false
              this.Project_group = ''
              this.DepSelect = null
              this.Period_code = ''
              this.editorData = ''
              this.editorData2 = ''
              this.FiscalYear = ''
              this.IsPlan = ''
              this.ProjectPlan = ''
              this.WorkByName = ''
              this.roundNeed = false
              this.ApproveRadio = '0'
            }
          })

        } else {
          this.$swal.fire({
            icon: 'error',
            title: 'พบข้อผิดพลาด',
            text: 'ไม่สามารถบันทึกข้อมูลได้',
          })
          this.Project_code = ''
          this.Project_name = ''
          this.Course_code = '0000000'
          this.course_group = ''
          this.Project_type = ''
          this.Remarks = ''
          this.WorkBy = ''
          this.Location = ''
          this.DateStart = ''
          this.DateEnd = ''
          this.CalHourse = ''
          this.CalCredit = ''
          this.PLACE = ''
          this.Province_id = ''
          this.BudgetRequest = ''
          this.ChooseTypeDep = '0'
          this.ChooseTypRegis = '1'
          this.ChooseTypRegis2 = '0'
          this.dateRegStart = ''
          this.dateRegEnd = ''
          this.ProjectQuotaCount = ''
          this.ProjectQuotaDepCount = 0
          this.MessageSuc = ''
          this.MessageError = ''
          this.ChkJoinPerson = true
          this.ShowAlertErr = false
          this.ShowAlertSuc = false
          this.Project_group = ''
          this.DepSelect = null
          this.Period_code = ''
          this.editorData = ''
          this.editorData2 = ''
          this.FiscalYear = ''
          this.IsPlan = ''
          this.ProjectPlan = ''
          this.WorkByName = ''
          this.roundNeed = false
          this.ApproveRadio = '0'
        }
      });
    },
    getRandomFileName() {
      var timestamp = new Date().toISOString().replace(/[-:.]/g, "");
      var random = ("" + Math.random()).substring(2, 8);
      var random_number = timestamp + random;
      return random_number;
    },
    AddCompetency() {
      const headerAxiosPUT = {
        headers: {
          'Content-Type': 'application/json',
          'X-REST-METHOD': 'PUT'
        }
      }
      const headerAxiosDel = {
        headers: {
          'Content-Type': 'application/json',
          'X-REST-METHOD': 'DELETE'
        }
      }
      return new Promise(resolve => {
        axios.get(ConstData.ConnectionHost + '/app-api/v2/?/apis/hrtrain/D_project_competency/Project_code/' + this.DataCourse.Project_code).then(res => {
          if (res.data) {
            axios.post(ConstData.ConnectionHost + '/app-api/v2/?/apis/hrtrain/D_project_competency/Project_code/' + this.DataCourse.Project_code, '', headerAxiosDel).then(res => {
              if (res.data.status) {
                if (this.selection.length > 0) {
                  for (var i = 0; i <= this.selection.length - 1; i++) {
                    this.CompetencyData.map(root => {
                      if (root.children.length > 0) {
                        root.children.map(child1 => {
                          if (child1.children.length > 0) {
                            child1.children.map(child2 => {
                              if (child2.id == this.selection[i]) {
                                axios.post(ConstData.ConnectionHost + '/app-api/v2/?/apis/hrtrain/D_project_competency/', {
                                  Project_code: this.DataCourse.Project_code,
                                  DelvNo: child2.DelvNo,
                                  create_by: this.MeData[0].perid,
                                }, headerAxiosPUT)
                              }
                            })
                          }
                          if (child1.id == this.selection[i]) {
                            axios.post(ConstData.ConnectionHost + '/app-api/v2/?/apis/hrtrain/D_project_competency/', {
                              Project_code: this.DataCourse.Project_code,
                              DelvNo: child1.DelvNo,
                              create_by: this.MeData[0].perid,
                            }, headerAxiosPUT)
                          }
                        })
                      }
                      if (root.id == this.selection[i]) {
                        axios.post(ConstData.ConnectionHost + '/app-api/v2/?/apis/hrtrain/D_project_competency/', {
                          Project_code: this.DataCourse.Project_code,
                          DelvNo: root.DelvNo,
                          create_by: this.MeData[0].perid,
                        }, headerAxiosPUT)
                      }
                    })
                  }
                  this.selection = []
                  resolve(true)
                } else {
                  resolve(true)
                }
              } else {
                resolve(false)
              }
            })
          } else {
            if (this.selection.length > 0) {
              for (var i = 0; i <= this.selection.length - 1; i++) {
                this.CompetencyData.map(root => {
                  if (root.children.length > 0) {
                    root.children.map(child1 => {
                      if (child1.children.length > 0) {
                        child1.children.map(child2 => {
                          if (child2.id == this.selection[i]) {
                            axios.post(ConstData.ConnectionHost + '/app-api/v2/?/apis/hrtrain/D_project_competency/', {
                              Project_code: this.DataCourse.Project_code,
                              DelvNo: child2.DelvNo,
                              create_by: this.MeData[0].perid,
                            }, headerAxiosPUT)
                          }
                        })
                      }
                      if (child1.id == this.selection[i]) {
                        axios.post(ConstData.ConnectionHost + '/app-api/v2/?/apis/hrtrain/D_project_competency/', {
                          Project_code: this.DataCourse.Project_code,
                          DelvNo: child1.DelvNo,
                          create_by: this.MeData[0].perid,
                        }, headerAxiosPUT)
                      }
                    })
                  }
                  if (root.id == this.selection[i]) {
                    axios.post(ConstData.ConnectionHost + '/app-api/v2/?/apis/hrtrain/D_project_competency/', {
                      Project_code: this.DataCourse.Project_code,
                      DelvNo: root.DelvNo,
                      create_by: this.MeData[0].perid,
                    }, headerAxiosPUT)
                  }
                })
              }
              this.selection = []
              resolve(true)
            } else {
              resolve(true)
            }
          }
        })
      })

    },
    CheckPermission() {
      return new Promise(resolve => {
        var CheckPermiss = false
        if (this.PermissionAdmin.length > 0) {
          this.PermissionAdmin.map((Per_i, idx) => {
            if (Per_i.permission_id == '9001') {
              resolve(true)
            } else {
              if (!CheckPermiss && idx == this.PermissionAdmin.length - 1) {
                resolve(false)
              }
            }
          })
        } else {
          this.Permission.map((Per_i, idx) => {
            if (Per_i.permission_id == '9001') {
              resolve(true)
            } else {
              if (!CheckPermiss && idx == this.Permission.length - 1) {
                resolve(false)
              }
            }
          })
        }
      })
    },
    GetOldData(item) {
      var objIem = JSON.parse(JSON.stringify(item))
      this.SubjectForLecturer = objIem.subject
      this.dateSForLecturer = objIem.date_start
      this.dateEForLecturer = objIem.date_end
      this.dateSTravelForLecturer = objIem.date_travel_start
      this.dateETravelForLecturer = objIem.date_travel_end
      this.timeSForLecturer = objIem.time_start
      this.timeEForLecturer = objIem.time_end
      this.FileProjectExpert = objIem.files
      this.Rm = objIem.Rm
      this.LecturerProjectName = objIem.Lecturer.Project_name
      this.LecturerHour = objIem.Lecturer.Hour
      this.LecturerInvite = objIem.Lecturer.Invite
      this.LecturerPlace = objIem.Lecturer.Place
      this.LecturerDocNo = objIem.Lecturer.DocNo
      this.LecturerDateDocOut = objIem.Lecturer.DateDocNo
      this.LecturerDateStart = objIem.Lecturer.DateStart
      this.LecturerTimeStart = objIem.Lecturer.TimeStart
      this.LecturerDateEnd = objIem.Lecturer.DateEnd
      this.LecturerTimeEnd = objIem.Lecturer.TimeEnd
    },
    init: function () {
      this.CompetencyData = []
      this.itemsSel = []
      this.FiscalYearData = []
      this.Project_plan = []

      for (var i = (new Date().getFullYear() - 1); i <= (new Date().getFullYear() + 1); i++) {
        this.FiscalYearData.push({
          year: i,
          yearth: i + 543
        })
      }

      this.initCountryData()

      if (this.projectData.length == 0) {
        this.initProjectData({
          perid: this.MeData[0].perid
        }).then(res => {
          if (res) {
            this.projectData.map(item => {
              if (item.Status == '0' || item.Status == '4') {
                this.ProjectData_U.push({
                  ...item
                })
              }
            })
          }
        })
      } else {
        this.projectData.map(item => {
          if (item.Status == '0' || item.Status == '4') {
            this.ProjectData_U.push({
              ...item
            })
          }
        })
      }

      if (this.courseData.length == 0) {
        this.initCourseData()
      }

      this.initDepartData().then(res => {
        if (res) {
          if (this.depart.length > 0) {
            this.groupDepart = this.UniqueArraybyId(this.depart, 'dep_group_name')
          }
        }
      })

      if (this.positions.length == 0) {
        this.initPositionsData()
      }

      this.initStaffData().then(res => {
        if (res) {
          if (this.staffData.length > 0) {
            this.staffData.map(item => {
              item.customDetail = item.full_Name + ' รหัส (' + item.perid + ')' + ' ' + item.dep_name + ' (' + item.dep_group_name + ')'
            })
          }
        }
      })


      if (this.committee_Posi.length == 0) {
        this.initComitteeType()
      }

      if (this.provinces_Data.length == 0) {
        this.initProvincesData()
      }

      if (this.expense_Data.length == 0) {
        this.initExpenseData()
      }

      if (this.projectGroup.length == 0) {
        this.initProjectGroupData()
      }

      if (this.levelData.length == 0) {
        this.initlevelData()
      }

      if (this.CardData.length == 0) {
        this.initCardData()
      }

      this.initCompetencyData().then(res => {
        if (res) {
          this.Competency.map(compe_i => {
            if (compe_i.DelvCover == null || compe_i.DelvCover == '') {
              if (compe_i.DelvEng == null || compe_i.DelvEng == '') {
                this.CompetencyData.push({
                  ...compe_i,
                  id: compe_i.DelvNo,
                  name: compe_i.DelvDes,
                  DelvLevel: '0',
                  children: []
                })
              } else {
                this.CompetencyData.push({
                  ...compe_i,
                  id: compe_i.DelvNo,
                  name: compe_i.DelvDes + '( ' + compe_i.DelvEng + ' )',
                  DelvLevel: '0',
                  children: []
                })
              }
            }
          })
          this.CompetencyData.map((data_i, idx) => {
            if (data_i.children.length == 0) {
              this.Competency.map(compe_i => {
                if (data_i.DelvNo == compe_i.DelvCover) {
                  if (compe_i.DelvEng == null || compe_i.DelvEng == '') {
                    this.CompetencyData[idx].children.push({
                      ...compe_i,
                      id: compe_i.DelvNo,
                      name: compe_i.DelvDes,
                      DelvLevel: '1',
                      children: []
                    })
                  } else {
                    this.CompetencyData[idx].children.push({
                      ...compe_i,
                      id: compe_i.DelvNo,
                      name: compe_i.DelvDes + '( ' + compe_i.DelvEng + ' )',
                      DelvLevel: '1',
                      children: []
                    })
                  }
                }
              })
            }
          })
          // lv2
          this.CompetencyData.map(data_i => {
            if (data_i.children.length > 0) {
              data_i.children.map((child1_i, idx) => {
                if (child1_i.children.length == 0) {
                  this.Competency.map(compe_i => {
                    if (child1_i.DelvNo == compe_i.DelvCover) {
                      if (compe_i.DelvEng == null || compe_i.DelvEng == '') {
                        data_i.children[idx].children.push({
                          ...compe_i,
                          id: compe_i.DelvNo,
                          name: compe_i.DelvDes,
                          DelvLevel: '2',
                          children: []
                        })
                      } else {
                        data_i.children[idx].children.push({
                          ...compe_i,
                          id: compe_i.DelvNo,
                          name: compe_i.DelvDes + '( ' + compe_i.DelvEng + ' )',
                          DelvLevel: '2',
                          children: []
                        })
                      }

                    }
                  })
                }
              })
            }
          })

          // item to autocomplete
          this.CompetencyData.map(itemRoot => {
            this.itemsSel.push({
              ...itemRoot
            })
            if (itemRoot.children.length > 0) {
              itemRoot.children.map(itemChild1 => {
                this.itemsSel.push({
                  ...itemChild1
                })
                if (itemChild1.children.length > 0) {
                  itemChild1.children.map(itemChild2 => {
                    this.itemsSel.push({
                      ...itemChild2
                    })
                  })
                }
              })
            }
          })
        }
      })

      this.initGroup_Quota()

      this.initGroup_Quota_Ms()

      this.initAppointment()

      axios.get(ConstData.ConnectionHost + '/app-api/v2/?/apis/stdMed/STUDENT/FAC_ID/09/STUDY_STATUS/OK/?limit=99999').then(res => {
        if (res.data) {
          if (res.data.length > 0) {
            res.data.map(item => {
              this.studentData.push({
                ...item,
                fullName: 'รหัสนักศึกษา : ' + item.STUDENT_ID + ' ชื่อ-สกุล ' + item.STUD_NAME_THAI + ' ' + item.STUD_SNAME_THAI
              })
            })
          } else {
            this.studentData.push({
              ...res.data,
              fullName: 'รหัสนักศึกษา : ' + res.data[0].STUDENT_ID + ' ชื่อ-สกุล ' + res.data[0].STUD_NAME_THAI + ' ' + res.data[0].STUD_SNAME_THAI
            })
          }
        } else {
          this.studentData = []
        }
      })

      axios.get(ConstData.ConnectionHost + '/rest/v1/AllPersonal/dss_person.W_FACULTY/1').then(res => {
        if (res.data) {
          if (res.data.length > 0) {
            this.AllDepartData = res.data
          } else {
            this.AllDepartData.push(res.data)
          }
        } else {
          this.AllDepartData = []
        }
      })
    }
  },
  mounted() {
    this.initMeData().then(res => {
      if (res) {
        this.getPermissionData({
          perid: this.MeData[0].perid
        }).then(resAdmin => {
          if (resAdmin) {
            this.PermissionAdmin.map((Per_i, idx) => {
              if (Per_i.permission_id == '9000') {
                this.CheckAdmin = true
                this.init()
              } else {
                if (!this.CheckAdmin && idx == this.PermissionAdmin.length - 1) {
                  this.$router.push('/')
                }
              }
            })
          } else {
            this.getPermissionUserData({
              perid: this.MeData[0].perid
            }).then(resUser => {
              if (resUser) {
                this.Permission.map((Per_i, idx) => {
                  if (Per_i.permission_id == '9000') {
                    this.CheckSubAdmin = true
                    this.init()
                  } else {
                    if (!this.CheckSubAdmin && idx == this.Permission.length - 1) {
                      this.$router.push('/')
                    }
                  }
                })
              } else {
                this.CheckSubAdmin = false
                this.CheckAdmin = false
                this.$router.push('/')
              }
            })
          }
        })
      }
    }).catch(reason => {
      console.log('Reject = ' + reason)
    })
  }
}
</script>

<style scoped>
@font-face {
  font-family: "THSarabunNew";
  src: url('../../lib/font/THSarabunNew.ttf');
}

@font-face {
  font-family: "THSarabunNew";
  font-weight: bold;
  src: url('../../lib/font/THSarabunNew Bold.ttf');
}

.pdf-content {
  width: 100%;
  background: #fff;
}

strong {
  font-family: "THSarabunNew";
  font-weight: bold;
  color: black;
}

p {
  font-family: "THSarabunNew";
  font-size: 22px;
  color: black;
}

ul {
  font-family: "THSarabunNew";
  font-size: 22px;
  color: black;
}

ol {
  font-family: "THSarabunNew";
  font-size: 22px;
  color: black;
}

i {
  font-family: "THSarabunNew";
  font-size: 22px;
  color: black;
}

s {
  font-family: "THSarabunNew";
  font-size: 22px;
  color: black;
}


@media print {
  .no-print {
    display: none !important;
  }
}

@media screen {
  .no-screen {
    display: none !important;
  }
}

.v-label {
  color: black;
}

.v-card {
  border: 1px solid;
}

.v-text-field >>> input {
  color: black;
}

.v-text-field >>> label {
  color: black;
  font-weight: bold;
}

.v-text-field >>> button {
  font-size: 0.1em;
}

.ck-content {
  height: 500px;
}

.ck-editor__editable {
  min-height: 500px;
}

textarea {
  font-family: THSarabunNew;
  font-size: 24px;
}
</style>
